export const fileSVG = (
  <svg
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M5 19.9115H15V18.5612H5V19.9115ZM5 14.5103H15V13.16H5V14.5103ZM2.30768 24.6376C1.65018 24.6376 1.10119 24.4294 0.660714 24.0131C0.220238 23.5967 0 23.0778 0 22.4563V2.51329C0 1.89181 0.220238 1.37289 0.660714 0.956549C1.10119 0.540204 1.65018 0.332031 2.30768 0.332031H13.5714L20 6.40842V22.4563C20 23.0778 19.7798 23.5967 19.3393 24.0131C18.8988 24.4294 18.3498 24.6376 17.6923 24.6376H2.30768ZM12.8571 7.08357V1.68234H2.30768C2.08792 1.68234 1.88645 1.7689 1.70329 1.942C1.52014 2.11514 1.42857 2.30556 1.42857 2.51329V22.4563C1.42857 22.6641 1.52014 22.8545 1.70329 23.0276C1.88645 23.2007 2.08792 23.2873 2.30768 23.2873H17.6923C17.9121 23.2873 18.1135 23.2007 18.2967 23.0276C18.4799 22.8545 18.5714 22.6641 18.5714 22.4563V7.08357H12.8571Z"
      fill="#F37032"
    />
  </svg>
);

export const logoutSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="logout_FILL0_wght300_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H12.0096V4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19H12.0096V20.5H5.3077ZM16.2308 16.2692L15.1923 15.1846L17.6269 12.75H9.09613V11.25H17.6269L15.1923 8.81538L16.2308 7.7308L20.5 12L16.2308 16.2692Z"
        fill="#FF0000"
      />
    </g>
  </svg>
);

export const profileAvatarSVG = (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="avatar 1" clip-path="url(#clip0_1267_77935)">
      <g id="Layer 2">
        <g id="&#226;&#128;&#148;&#195;&#142;&#195;&#147;&#195;&#136; 1">
          <path
            id="Vector"
            d="M18.75 36.75C28.8292 36.75 37 28.5792 37 18.5C37 8.4208 28.8292 0.25 18.75 0.25C8.6708 0.25 0.5 8.4208 0.5 18.5C0.5 28.5792 8.6708 36.75 18.75 36.75Z"
            fill="#58B0E0"
          />
          <path
            id="Vector_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.2319 23.0938L23.6268 23.1652V30.7948L14.2319 30.7233V23.0938Z"
            fill="#F9DCA4"
          />
          <path
            id="Vector_3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.47 35.042C24.082 36.1542 21.4818 36.7374 18.8475 36.7517C16.2131 36.766 13.6068 36.211 11.2068 35.1247V28.8477H26.4695L26.47 35.042Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.2291 36.6893C19.7417 36.7283 19.2489 36.748 18.7508 36.7484C18.3748 36.7484 18.0017 36.7371 17.6316 36.7147L18.2399 31.4062H19.6633L20.2291 36.6893Z"
            fill="#E9573E"
          />
          <path
            id="Vector_5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.6526 36.4728C13.6404 36.0981 11.6972 35.4185 9.88997 34.4576C8.15413 33.4917 6.58687 32.25 5.24951 30.7811L6.00786 28.9502L14.2322 25.2812C14.2322 28.3595 15.2427 33.2433 15.6526 36.4728Z"
            fill="#677079"
          />
          <path
            id="Vector_6"
            opacity="0.11"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6305 23.1421V25.0503C20.8358 28.3147 15.496 27.8528 14.2988 23.0352L23.6305 23.1421Z"
            fill="black"
          />
          <path
            id="Vector_7"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.887 5.23047C31.4559 5.23047 26.5573 26.0591 18.887 26.0591C11.6419 26.0591 6.31812 5.23047 18.887 5.23047Z"
            fill="#FFE8BE"
          />
          <path
            id="Vector_8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3458 14.4498C9.53258 15.2406 11.0741 18.9893 12.2152 18.9727C11.7418 17.506 11.4499 15.9875 11.3458 14.4498ZM26.5689 14.4492C28.3821 15.2401 26.8405 18.9893 25.7001 18.9721C26.173 17.5056 26.4648 15.9866 26.5689 14.4492Z"
            fill="#F9DCA4"
          />
          <path
            id="Vector_9"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4494 8.71261C11.4803 10.755 12.1731 16.4083 12.1731 16.4083L11.553 16.116C7.68209 1.11789 30.2365 1.1173 26.3437 16.116L25.7236 16.4083C25.7236 16.4083 26.417 10.755 24.4479 8.71261C22.0151 11.0721 15.8686 11.0597 13.4494 8.71261Z"
            fill="#464449"
          />
          <path
            id="Vector_10"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.2163 36.4208C26.2073 35.6501 29.8261 33.5675 32.4977 30.5041L31.854 28.9502L23.6302 25.2812C23.6302 28.3595 22.6262 33.1914 22.2163 36.4208Z"
            fill="#677079"
          />
          <path
            id="Vector_11"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6273 25.043L18.946 28.8613L22.8282 32.3536C22.8282 32.3536 23.8629 26.6223 23.6273 25.043Z"
            fill="white"
          />
          <path
            id="Vector_12"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.2318 25.043L18.9502 28.8613L15.0256 32.3536C15.0256 32.3536 13.9944 26.6223 14.2318 25.043Z"
            fill="white"
          />
          <path
            id="Vector_13"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.1016 30.5042L18.9543 28.8398L20.8071 30.5042L18.9543 32.168L17.1016 30.5042Z"
            fill="#E9573E"
          />
          <path
            id="Vector_14"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.7185 36.496C14.9643 36.3698 14.2189 36.1963 13.4866 35.9763C13.4636 35.9586 13.4412 35.9403 13.4192 35.9214L11.3314 32.1473L14.0134 30.2219H11.2068L11.8074 26.1756L14.2349 24.6406C14.34 28.9935 15.2738 33.8873 15.7185 36.496ZM22.1432 36.4328C22.4905 36.375 22.8342 36.2946 23.175 36.206C23.5775 36.0995 23.978 35.9855 24.3763 35.8641L24.4555 35.8387L26.5291 32.109L23.8471 30.1942H26.6537L26.0531 26.168L23.6256 24.6406C23.5205 28.971 22.5873 33.8371 22.1432 36.4328Z"
            fill="#434955"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1267_77935">
        <rect
          width="36.5"
          height="36.5"
          fill="white"
          transform="translate(0.5 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const partnerNameSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 11.3828C11.175 11.3828 10.4688 11.0891 9.88125 10.5016C9.29375 9.91409 9 9.20784 9 8.38284C9 7.55782 9.29375 6.85156 9.88125 6.26406C10.4688 5.67656 11.175 5.38281 12 5.38281C12.825 5.38281 13.5312 5.67656 14.1188 6.26406C14.7063 6.85156 15 7.55782 15 8.38284C15 9.20784 14.7063 9.91409 14.1188 10.5016C13.5312 11.0891 12.825 11.3828 12 11.3828ZM5 18.6136V16.9674C5 16.5546 5.12019 16.1684 5.36058 15.8088C5.60096 15.4492 5.92436 15.17 6.33078 14.9713C7.27436 14.5187 8.21858 14.1793 9.16345 13.953C10.1083 13.7267 11.0539 13.6136 12 13.6136C12.9462 13.6136 13.8917 13.7267 14.8365 13.953C15.7814 14.1793 16.7256 14.5187 17.6692 14.9713C18.0756 15.17 18.399 15.4492 18.6394 15.8088C18.8798 16.1684 19 16.5546 19 16.9674V18.6136H5ZM6 17.6136H18V16.9674C18 16.7457 17.9285 16.5373 17.7856 16.3424C17.6426 16.1476 17.4449 15.9828 17.1923 15.8482C16.3692 15.4495 15.5206 15.144 14.6464 14.9319C13.7722 14.7197 12.8901 14.6136 12 14.6136C11.1099 14.6136 10.2278 14.7197 9.3536 14.9319C8.4794 15.144 7.63077 15.4495 6.8077 15.8482C6.55513 15.9828 6.35737 16.1476 6.21442 16.3424C6.07147 16.5373 6 16.7457 6 16.9674V17.6136ZM12 10.3828C12.55 10.3828 13.0208 10.187 13.4125 9.79534C13.8042 9.40367 14 8.93284 14 8.38284C14 7.83284 13.8042 7.36201 13.4125 6.97034C13.0208 6.57867 12.55 6.38284 12 6.38284C11.45 6.38284 10.9792 6.57867 10.5875 6.97034C10.1958 7.36201 10 7.83284 10 8.38284C10 8.93284 10.1958 9.40367 10.5875 9.79534C10.9792 10.187 11.45 10.3828 12 10.3828Z"
      fill="black"
    />
  </svg>
);

export const partnerCallSVG = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="call_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M14.9843 15.8327C13.6496 15.8327 12.2814 15.4985 10.8798 14.8302C9.47811 14.1618 8.17591 13.2237 6.97319 12.0159C5.77046 10.8081 4.83493 9.50594 4.16659 8.10936C3.49824 6.71278 3.16406 5.34716 3.16406 4.01249C3.16406 3.77063 3.24323 3.56909 3.40156 3.40787C3.5599 3.24663 3.75781 3.16602 3.99531 3.16602H5.95316C6.16834 3.16602 6.35611 3.23376 6.51647 3.36926C6.67684 3.50475 6.78544 3.67856 6.84226 3.89069L7.23505 5.77852C7.2716 5.99977 7.265 6.19312 7.21526 6.35857C7.16553 6.524 7.07774 6.6595 6.95189 6.76505L5.21478 8.38492C5.53957 8.97462 5.89862 9.52245 6.29192 10.0284C6.6852 10.5344 7.10463 11.0137 7.55019 11.4663C8.00998 11.9261 8.50477 12.3537 9.03457 12.749C9.56438 13.1443 10.1459 13.5176 10.7793 13.8687L12.4722 12.1453C12.6011 12.0063 12.746 11.9147 12.9069 11.8705C13.0678 11.8264 13.2456 11.8175 13.4405 11.8439L15.1061 12.1849C15.3212 12.2377 15.4958 12.346 15.6298 12.51C15.7637 12.6739 15.8307 12.8619 15.8307 13.074V15.0014C15.8307 15.2389 15.7501 15.4368 15.5889 15.5952C15.4277 15.7535 15.2261 15.8327 14.9843 15.8327ZM4.84331 7.64198L6.36269 6.24437C6.41344 6.20377 6.44642 6.14795 6.46165 6.07692C6.47688 6.00586 6.47434 5.93989 6.45405 5.879L6.10235 4.20128C6.08206 4.12008 6.04654 4.05918 5.99579 4.01858C5.94505 3.97798 5.87908 3.95768 5.79788 3.95768H4.17344C4.11255 3.95768 4.0618 3.97798 4.0212 4.01858C3.9806 4.05918 3.9603 4.10993 3.9603 4.17082C3.97553 4.71179 4.06028 5.27662 4.21454 5.8653C4.36881 6.45397 4.5784 7.0462 4.84331 7.64198ZM11.5329 14.2402C12.0678 14.5051 12.6379 14.701 13.2433 14.8279C13.8488 14.9547 14.3763 15.0227 14.8259 15.0319C14.8868 15.0319 14.9376 15.0116 14.9782 14.971C15.0188 14.9304 15.0391 14.8796 15.0391 14.8187V13.2293C15.0391 13.1481 15.0188 13.0822 14.9782 13.0314C14.9376 12.9806 14.8767 12.9451 14.7955 12.9248L13.3309 12.6249C13.27 12.6046 13.2167 12.6021 13.171 12.6173C13.1254 12.6325 13.0772 12.6655 13.0264 12.7163L11.5329 14.2402Z"
        fill="black"
      />
    </g>
  </svg>
);

export const partnerMailSVG = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="mail_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M3.97716 14.25C3.63197 14.25 3.34375 14.1344 3.1125 13.9031C2.88125 13.6719 2.76562 13.3837 2.76562 13.0385V4.96153C2.76562 4.61634 2.88125 4.32812 3.1125 4.09688C3.34375 3.86563 3.63197 3.75 3.97716 3.75H15.0541C15.3993 3.75 15.6875 3.86563 15.9188 4.09688C16.15 4.32812 16.2656 4.61634 16.2656 4.96153V13.0385C16.2656 13.3837 16.15 13.6719 15.9188 13.9031C15.6875 14.1344 15.3993 14.25 15.0541 14.25H3.97716ZM9.51563 9.08655L3.51562 5.16347V13.0385C3.51562 13.1731 3.55889 13.2837 3.64543 13.3702C3.73197 13.4567 3.84254 13.5 3.97716 13.5H15.0541C15.1887 13.5 15.2993 13.4567 15.3858 13.3702C15.4724 13.2837 15.5156 13.1731 15.5156 13.0385V5.16347L9.51563 9.08655ZM9.51563 8.25L15.2849 4.5H3.7464L9.51563 8.25ZM3.51562 5.16347V4.5V13.0385C3.51562 13.1731 3.55889 13.2837 3.64543 13.3702C3.73197 13.4567 3.84254 13.5 3.97716 13.5H3.51562V5.16347Z"
        fill="black"
      />
    </g>
  </svg>
);

export const eventsImageSVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="image_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M4.68208 16.6673C4.29854 16.6673 3.9783 16.5388 3.72135 16.2819C3.46441 16.025 3.33594 15.7047 3.33594 15.3212V4.68013C3.33594 4.29659 3.46441 3.97635 3.72135 3.7194C3.9783 3.46246 4.29854 3.33398 4.68208 3.33398H15.3231C15.7067 3.33398 16.0269 3.46246 16.2839 3.7194C16.5408 3.97635 16.6693 4.29659 16.6693 4.68013V15.3212C16.6693 15.7047 16.5408 16.025 16.2839 16.2819C16.0269 16.5388 15.7067 16.6673 15.3231 16.6673H4.68208ZM4.68208 15.834H15.3231C15.4513 15.834 15.5688 15.7806 15.6757 15.6737C15.7825 15.5669 15.8359 15.4494 15.8359 15.3212V4.68013C15.8359 4.55194 15.7825 4.43442 15.6757 4.32757C15.5688 4.22073 15.4513 4.16732 15.3231 4.16732H4.68208C4.55389 4.16732 4.43637 4.22073 4.32952 4.32757C4.22269 4.43442 4.16927 4.55194 4.16927 4.68013V15.3212C4.16927 15.4494 4.22269 15.5669 4.32952 15.6737C4.43637 15.7806 4.55389 15.834 4.68208 15.834ZM6.2526 13.7507H13.8808L11.525 10.6096L9.34556 13.366L7.88721 11.6032L6.2526 13.7507Z"
        fill="black"
      />
    </g>
  </svg>
);

export const eventsRatingSVG = (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 227">
      <circle id="Ellipse 7" cx="15.5156" cy="15" r="15" fill="#FFF6F6" />
      <path
        id="Vector"
        d="M15.5205 19.7789L11.1941 22L12.0205 17.2957L8.51562 13.9644L13.3524 13.2799L15.5156 9L17.6789 13.2799L22.5156 13.9644L19.0107 17.2957L19.8372 22L15.5205 19.7789Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const accordionPlusIconCloseSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="add_FILL0_wght200_GRAD0_opsz24 1">
      <rect
        id="Rectangle 27029"
        x="6.25"
        y="11.25"
        width="11.5"
        height="0.5"
        fill="black"
        stroke="black"
        stroke-width="0.5"
      />
    </g>
  </svg>
);

export const accordionPlusIconOpenSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="add_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M5.8 12.5C5.8 12.6105 5.88954 12.7 6 12.7H11.3V18C11.3 18.1105 11.3895 18.2 11.5 18.2H12.5C12.6105 18.2 12.7 18.1105 12.7 18V12.7H18C18.1105 12.7 18.2 12.6105 18.2 12.5V11.5C18.2 11.3895 18.1105 11.3 18 11.3H12.7V6C12.7 5.88954 12.6105 5.8 12.5 5.8H11.5C11.3895 5.8 11.3 5.88954 11.3 6V11.3H6C5.88954 11.3 5.8 11.3895 5.8 11.5V12.5Z"
        fill="black"
        stroke="black"
        stroke-width="0.4"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const attachmentFileSVG = (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 400 400"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs></defs>

    <title />

    <g id="xxx-file">
      <path
        class="cls-1"
        d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"
      />

      <path
        class="cls-1"
        d="M300,380H100a30,30,0,0,1-30-30V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100V350A30,30,0,0,1,300,380ZM100,30A20,20,0,0,0,80,50V350a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V102.07L247.93,30Z"
      />

      <path class="cls-1" d="M275,180H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z" />

      <path class="cls-1" d="M275,230H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z" />

      <path class="cls-1" d="M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z" />

      <path class="cls-1" d="M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z" />
    </g>
  </svg>
);

export const closeBtnSVG = (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M0.182955 9.43237C0.0657717 9.5496 -3.90388e-05 9.70858 3.05518e-08 9.87434C3.90999e-05 10.0401 0.0659248 10.199 0.183163 10.3162C0.300401 10.4334 0.459388 10.4992 0.625149 10.4992C0.79091 10.4991 0.949866 10.4332 1.06705 10.316L4.9259 6.45774C4.93558 6.44804 4.94707 6.44034 4.95972 6.43509C4.97238 6.42984 4.98594 6.42714 4.99964 6.42714C5.01334 6.42714 5.02691 6.42984 5.03956 6.43509C5.05222 6.44034 5.06371 6.44804 5.07339 6.45774L8.93224 10.3168C8.99026 10.3749 9.05915 10.4209 9.13497 10.4524C9.21079 10.4838 9.29206 10.5 9.37414 10.5C9.45622 10.5 9.53749 10.4839 9.61333 10.4525C9.68917 10.4211 9.75807 10.3751 9.81612 10.3171C9.87418 10.259 9.92023 10.1901 9.95166 10.1143C9.98308 10.0385 9.99927 9.95724 9.99929 9.87517C9.99931 9.7931 9.98316 9.71183 9.95177 9.63599C9.92038 9.56016 9.87436 9.49125 9.81633 9.4332L5.9579 5.57326C5.9482 5.56359 5.9405 5.55209 5.93525 5.53944C5.93 5.52679 5.9273 5.51322 5.9273 5.49952C5.9273 5.48582 5.93 5.47226 5.93525 5.4596C5.9405 5.44695 5.9482 5.43546 5.9579 5.42578L9.81717 1.56709C9.93435 1.44975 10.0001 1.29066 10 1.12483C9.99988 0.958997 9.93389 0.800003 9.81654 0.682825C9.69919 0.565647 9.5401 0.499883 9.37426 0.5C9.20842 0.500117 9.04942 0.566106 8.93224 0.68345L5.07339 4.54131C5.06371 4.55101 5.05222 4.5587 5.03956 4.56395C5.02691 4.5692 5.01334 4.57191 4.99964 4.57191C4.98594 4.57191 4.97238 4.5692 4.95972 4.56395C4.94707 4.5587 4.93558 4.55101 4.9259 4.54131L1.06705 0.68345C1.00903 0.625402 0.940137 0.57935 0.864316 0.547925C0.788494 0.516499 0.707226 0.500314 0.625149 0.500295C0.459388 0.500256 0.300401 0.566064 0.183163 0.683242C0.0659248 0.80042 3.90843e-05 0.959369 1.73834e-08 1.12512C-3.90495e-05 1.29088 0.0657717 1.44986 0.182955 1.56709L4.04139 5.42578C4.05109 5.43546 4.05878 5.44695 4.06404 5.4596C4.06929 5.47226 4.07199 5.48582 4.07199 5.49952C4.07199 5.51322 4.06929 5.52679 4.06404 5.53944C4.05878 5.55209 4.05109 5.56359 4.04139 5.57326L0.182955 9.43237Z"
      fill="black"
    />
  </svg>
);

export const notificationBellSVG = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="notifications_FILL0_wght300_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M4.5 19.3846V17.8846H6.3077V10.4231C6.3077 9.07818 6.72276 7.88908 7.55287 6.85575C8.38301 5.82242 9.44872 5.16153 10.75 4.87308V4.25C10.75 3.90278 10.8714 3.60765 11.1143 3.3646C11.3571 3.12153 11.6519 3 11.9988 3C12.3457 3 12.641 3.12153 12.8846 3.3646C13.1282 3.60765 13.25 3.90278 13.25 4.25V4.87308C14.5512 5.16153 15.6169 5.82242 16.4471 6.85575C17.2772 7.88908 17.6922 9.07818 17.6922 10.4231V17.8846H19.5V19.3846H4.5ZM11.9983 22.1923C11.5007 22.1923 11.0753 22.0153 10.7221 21.6613C10.3689 21.3073 10.1923 20.8817 10.1923 20.3846H13.8077C13.8077 20.8833 13.6305 21.3093 13.2761 21.6625C12.9218 22.0157 12.4959 22.1923 11.9983 22.1923ZM7.80765 17.8846H16.1923V10.4231C16.1923 9.26535 15.783 8.27721 14.9644 7.45863C14.1458 6.64003 13.1577 6.23073 12 6.23073C10.8423 6.23073 9.85413 6.64003 9.03555 7.45863C8.21695 8.27721 7.80765 9.26535 7.80765 10.4231V17.8846Z"
        fill="black"
      />
    </g>
  </svg>
);

export const backButtonSVG = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="keyboard_backspace_FILL0_wght400_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M13.5 27L4.5 18L13.5 9L15.6 11.1L10.2 16.5H31.5V19.5H10.2L15.6 24.9L13.5 27Z"
        fill="black"
      />
    </g>
  </svg>
);

export const walletSVG = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="wallet_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M7.5 23.4514C6.46154 23.4514 5.57693 23.0962 4.84616 22.3857C4.11539 21.6752 3.75 20.8152 3.75 19.8056V10.0833C3.75 9.07372 4.11539 8.21368 4.84616 7.50321C5.57693 6.79274 6.46154 6.4375 7.5 6.4375H22.5C23.5385 6.4375 24.4231 6.79274 25.1538 7.50321C25.8846 8.21368 26.25 9.07372 26.25 10.0833V19.8056C26.25 20.8152 25.8846 21.6752 25.1538 22.3857C24.4231 23.0962 23.5385 23.4514 22.5 23.4514H7.5ZM7.5 10.691H22.5C22.9904 10.691 23.4479 10.7728 23.8726 10.9364C24.2973 11.1 24.6731 11.3399 25 11.6562V10.0833C25 9.41493 24.7552 8.84274 24.2656 8.36675C23.776 7.89077 23.1875 7.65278 22.5 7.65278H7.5C6.8125 7.65278 6.22396 7.89077 5.73438 8.36675C5.24479 8.84274 5 9.41493 5 10.0833V11.6562C5.32692 11.3399 5.70272 11.1 6.12741 10.9364C6.55209 10.7728 7.00962 10.691 7.5 10.691ZM5.04328 14.0096L19.2139 17.361C19.3694 17.4015 19.5289 17.4054 19.6923 17.3727C19.8558 17.3399 19.9968 17.2706 20.1154 17.1647L24.7716 13.3365C24.5905 12.9081 24.2949 12.5626 23.8846 12.3001C23.4744 12.0375 23.0128 11.9063 22.5 11.9063H7.5C6.86219 11.9063 6.3121 12.1053 5.84975 12.5034C5.38742 12.9015 5.11859 13.4035 5.04328 14.0096Z"
        fill="#F37032"
      />
    </g>
  </svg>
);

export const dashboardSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 19V14.1923H19V19H16ZM10.5 19V5H13.5V19H10.5ZM5 19V9.80775H8V19H5Z"
      fill="#F37032"
    />
  </svg>
);

export const downloadIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#5f6368"
  >
    <path d="M480-328.46 309.23-499.23l42.16-43.38L450-444v-336h60v336l98.61-98.61 42.16 43.38L480-328.46ZM252.31-180Q222-180 201-201q-21-21-21-51.31v-108.46h60v108.46q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-108.46h60v108.46Q780-222 759-201q-21 21-51.31 21H252.31Z" />
  </svg>
);

export const locationSVG = (height, width) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill={"rgb(255, 93, 2)"}
    >
      <path d="M480-291q98.62-83.08 149.31-160.54T680-596.69q0-89.23-56-146.27Q568-800 480-800t-144 57.04q-56 57.04-56 146.27 0 67.69 50.69 145.15Q381.38-374.08 480-291Zm0 76Q350.15-315.54 285.08-411.42 220-507.31 220-596.69q0-115.39 72.62-189.35Q365.23-860 480-860t187.38 73.96Q740-712.08 740-596.69q0 89.38-65.08 185.07Q609.85-315.92 480-215Zm0-312.69q29.92 0 51.11-21.2 21.2-21.19 21.2-51.11 0-29.92-21.2-51.11-21.19-21.2-51.11-21.2-29.92 0-51.11 21.2-21.2 21.19-21.2 51.11 0 29.92 21.2 51.11 21.19 21.2 51.11 21.2ZM220-100v-60h520v60H220Zm260-500Z" />
    </svg>
  );
};

export const companyGroupsSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_5110_13916)">
      <path
        d="M2.5 17.5H17.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16602 17.5V5.83333L10.8327 2.5V17.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.834 17.5026V9.16927L10.834 5.83594"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 7.5V7.50833"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 10V10.0083"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 12.5V12.5083"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 15V15.0083"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5110_13916">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const starSVG = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="groups_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M18.9823 23.7697C18.6866 23.6103 18.3305 23.6102 18.0346 23.7692L12.7242 26.6236L13.7443 20.5441C13.7979 20.2244 13.6932 19.8985 13.4634 19.6698L9.11816 15.3457L15.0927 14.4604C15.4203 14.4119 15.7027 14.2043 15.8467 13.906L18.5 8.40962L21.1533 13.906C21.2973 14.2043 21.5797 14.4119 21.9073 14.4604L27.8818 15.3457L23.5366 19.6698C23.3068 19.8985 23.2021 20.2244 23.2557 20.5441L24.2754 26.6212L18.9823 23.7697Z"
        stroke="#F37032"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const imageSVG = (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="image_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M7.25742 25.4754C6.66294 25.4754 6.16656 25.2818 5.76829 24.8946C5.37003 24.5074 5.1709 24.0248 5.1709 23.4468V7.41138C5.1709 6.8334 5.37003 6.35081 5.76829 5.96361C6.16656 5.57641 6.66294 5.38281 7.25742 5.38281H23.751C24.3455 5.38281 24.8419 5.57641 25.2402 5.96361C25.6384 6.35081 25.8376 6.8334 25.8376 7.41138V23.4468C25.8376 24.0248 25.6384 24.5074 25.2402 24.8946C24.8419 25.2818 24.3455 25.4754 23.751 25.4754H7.25742ZM7.25742 24.2196H23.751C23.9497 24.2196 24.1319 24.1391 24.2975 23.9781C24.4631 23.8171 24.5459 23.64 24.5459 23.4468V7.41138C24.5459 7.2182 24.4631 7.0411 24.2975 6.88009C24.1319 6.7191 23.9497 6.6386 23.751 6.6386H7.25742C7.05872 6.6386 6.87657 6.7191 6.71095 6.88009C6.54536 7.0411 6.46257 7.2182 6.46257 7.41138V23.4468C6.46257 23.64 6.54536 23.8171 6.71095 23.9781C6.87657 24.1391 7.05872 24.2196 7.25742 24.2196ZM9.69173 21.0802H21.5155L17.864 16.3468L14.4858 20.5005L12.2254 17.8441L9.69173 21.0802Z"
        fill="#F37032"
      />
    </g>
  </svg>
);

export const travelSVG = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="groups_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M1.5 26.1041V24.8448C1.5 23.9493 1.9923 23.2061 2.9769 22.6153C3.96153 22.0245 5.22884 21.7291 6.77884 21.7291C7.00769 21.7291 7.25289 21.7398 7.51444 21.7613C7.77596 21.7828 8.05384 21.8179 8.34806 21.8665C8.11346 22.2647 7.94231 22.6733 7.83461 23.092C7.72691 23.5109 7.67306 23.9306 7.67306 24.3513V26.1041H1.5ZM10.5 26.1041V24.4635C10.5 23.8757 10.6755 23.3385 11.0264 22.8518C11.3774 22.3651 11.8952 21.9441 12.5798 21.5889C13.2644 21.2336 14.062 20.9672 14.9726 20.7896C15.8832 20.612 16.8884 20.5232 17.9885 20.5232C19.1096 20.5232 20.1255 20.612 21.0361 20.7896C21.9466 20.9672 22.7442 21.2336 23.4288 21.5889C24.1135 21.9441 24.6298 22.3651 24.9779 22.8518C25.326 23.3385 25.5 23.8757 25.5 24.4635V26.1041H10.5ZM28.3269 26.1041V24.3597C28.3269 23.8945 28.2745 23.4561 28.1697 23.0446C28.0649 22.6332 27.9077 22.2404 27.6981 21.8665C28.0115 21.8179 28.2928 21.7828 28.5418 21.7613C28.7909 21.7398 29.0269 21.7291 29.25 21.7291C30.8 21.7291 32.0625 22.0231 33.0375 22.6111C34.0125 23.1991 34.5 23.9437 34.5 24.8448V26.1041H28.3269ZM12.0433 24.6458H23.9654V24.3372C23.9077 23.6455 23.3245 23.0799 22.2159 22.6405C21.1072 22.2012 19.7019 21.9815 18 21.9815C16.2981 21.9815 14.8928 22.2012 13.7841 22.6405C12.6755 23.0799 12.0952 23.6455 12.0433 24.3372V24.6458ZM6.77119 20.3549C6.18206 20.3549 5.68029 20.1517 5.26586 19.7452C4.85144 19.3388 4.64423 18.8503 4.64423 18.2795C4.64423 17.7149 4.85324 17.2325 5.27126 16.8324C5.68929 16.4323 6.19181 16.2323 6.77884 16.2323C7.35961 16.2323 7.86058 16.4323 8.28172 16.8324C8.70288 17.2325 8.91345 17.7177 8.91345 18.2879C8.91345 18.8414 8.70815 19.3242 8.29755 19.7365C7.88695 20.1487 7.37816 20.3549 6.77119 20.3549ZM29.25 20.3549C28.675 20.3549 28.1755 20.1487 27.7514 19.7365C27.3274 19.3242 27.1154 18.8414 27.1154 18.2879C27.1154 17.7177 27.3274 17.2325 27.7514 16.8324C28.1755 16.4323 28.6769 16.2323 29.2556 16.2323C29.8519 16.2323 30.3558 16.4323 30.7673 16.8324C31.1789 17.2325 31.3846 17.7149 31.3846 18.2795C31.3846 18.8503 31.18 19.3388 30.7709 19.7452C30.3618 20.1517 29.8548 20.3549 29.25 20.3549ZM18.0102 19.4294C17.0995 19.4294 16.3221 19.1186 15.6779 18.4969C15.0336 17.8752 14.7115 17.1204 14.7115 16.2323C14.7115 15.3264 15.0312 14.5671 15.6707 13.9543C16.3101 13.3415 17.0865 13.0352 18 13.0352C18.9317 13.0352 19.7127 13.3406 20.343 13.9515C20.9733 14.5624 21.2885 15.3193 21.2885 16.2224C21.2885 17.1077 20.9743 17.8635 20.346 18.4899C19.7176 19.1162 18.939 19.4294 18.0102 19.4294ZM18.0144 17.9711C18.5067 17.9711 18.9255 17.7986 19.2707 17.4536C19.6159 17.1087 19.7885 16.6969 19.7885 16.2183C19.7885 15.7396 19.6171 15.3325 19.2743 14.9969C18.9315 14.6613 18.5067 14.4935 18 14.4935C17.5173 14.4935 17.0986 14.6601 16.7438 14.9934C16.389 15.3267 16.2116 15.7396 16.2116 16.2323C16.2116 16.7016 16.389 17.1087 16.7438 17.4536C17.0986 17.7986 17.5221 17.9711 18.0144 17.9711Z"
        fill="#F37032"
      />
    </g>
  </svg>
);

export const uploadIconSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="upload_FILL0_wght300_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M11.25 15.7884V7.3884L8.78462 9.85378L7.7308 8.7692L12 4.5L16.2692 8.7692L15.2153 9.85378L12.7499 7.3884V15.7884H11.25ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V14.9808H5.99997V17.6923C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6923V14.9808H19.5V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
        fill="#1D275F"
      />
    </g>
  </svg>
);

export const uploadWalletIconSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="upload_FILL0_wght300_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M11.25 15.7884V7.3884L8.78462 9.85378L7.7308 8.7692L12 4.5L16.2692 8.7692L15.2153 9.85378L12.7499 7.3884V15.7884H11.25ZM6.3077 19.5C5.80257 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V14.9808H5.99997V17.6923C5.99997 17.7692 6.03202 17.8397 6.09612 17.9038C6.16024 17.9679 6.23077 18 6.3077 18H17.6922C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6923V14.9808H19.5V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6922 19.5H6.3077Z"
        fill="white"
      />
    </g>
  </svg>
);

export const addIconSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="add_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M5.8 12.5C5.8 12.6105 5.88954 12.7 6 12.7H11.3V18C11.3 18.1105 11.3895 18.2 11.5 18.2H12.5C12.6105 18.2 12.7 18.1105 12.7 18V12.7H18C18.1105 12.7 18.2 12.6105 18.2 12.5V11.5C18.2 11.3895 18.1105 11.3 18 11.3H12.7V6C12.7 5.88954 12.6105 5.8 12.5 5.8H11.5C11.3895 5.8 11.3 5.88954 11.3 6V11.3H6C5.88954 11.3 5.8 11.3895 5.8 11.5V12.5Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const requestIconSVG = (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M0.171875 16.3846V14.8846H2.08969V7.42305C2.08969 6.07818 2.53003 4.88908 3.41071 3.85575C4.29141 2.82242 5.42204 2.16153 6.80259 1.87308V1.25C6.80259 0.902783 6.9314 0.607651 7.18902 0.364601C7.44665 0.121534 7.75948 0 8.12751 0C8.49554 0 8.80876 0.121534 9.06718 0.364601C9.32561 0.607651 9.45482 0.902783 9.45482 1.25V1.87308C10.8354 2.16153 11.966 2.82242 12.8467 3.85575C13.7274 4.88908 14.1677 6.07818 14.1677 7.42305V14.8846H16.0855V16.3846H0.171875ZM8.1269 19.1923C7.599 19.1923 7.1477 19.0153 6.77299 18.6613C6.39827 18.3073 6.21091 17.8817 6.21091 17.3846H10.0465C10.0465 17.8833 9.85853 18.3093 9.48261 18.6625C9.1067 19.0157 8.65479 19.1923 8.1269 19.1923ZM3.68101 14.8846H12.5764V7.42305C12.5764 6.26535 12.1422 5.27721 11.2737 4.45863C10.4053 3.64003 9.35692 3.23073 8.1287 3.23073C6.90048 3.23073 5.85215 3.64003 4.9837 4.45863C4.11524 5.27721 3.68101 6.26535 3.68101 7.42305V14.8846Z"
      fill="#FF0000"
    />
  </svg>
);

export const accordionExpandCloseSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="expand_more_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M11.8587 14.8443L12.0001 14.9857L12.1415 14.8443L17.4492 9.53662L17.5906 9.3952L17.4492 9.25378L16.7415 8.54608L16.6001 8.40466L16.4587 8.54608L12.0001 13.0047L7.5415 8.54608L7.40008 8.40466L7.25866 8.54608L6.55096 9.25378L6.40954 9.3952L6.55096 9.53662L11.8587 14.8443Z"
        fill="#F37032"
        stroke="#F37032"
        stroke-width="0.4"
      />
    </g>
  </svg>
);

export const accordionExpandOpenSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="expand_more_FILL0_wght200_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M12.1413 9.15568L11.9999 9.01426L11.8585 9.15568L6.5508 14.4634L6.40937 14.6048L6.5508 14.7462L7.2585 15.4539L7.39992 15.5953L7.54134 15.4539L11.9999 10.9953L16.4585 15.4539L16.5999 15.5953L16.7413 15.4539L17.449 14.7462L17.5905 14.6048L17.449 14.4634L12.1413 9.15568Z"
        fill="#F37032"
        stroke="#F37032"
        stroke-width="0.4"
      />
    </g>
  </svg>
);

export const uploadCloudIconSVG = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <g id="Group">
        <path
          id="Vector"
          d="M12.4992 12.0002V21.0002M12.4992 12.0002L9.99923 14.0002M12.4992 12.0002L14.9992 14.0002M5.53323 9.11719C4.58744 9.35518 3.76111 9.93035 3.20948 10.7346C2.65786 11.5389 2.41891 12.5169 2.53754 13.485C2.65616 14.453 3.12419 15.3444 3.85369 15.9917C4.5832 16.639 5.52396 16.9976 6.49923 17.0002H7.49923"
          stroke="#191D23"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M16.3326 7.13772C15.9908 5.78429 15.1472 4.61146 13.9727 3.85698C12.7983 3.10249 11.3809 2.82281 10.0079 3.07462C8.63484 3.32643 7.40894 4.0909 6.57866 5.21306C5.74839 6.33521 5.37586 7.73109 5.5366 9.11772C5.5366 9.11772 5.6896 9.99972 6.0026 10.4997"
          stroke="#191D23"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M17.5 17C18.206 16.9995 18.904 16.8495 19.5479 16.5599C20.1917 16.2702 20.767 15.8475 21.2357 15.3195C21.7045 14.7915 22.0561 14.1702 22.2674 13.4965C22.4787 12.8229 22.545 12.1121 22.4618 11.4109C22.3786 10.7098 22.1479 10.0343 21.7848 9.42874C21.4217 8.82321 20.9345 8.30145 20.3552 7.89778C19.776 7.49412 19.1178 7.21772 18.424 7.08676C17.7302 6.9558 17.0166 6.97327 16.33 7.138L15 7.5"
          stroke="#191D23"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const contactAdminSVG = (
  <svg
    width="248"
    height="165"
    viewBox="0 0 248 165"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Pull request-pana 1">
      <g id="freepik--background-complete--inject-4">
        <path
          id="Vector"
          d="M216.587 126.305C215.798 126.308 215.026 126.077 214.369 125.642C213.711 125.207 213.198 124.588 212.894 123.861C212.59 123.135 212.509 122.335 212.66 121.562C212.812 120.79 213.191 120.08 213.747 119.522C214.304 118.964 215.014 118.584 215.787 118.429C216.56 118.274 217.362 118.352 218.091 118.653C218.82 118.953 219.444 119.463 219.882 120.117C220.321 120.771 220.555 121.541 220.555 122.328C220.554 123.38 220.136 124.388 219.393 125.133C218.649 125.878 217.641 126.299 216.587 126.305ZM216.587 120.483C216.221 120.483 215.864 120.59 215.559 120.793C215.255 120.995 215.017 121.283 214.877 121.62C214.737 121.957 214.699 122.328 214.77 122.686C214.841 123.044 215.017 123.373 215.275 123.631C215.534 123.89 215.863 124.066 216.222 124.137C216.581 124.208 216.952 124.172 217.29 124.033C217.628 123.893 217.917 123.657 218.12 123.353C218.324 123.05 218.432 122.693 218.432 122.328C218.431 121.84 218.237 121.371 217.891 121.026C217.545 120.68 217.076 120.485 216.587 120.483Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_2"
          d="M216.587 145.215C215.798 145.218 215.026 144.988 214.369 144.553C213.711 144.118 213.198 143.498 212.894 142.771C212.59 142.045 212.509 141.245 212.66 140.473C212.812 139.7 213.191 138.99 213.747 138.432C214.304 137.874 215.014 137.494 215.787 137.339C216.56 137.185 217.362 137.262 218.091 137.563C218.82 137.863 219.444 138.373 219.882 139.027C220.321 139.682 220.555 140.451 220.555 141.238C220.554 142.29 220.136 143.298 219.393 144.043C218.649 144.788 217.641 145.209 216.587 145.215ZM216.587 139.397C216.222 139.397 215.865 139.505 215.562 139.707C215.258 139.909 215.022 140.197 214.882 140.534C214.743 140.87 214.706 141.24 214.777 141.597C214.849 141.955 215.024 142.283 215.282 142.54C215.54 142.798 215.869 142.973 216.227 143.044C216.585 143.115 216.956 143.079 217.293 142.939C217.63 142.8 217.918 142.564 218.121 142.261C218.324 141.958 218.432 141.602 218.432 141.238C218.431 140.75 218.237 140.282 217.891 139.937C217.545 139.592 217.076 139.398 216.587 139.397Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_3"
          d="M232.739 145.215C231.951 145.218 231.179 144.988 230.521 144.553C229.864 144.118 229.35 143.498 229.046 142.771C228.742 142.045 228.661 141.245 228.813 140.473C228.965 139.7 229.343 138.99 229.899 138.432C230.456 137.874 231.166 137.494 231.939 137.339C232.713 137.185 233.515 137.262 234.244 137.563C234.973 137.863 235.596 138.373 236.035 139.027C236.473 139.682 236.707 140.451 236.707 141.238C236.706 142.289 236.288 143.297 235.544 144.042C234.801 144.787 233.793 145.209 232.739 145.215ZM232.739 139.397C232.375 139.397 232.018 139.506 231.715 139.709C231.412 139.911 231.176 140.199 231.037 140.536C230.898 140.872 230.862 141.242 230.933 141.599C231.005 141.956 231.181 142.284 231.439 142.541C231.697 142.799 232.026 142.974 232.384 143.044C232.742 143.115 233.113 143.079 233.45 142.939C233.786 142.8 234.074 142.564 234.277 142.261C234.48 141.958 234.588 141.602 234.588 141.238C234.588 140.996 234.54 140.756 234.447 140.533C234.354 140.309 234.218 140.106 234.046 139.935C233.875 139.764 233.671 139.628 233.446 139.536C233.222 139.444 232.982 139.396 232.739 139.397Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_4"
          d="M217.555 125.289H215.416V138.651H217.555V125.289Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_5"
          d="M234.188 139.158H232.052V128.041C232.05 126.806 231.558 125.621 230.682 124.748C229.807 123.874 228.621 123.383 227.383 123.381H224.599V121.246H227.383C229.187 121.249 230.917 121.966 232.193 123.239C233.469 124.513 234.186 126.24 234.188 128.041V139.158Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_6"
          d="M226.12 118.402V125.996L221.97 122.326L226.12 118.402Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_7"
          d="M29.469 38.6211H12.9688V65.9451H29.469V38.6211Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_8"
          d="M47.9331 38.6211H30.1035V65.9451H47.9331V38.6211Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_9"
          d="M47.9331 67.8555H30.1035V94.2555H47.9331V67.8555Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_10"
          d="M50.2148 38.1475H68.9901V13.909H69.625V38.1475H84.9051V13.3711H50.2148V38.1475Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_11"
          d="M84.9051 38.6211H69.625V65.9451H84.9051V38.6211Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_12"
          d="M84.9051 67.8555H69.625V94.2555H84.9051V67.8555Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_13"
          d="M29.469 67.8555H12.9688V94.2555H29.469V67.8555Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_14"
          d="M68.9901 67.8555H50.2148V94.2555H68.9901V67.8555Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_15"
          d="M29.469 94.7266H12.9688V118.516H29.469V94.7266Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_16"
          d="M84.9051 94.7266H69.625V118.516H84.9051V94.7266Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_17"
          d="M29.469 38.1475V13.909H30.1039V38.1475H47.9301V13.3711H12.9688V38.1475H29.469Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_18"
          d="M68.9901 94.7266H50.2148V118.516H68.9901V94.7266Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_19"
          d="M47.9331 94.7266H30.1035V118.516H47.9331V94.7266Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_20"
          d="M68.9901 38.6211H50.2148V65.9451H68.9901V38.6211Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_21"
          d="M155.453 37.5H139.684V63.6129H155.453V37.5Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_22"
          d="M173.095 37.5H156.059V63.6129H173.095V37.5Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_23"
          d="M173.095 65.4336H156.059V90.6621H173.095V65.4336Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_24"
          d="M175.276 37.0486H193.218V13.8826H193.827V37.0486H208.429V13.3711H175.276V37.0486Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_25"
          d="M208.429 37.5H193.827V63.6129H208.429V37.5Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_26"
          d="M208.429 65.4336H193.827V90.6621H208.429V65.4336Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_27"
          d="M155.453 65.4336H139.684V90.6621H155.453V65.4336Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_28"
          d="M193.218 65.4336H175.276V90.6621H193.218V65.4336Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_29"
          d="M155.45 37.0486V13.8826H156.055V37.0486H173.094V13.3711H139.684V37.0486H155.45Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_30"
          d="M193.218 37.5H175.276V63.6129H193.218V37.5Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_31"
          d="M125.676 52.0059L121.195 49.983C118.772 51.2495 115.964 51.5732 113.315 50.8912C110.666 50.2093 108.366 48.5703 106.859 46.2919C105.352 44.0134 104.746 41.2579 105.159 38.5591C105.571 35.8604 106.973 33.4106 109.093 31.6847C111.212 29.9587 113.898 29.0794 116.63 29.2172C119.362 29.3549 121.946 30.5 123.88 32.4303C125.815 34.3607 126.962 36.939 127.1 39.6655C127.238 42.392 126.357 45.0727 124.628 47.1879L125.676 52.0059ZM121.182 49.5705L125.15 51.3657L124.221 47.0988L124.277 47.0295C125.914 45.068 126.788 42.5848 126.742 40.033C126.696 37.4813 125.732 35.0311 124.027 33.1297C122.321 31.2283 119.987 30.0025 117.45 29.676C114.914 29.3495 112.344 29.9441 110.211 31.3512C108.077 32.7583 106.522 34.8842 105.829 37.3408C105.135 39.7974 105.35 42.4209 106.434 44.7325C107.518 47.0441 109.399 48.8897 111.733 49.9323C114.067 50.975 116.699 51.1452 119.149 50.412C119.822 50.2099 120.475 49.9424 121.096 49.6134L121.182 49.5705Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_32"
          d="M117.011 44.3657C118.345 39.1698 115.206 33.8785 110 32.5474C104.793 31.2162 99.4913 34.3492 98.1574 39.5451C96.8235 44.741 99.9628 50.0323 105.169 51.3635C110.376 52.6946 115.678 49.5617 117.011 44.3657Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_33"
          d="M100.489 47.3281L99.4941 52.4596L104.094 50.2486L100.489 47.3281Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_34"
          d="M103.542 43.2581C104.265 43.2581 104.851 42.6731 104.851 41.9513C104.851 41.2296 104.265 40.6445 103.542 40.6445C102.819 40.6445 102.232 41.2296 102.232 41.9513C102.232 42.6731 102.819 43.2581 103.542 43.2581Z"
          fill="white"
        />
        <path
          id="Vector_35"
          d="M108.459 41.9528C108.459 42.2139 108.381 42.4691 108.236 42.6862C108.091 42.9032 107.884 43.0724 107.642 43.1723C107.401 43.2722 107.135 43.2984 106.878 43.2475C106.622 43.1965 106.386 43.0708 106.201 42.8862C106.016 42.7016 105.89 42.4664 105.839 42.2103C105.788 41.9543 105.814 41.6889 105.914 41.4477C106.014 41.2065 106.184 41.0003 106.401 40.8553C106.619 40.7102 106.875 40.6328 107.136 40.6328C107.487 40.6328 107.823 40.7719 108.071 41.0194C108.319 41.267 108.459 41.6027 108.459 41.9528Z"
          fill="white"
        />
        <path
          id="Vector_36"
          d="M110.733 43.2581C111.456 43.2581 112.043 42.6731 112.043 41.9513C112.043 41.2296 111.456 40.6445 110.733 40.6445C110.01 40.6445 109.424 41.2296 109.424 41.9513C109.424 42.6731 110.01 43.2581 110.733 43.2581Z"
          fill="white"
        />
      </g>
      <g id="freepik--Tables--inject-4">
        <path
          id="Vector_37"
          d="M102.715 151.578C102.715 151.627 81.8071 151.664 56.0184 151.664C30.2297 151.664 9.31836 151.627 9.31836 151.578C9.31836 151.528 30.2231 151.492 56.0184 151.492C81.8137 151.492 102.715 151.532 102.715 151.578Z"
          fill="#263238"
        />
        <path
          id="Vector_38"
          d="M238.682 100.648C238.682 100.695 222.915 100.734 203.469 100.734C184.022 100.734 168.253 100.695 168.253 100.648C168.253 100.602 184.016 100.562 203.469 100.562C222.922 100.562 238.682 100.582 238.682 100.648Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--speech-bubble-2--inject-4">
        <path
          id="Vector_39"
          d="M187.888 40.7803L184.687 38.6749C184.446 35.6364 183.074 32.7978 180.842 30.7171C178.611 28.6364 175.68 27.4641 172.626 27.4304C169.572 27.3968 166.615 28.5043 164.338 30.5354C162.061 32.5664 160.627 35.3741 160.318 38.4065C160.01 41.439 160.849 44.4769 162.671 46.9232C164.493 49.3696 167.166 51.0474 170.164 51.6269C173.163 52.2065 176.27 51.6459 178.875 50.0552C181.481 48.4646 183.396 45.959 184.244 43.0309L187.888 40.7803Z"
          fill="white"
        />
        <path
          id="Vector_40"
          d="M187.888 40.7815L187.643 40.9267L186.935 41.3557L184.224 43.0057L184.28 43.0387C184.281 43.0336 184.28 43.0286 184.278 43.0238C184.277 43.019 184.274 43.0146 184.271 43.0108C184.267 43.0071 184.263 43.0041 184.259 43.0021C184.254 43.0001 184.249 42.9991 184.244 42.9991C184.236 42.9988 184.228 43.0012 184.221 43.006C184.215 43.0108 184.21 43.0176 184.207 43.0255C183.633 44.9779 182.579 46.7564 181.142 48.1999C180.699 48.6462 180.222 49.0567 179.714 49.4275C179.165 49.8162 178.588 50.1637 177.988 50.467C175.613 51.6626 172.912 52.0474 170.297 51.562C167.683 51.0767 165.3 49.7482 163.515 47.7805C161.731 45.8128 160.643 43.3149 160.419 40.6703C160.194 38.0258 160.846 35.3809 162.274 33.142C163.296 31.5578 164.667 30.2271 166.282 29.2513C167.805 28.3405 169.511 27.777 171.278 27.6013C174.421 27.289 177.564 28.2018 180.048 30.1489L180.451 30.4789C180.586 30.5794 180.713 30.6897 180.831 30.8089C181.073 31.0465 181.308 31.2841 181.539 31.5151C181.953 31.9932 182.339 32.4945 182.696 33.0166C183.809 34.7079 184.481 36.6499 184.651 38.6662C184.65 38.6718 184.652 38.6773 184.655 38.6821C184.658 38.6868 184.662 38.6905 184.667 38.6926L187.051 40.2337L187.67 40.633L187.888 40.7683C187.888 40.7683 187.825 40.7221 187.689 40.633L187.088 40.2271L184.707 38.6332V38.6596C184.557 36.6319 183.899 34.6743 182.792 32.9671C182.433 32.4391 182.044 31.9312 181.628 31.4458L180.917 30.7297C180.801 30.6052 180.677 30.4894 180.544 30.3832L180.137 30.0532C178.955 29.116 177.61 28.4055 176.169 27.9577C174.583 27.4605 172.913 27.2876 171.259 27.4495C169.468 27.6179 167.738 28.1815 166.193 29.0995C164.554 30.0841 163.164 31.431 162.129 33.0364C161.045 34.7221 160.395 36.6493 160.237 38.6464C160.209 38.8928 160.197 39.1408 160.201 39.3889V40.1281L160.264 40.864C160.278 41.1078 160.309 41.3504 160.357 41.59C160.403 41.8309 160.446 42.0685 160.489 42.3061C160.532 42.5437 160.614 42.7747 160.677 43.009C160.74 43.2433 160.803 43.4743 160.886 43.702L161.153 44.362C161.867 46.0932 162.976 47.6344 164.391 48.8632C166.235 50.4787 168.523 51.5047 170.959 51.8083C173.394 52.1118 175.864 51.6791 178.05 50.566C178.656 50.2568 179.237 49.9027 179.79 49.5067C180.302 49.1312 180.783 48.7151 181.228 48.2626C182.671 46.8009 183.722 44.9997 184.284 43.0255H184.207C184.207 43.0354 184.211 43.045 184.218 43.0524C184.225 43.0597 184.234 43.0642 184.244 43.0651H184.267L186.978 41.359L187.666 40.9234L187.888 40.7815Z"
          fill="#263238"
        />
        <path
          id="Vector_41"
          d="M170.091 37.6516C169.802 37.6516 169.52 37.5659 169.279 37.4055C169.039 37.2451 168.851 37.0171 168.741 36.7504C168.63 36.4837 168.602 36.1902 168.658 35.9072C168.715 35.6242 168.854 35.3643 169.059 35.1604C169.264 34.9566 169.525 34.8179 169.808 34.762C170.092 34.7061 170.386 34.7354 170.653 34.8464C170.92 34.9573 171.148 35.1447 171.308 35.385C171.468 35.6253 171.554 35.9077 171.553 36.1963C171.552 36.5825 171.398 36.9527 171.124 37.2255C170.85 37.4984 170.478 37.6516 170.091 37.6516ZM170.091 35.5198C169.961 35.523 169.835 35.5645 169.729 35.6389C169.622 35.7134 169.54 35.8176 169.492 35.9384C169.445 36.0593 169.434 36.1914 169.461 36.3184C169.489 36.4453 169.553 36.5613 169.646 36.652C169.739 36.7426 169.857 36.8039 169.985 36.828C170.113 36.8522 170.245 36.8382 170.365 36.7878C170.485 36.7374 170.587 36.6528 170.659 36.5447C170.731 36.4365 170.769 36.3096 170.769 36.1798C170.769 36.0917 170.752 36.0045 170.717 35.9233C170.683 35.8422 170.633 35.7687 170.57 35.7072C170.507 35.6456 170.432 35.5974 170.35 35.5652C170.267 35.533 170.18 35.5176 170.091 35.5198Z"
          fill="#263238"
        />
        <path
          id="Vector_42"
          d="M170.091 44.5813C169.802 44.5813 169.52 44.4957 169.279 44.3354C169.039 44.1752 168.852 43.9474 168.741 43.6808C168.631 43.4143 168.602 43.121 168.658 42.8381C168.714 42.5552 168.854 42.2953 169.058 42.0913C169.262 41.8873 169.523 41.7484 169.806 41.6921C170.09 41.6358 170.384 41.6647 170.651 41.7751C170.918 41.8855 171.146 42.0724 171.307 42.3123C171.467 42.5522 171.553 42.8342 171.553 43.1227C171.553 43.5095 171.399 43.8805 171.125 44.154C170.851 44.4276 170.479 44.5813 170.091 44.5813ZM170.091 42.4495C169.961 42.4527 169.835 42.4942 169.729 42.5686C169.622 42.6431 169.54 42.7473 169.492 42.8681C169.445 42.989 169.434 43.1211 169.461 43.248C169.489 43.375 169.553 43.491 169.646 43.5817C169.739 43.6723 169.857 43.7336 169.985 43.7577C170.113 43.7819 170.245 43.7679 170.365 43.7175C170.485 43.6671 170.587 43.5825 170.659 43.4744C170.731 43.3662 170.769 43.2393 170.769 43.1095C170.769 43.0214 170.752 42.9342 170.717 42.853C170.683 42.7718 170.633 42.6983 170.57 42.6368C170.507 42.5753 170.432 42.5271 170.35 42.4949C170.267 42.4627 170.18 42.4473 170.091 42.4495Z"
          fill="#263238"
        />
        <path
          id="Vector_43"
          d="M176.007 44.5813C175.718 44.5819 175.435 44.4969 175.194 44.337C174.953 44.1772 174.765 43.9496 174.654 43.6831C174.543 43.4167 174.514 43.1233 174.57 42.8401C174.626 42.557 174.765 42.2968 174.969 42.0924C175.173 41.8881 175.434 41.7489 175.717 41.6923C176.001 41.6358 176.295 41.6645 176.562 41.7748C176.829 41.8851 177.058 42.072 177.219 42.312C177.379 42.5519 177.465 42.834 177.465 43.1227C177.465 43.5089 177.312 43.8794 177.038 44.1529C176.765 44.4263 176.394 44.5804 176.007 44.5813ZM176.007 42.4495C175.876 42.4495 175.748 42.4882 175.639 42.5607C175.531 42.6332 175.446 42.7363 175.396 42.8569C175.346 42.9775 175.333 43.1102 175.358 43.2382C175.384 43.3662 175.447 43.4838 175.539 43.5762C175.632 43.6685 175.75 43.7313 175.878 43.7568C176.006 43.7822 176.139 43.7692 176.26 43.7192C176.381 43.6693 176.484 43.5847 176.557 43.4761C176.629 43.3676 176.668 43.24 176.668 43.1095C176.664 42.9357 176.593 42.7703 176.47 42.6474C176.347 42.5245 176.181 42.4536 176.007 42.4495Z"
          fill="#263238"
        />
        <path
          id="Vector_44"
          d="M170.442 37.2812H169.658V42.1784H170.442V37.2812Z"
          fill="#263238"
        />
        <path
          id="Vector_45"
          d="M176.536 42.3618H175.752V38.2797C175.752 37.8275 175.571 37.394 175.251 37.0743C174.93 36.7545 174.496 36.5745 174.043 36.5736H173.024V35.8047H174.043C174.704 35.8056 175.337 36.068 175.805 36.5344C176.272 37.0009 176.535 37.6332 176.536 38.2929V42.3618Z"
          fill="#263238"
        />
        <path
          id="Vector_46"
          d="M173.58 34.7578V37.5397L172.062 36.1966L173.58 34.7578Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--speech-bubble-1--inject-4">
        <path
          id="Vector_47"
          d="M59.5195 95.5573L62.4261 93.5245C62.5713 90.7094 63.7663 88.0503 65.7761 86.0697C67.786 84.0891 70.4654 82.9303 73.2878 82.821C76.1102 82.7117 78.8716 83.6598 81.0292 85.479C83.1867 87.2982 84.5846 89.857 84.9479 92.6524C85.3113 95.4478 84.6139 98.2778 82.9928 100.586C81.3718 102.895 78.9442 104.514 76.1873 105.127C73.4303 105.74 70.5433 105.302 68.0936 103.899C65.6439 102.496 63.8087 100.229 62.9485 97.5439L59.5195 95.5573Z"
          fill="white"
        />
        <path
          id="Vector_48"
          d="M59.5195 95.5566L59.751 95.682L60.4123 96.0615L62.9651 97.5168L62.9122 97.5498C62.9117 97.5452 62.9122 97.5405 62.9137 97.5361C62.9151 97.5317 62.9175 97.5277 62.9206 97.5243C62.9237 97.5209 62.9275 97.5181 62.9318 97.5163C62.936 97.5144 62.9406 97.5134 62.9452 97.5135C62.9529 97.5134 62.9604 97.5156 62.9668 97.5197C62.9733 97.5238 62.9784 97.5296 62.9816 97.5366C63.5642 99.3286 64.5874 100.946 65.9576 102.242C66.379 102.645 66.8324 103.012 67.3133 103.341C67.8315 103.684 68.3728 103.991 68.9336 104.259C70.7396 105.108 72.74 105.462 74.7286 105.283C76.7172 105.104 78.6219 104.399 80.2466 103.241C81.8712 102.082 83.1568 100.513 83.971 98.6933C84.7852 96.8738 85.0984 94.8706 84.8784 92.8902C84.6806 91.0703 84.0342 89.3277 82.9969 87.8181C82.0114 86.38 80.7096 85.1858 79.1909 84.3267C77.7596 83.5229 76.1669 83.0472 74.5285 82.9341C73.0133 82.8265 71.4918 83.024 70.0546 83.5149C68.7519 83.9577 67.5423 84.6368 66.4867 85.518L66.1229 85.848C65.9985 85.9485 65.8824 86.0588 65.7757 86.178L65.1409 86.838C64.7723 87.2918 64.429 87.7655 64.1125 88.257C63.1299 89.8523 62.5616 91.6671 62.4592 93.537C62.4622 93.5455 62.4622 93.5548 62.4592 93.5634L60.2801 95.0385L59.7179 95.4246L59.5195 95.5566L59.6981 95.4246L60.247 95.0385L62.4062 93.504V93.5304C62.4939 91.6447 63.0569 89.8117 64.043 88.2009C64.3593 87.7032 64.7038 87.2239 65.0747 86.7654L65.7162 86.0856C65.8176 85.9671 65.9282 85.8567 66.0469 85.7556L66.4139 85.4256C68.6785 83.5262 71.5941 82.5796 74.545 82.7856C76.2061 82.899 77.8211 83.3791 79.2736 84.1914C80.8144 85.0598 82.1356 86.2688 83.1357 87.7257C84.1811 89.2568 84.8318 91.0216 85.0305 92.8638C85.0646 93.091 85.0823 93.3204 85.0834 93.5502L85.1098 94.2333L85.0701 94.9131C85.0648 95.1399 85.0427 95.366 85.004 95.5896C84.9676 95.8107 84.9346 96.0351 84.8982 96.2496C84.8594 96.4722 84.8087 96.6925 84.7461 96.9096C84.6866 97.1241 84.6403 97.3452 84.5708 97.5696L84.3427 98.1933C83.725 99.8116 82.7404 101.265 81.4659 102.44C80.3103 103.506 78.9466 104.321 77.4602 104.835C75.9738 105.349 74.397 105.55 72.8289 105.427C71.4582 105.319 70.1189 104.961 68.8774 104.371C68.3032 104.102 67.7505 103.79 67.2241 103.437C66.7422 103.102 66.2867 102.73 65.8617 102.325C64.4833 101.013 63.4596 99.3753 62.8857 97.563H62.9552C62.9556 97.5676 62.9551 97.5722 62.9537 97.5766C62.9522 97.581 62.9498 97.585 62.9467 97.5885C62.9436 97.5919 62.9398 97.5946 62.9356 97.5965C62.9313 97.5983 62.9267 97.5993 62.9221 97.5993H62.9022L60.3495 96.0912L59.6882 95.7051L59.5195 95.5566Z"
          fill="#263238"
        />
        <path
          id="Vector_49"
          d="M69.7236 94.2755L70.8909 93.1106L73.1427 95.1071L77.5604 90.8633L78.645 92.0282L72.9774 97.3544L69.7236 94.2755Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--Lines--inject-4">
        <path
          id="Vector_50"
          d="M208.76 135.832H76.6914V136.162H208.76V135.832Z"
          fill="#263238"
        />
        <path
          id="Vector_51"
          d="M144.052 67.5625H111.365V67.8925H144.052V67.5625Z"
          fill="#263238"
        />
        <path
          id="Vector_52"
          d="M223.881 135.832H216.167V136.162H223.881V135.832Z"
          fill="#263238"
        />
        <path
          id="Vector_53"
          d="M214.011 135.832H209.974V136.162H214.011V135.832Z"
          fill="#263238"
        />
        <path
          id="Vector_54"
          d="M104.077 73.0703H103.746V127.26H104.077V73.0703Z"
          fill="#263238"
        />
        <path
          id="Vector_55"
          d="M189.389 123.833H189.059V119.873H189.389V123.833ZM188.959 115.94C188.78 114.65 188.357 113.406 187.713 112.273L188.001 112.108C188.666 113.278 189.103 114.564 189.287 115.897L188.959 115.94ZM185.206 109.317C184.193 108.494 183.033 107.87 181.787 107.478L181.887 107.165C183.172 107.567 184.37 108.21 185.415 109.059L185.206 109.317ZM177.932 107.007H173.964V106.677H177.932V107.007ZM169.996 107.007H166.028V106.677H169.996V107.007ZM162.06 107.007C160.713 106.975 159.385 106.69 158.145 106.165L158.274 105.861C159.476 106.369 160.764 106.646 162.07 106.677L162.06 107.007ZM154.798 103.951C153.834 103.011 153.058 101.896 152.51 100.667L152.811 100.535C153.344 101.724 154.097 102.802 155.03 103.713L154.798 103.951ZM151.591 96.7766C151.591 96.6215 151.591 96.4631 151.591 96.3047V92.7935H151.921V96.2882C151.921 96.4433 151.921 96.5951 151.921 96.7469L151.591 96.7766ZM151.921 88.8566H151.591V84.8966H151.921V88.8566ZM151.921 80.9366H151.591V76.9766H151.921V80.9366Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--Button--inject-4">
        <path
          id="Vector_56"
          d="M117.472 58.5195H84.4651C79.927 58.5195 76.248 62.1903 76.248 66.7184C76.248 71.2465 79.927 74.9172 84.4651 74.9172H117.472C122.01 74.9172 125.689 71.2465 125.689 66.7184C125.689 62.1903 122.01 58.5195 117.472 58.5195Z"
          fill="#F37032"
        />
        <path
          id="Vector_57"
          d="M87.702 66.4773C87.702 67.1373 87.2093 67.5333 86.4256 67.5333H85.9263V68.2824H85.1162V65.418H86.4389C87.2093 65.418 87.702 65.8239 87.702 66.4773ZM86.882 66.4773C86.882 66.2133 86.7133 66.0582 86.3761 66.0582H85.9263V66.8964H86.3761C86.7133 66.8964 86.882 66.7413 86.882 66.4773Z"
          fill="white"
        />
        <path
          id="Vector_58"
          d="M88.04 67.0053V65.418H88.8535V66.9888C88.8535 67.4772 89.0552 67.6752 89.3958 67.6752C89.7364 67.6752 89.9381 67.4772 89.9381 66.9888V65.4246H90.735V67.0119C90.7512 67.1913 90.7273 67.372 90.665 67.5411C90.6028 67.7102 90.5037 67.8634 90.375 67.9896C90.2463 68.1159 90.0911 68.2121 89.9206 68.2713C89.7501 68.3304 89.5686 68.3511 89.3892 68.3319C88.5393 68.3385 88.04 67.86 88.04 67.0053Z"
          fill="white"
        />
        <path
          id="Vector_59"
          d="M91.2832 65.418H92.0933V67.6488H93.4623V68.2923H91.2832V65.418Z"
          fill="white"
        />
        <path
          id="Vector_60"
          d="M93.7832 65.418H94.5933V67.6488H95.9623V68.2923H93.7832V65.418Z"
          fill="white"
        />
        <path
          id="Vector_61"
          d="M98.7269 67.5201H98.2838V68.2824H97.4736V65.418H98.7963C99.58 65.418 100.073 65.8239 100.073 66.4773C100.08 66.6667 100.03 66.8541 99.9303 67.0152C99.8301 67.1764 99.6839 67.3039 99.5105 67.3815L100.129 68.2824H99.2592L98.7269 67.5201ZM98.7269 66.0582H98.2772V66.8964H98.7269C99.0575 66.8964 99.2328 66.7413 99.2328 66.4773C99.2328 66.2133 99.0708 66.0582 98.7335 66.0582H98.7269Z"
          fill="white"
        />
        <path
          id="Vector_62"
          d="M102.807 67.6515V68.2785H100.492V65.4141H102.744V66.0411H101.296V66.5229H102.569V67.1301H101.296V67.6515H102.807Z"
          fill="white"
        />
        <path
          id="Vector_63"
          d="M106.438 68.6124C106.341 68.7296 106.218 68.823 106.08 68.8853C105.941 68.9477 105.79 68.9774 105.637 68.9721C105.168 68.9721 104.86 68.8137 104.381 68.3121C104.026 68.2654 103.7 68.0906 103.465 67.8207C103.23 67.5508 103.101 67.2045 103.105 66.8469C103.131 66.4427 103.31 66.0636 103.606 65.7866C103.902 65.5096 104.293 65.3555 104.698 65.3555C105.104 65.3555 105.495 65.5096 105.791 65.7866C106.087 66.0636 106.266 66.4427 106.292 66.8469C106.296 67.1504 106.203 67.4472 106.028 67.6954C105.853 67.9436 105.604 68.1305 105.317 68.2296C105.356 68.2794 105.406 68.3199 105.464 68.3479C105.521 68.3758 105.584 68.3907 105.647 68.3913C105.729 68.3888 105.81 68.3701 105.884 68.3361C105.958 68.3021 106.025 68.2535 106.081 68.1933L106.438 68.6124ZM104.698 67.6686C104.862 67.6778 105.025 67.6378 105.166 67.5537C105.307 67.4695 105.419 67.3452 105.488 67.1967C105.557 67.0482 105.58 66.8824 105.554 66.7207C105.528 66.559 105.454 66.4089 105.341 66.2898C105.228 66.1707 105.083 66.088 104.922 66.0525C104.762 66.017 104.595 66.0303 104.442 66.0907C104.29 66.151 104.159 66.2556 104.067 66.391C103.974 66.5264 103.925 66.6864 103.925 66.8502C103.917 66.9556 103.932 67.0614 103.968 67.1609C104.003 67.2605 104.059 67.3515 104.132 67.4284C104.205 67.5053 104.292 67.5663 104.39 67.6077C104.487 67.649 104.592 67.6697 104.698 67.6686Z"
          fill="white"
        />
        <path
          id="Vector_64"
          d="M106.692 67.0053V65.418H107.503V66.9888C107.503 67.4772 107.708 67.6752 108.048 67.6752C108.389 67.6752 108.59 67.4772 108.59 66.9888V65.4246H109.387V67.0119C109.404 67.1913 109.38 67.372 109.317 67.5411C109.255 67.7102 109.156 67.8634 109.027 67.9896C108.899 68.1159 108.743 68.2121 108.573 68.2713C108.402 68.3304 108.221 68.3511 108.041 68.3319C107.192 68.3385 106.692 67.86 106.692 67.0053Z"
          fill="white"
        />
        <path
          id="Vector_65"
          d="M112.238 67.6515V68.2785H109.923V65.4141H112.171V66.0411H110.74V66.5229H112.013V67.1301H110.74V67.6515H112.238Z"
          fill="white"
        />
        <path
          id="Vector_66"
          d="M112.489 68.0267L112.754 67.4294C113.037 67.6088 113.364 67.706 113.699 67.7099C114.03 67.7099 114.169 67.6175 114.169 67.4789C114.169 67.0235 112.539 67.3535 112.539 66.2909C112.539 65.7794 112.955 65.3636 113.809 65.3636C114.17 65.3576 114.528 65.4439 114.847 65.6144L114.599 66.215C114.356 66.0763 114.082 66.0003 113.802 65.9939C113.471 65.9939 113.339 66.1061 113.339 66.2513C113.339 66.6869 114.966 66.3602 114.966 67.4162C114.966 67.9145 114.549 68.3402 113.696 68.3402C113.272 68.3513 112.854 68.2426 112.489 68.0267Z"
          fill="white"
        />
        <path
          id="Vector_67"
          d="M115.908 66.0615H115.028V65.418H117.594V66.0615H116.725V68.2824H115.915L115.908 66.0615Z"
          fill="white"
        />
      </g>
      <g id="freepik--character-2--inject-4">
        <path
          id="Vector_68"
          d="M203.509 17.599C202.789 17.498 202.055 17.5871 201.381 17.8576C200.707 18.128 200.116 18.5702 199.666 19.1401C199.162 19.029 198.635 19.0658 198.151 19.246C197.667 19.4263 197.245 19.7424 196.937 20.1562C196.628 20.57 196.446 21.064 196.413 21.5787C196.379 22.0933 196.495 22.6068 196.746 23.0572C196.377 23.3193 196.073 23.6621 195.857 24.0593C195.641 24.4565 195.518 24.8977 195.499 25.3494C195.479 25.801 195.563 26.2511 195.745 26.6654C195.926 27.0796 196.2 27.4472 196.545 27.7399L206.726 20.2093C206.466 19.5311 206.032 18.9329 205.467 18.4748C204.902 18.0167 204.227 17.7147 203.509 17.599Z"
          fill="#263238"
        />
        <path
          id="Vector_69"
          d="M196.468 28.2252C196.807 25.6411 198.108 23.2791 200.113 21.6096C202.118 19.94 204.68 19.0855 207.288 19.2162L207.824 19.2426C213.6 19.8663 216.299 25.1133 215.512 30.8586L213.713 50.0745L213.617 51.0084L200.112 53.0214L200.377 48.111C200.377 48.111 194.848 46.9725 195.057 41.4087C195.156 38.7225 195.814 33.2082 196.468 28.2252Z"
          fill="#AE7461"
        />
        <path
          id="Vector_70"
          d="M200.331 48.1008C202.918 48.2301 205.487 47.6163 207.735 46.332C207.735 46.332 205.82 50.2458 200.288 49.4703L200.331 48.1008Z"
          fill="#6F4439"
        />
        <path
          id="Vector_71"
          d="M197.954 33.3569C197.941 33.5637 198.009 33.7673 198.144 33.9244C198.28 34.0816 198.471 34.1799 198.678 34.1984C198.778 34.2113 198.879 34.2045 198.976 34.1784C199.073 34.1522 199.164 34.1071 199.243 34.0458C199.323 33.9845 199.39 33.9081 199.439 33.821C199.489 33.734 199.522 33.6379 199.534 33.5384C199.545 33.4337 199.535 33.3279 199.504 33.2272C199.474 33.1265 199.423 33.033 199.356 32.9521C199.288 32.8712 199.205 32.8046 199.111 32.7563C199.018 32.7079 198.915 32.6787 198.81 32.6705C198.708 32.6572 198.605 32.6646 198.506 32.6922C198.407 32.7198 198.315 32.7671 198.235 32.8313C198.155 32.8954 198.089 32.975 198.041 33.0654C197.992 33.1557 197.963 33.2549 197.954 33.3569Z"
          fill="#263238"
        />
        <path
          id="Vector_72"
          d="M197.53 31.0014C197.623 31.1103 198.248 30.6945 199.104 30.7407C199.961 30.7869 200.566 31.2423 200.665 31.1433C200.711 31.1004 200.622 30.909 200.358 30.6945C200 30.42 199.565 30.2632 199.114 30.2457C198.67 30.2199 198.229 30.3355 197.855 30.5757C197.583 30.7704 197.484 30.9552 197.53 31.0014Z"
          fill="#263238"
        />
        <path
          id="Vector_73"
          d="M205.919 33.9899C205.907 34.1963 205.975 34.3996 206.111 34.5562C206.246 34.7128 206.437 34.8104 206.644 34.8281C206.743 34.8411 206.845 34.8343 206.942 34.8081C207.039 34.7819 207.13 34.7369 207.209 34.6756C207.289 34.6142 207.355 34.5379 207.405 34.4508C207.455 34.3637 207.487 34.2677 207.5 34.1681C207.512 33.961 207.443 33.7574 207.307 33.6004C207.171 33.4433 206.98 33.3451 206.773 33.3266C206.673 33.3137 206.572 33.3207 206.475 33.3471C206.377 33.3735 206.287 33.4189 206.207 33.4806C206.128 33.5423 206.062 33.619 206.012 33.7065C205.963 33.7939 205.931 33.8902 205.919 33.9899Z"
          fill="#263238"
        />
        <path
          id="Vector_74"
          d="M205.936 31.579C206.028 31.6879 206.653 31.2721 207.51 31.3183C208.366 31.3645 208.971 31.8199 209.071 31.7209C209.117 31.6747 209.028 31.4833 208.763 31.2721C208.404 30.9983 207.971 30.8405 207.52 30.82C207.075 30.7941 206.634 30.9097 206.26 31.15C206.005 31.3513 205.889 31.5295 205.936 31.579Z"
          fill="#263238"
        />
        <path
          id="Vector_75"
          d="M202.514 37.7587C202.514 37.7092 201.994 37.5904 201.138 37.4287C200.92 37.3957 200.715 37.3429 200.685 37.1911C200.678 36.9647 200.741 36.7415 200.863 36.5509L201.591 34.924C202.606 32.614 203.353 30.6901 203.261 30.634C203.168 30.5779 202.269 32.4424 201.25 34.7623L200.549 36.4123C200.388 36.6749 200.33 36.9872 200.384 37.2901C200.412 37.3659 200.455 37.4348 200.513 37.4918C200.57 37.5488 200.639 37.5926 200.715 37.6201C200.833 37.6599 200.957 37.6832 201.082 37.6894C201.971 37.7752 202.507 37.8049 202.514 37.7587Z"
          fill="#263238"
        />
        <path
          id="Vector_76"
          d="M205.013 38.4766C204.874 38.4766 204.825 39.3874 203.998 40.0078C203.171 40.6282 202.186 40.4731 202.173 40.6018C202.173 40.6612 202.384 40.7932 202.801 40.8262C203.345 40.861 203.884 40.7032 204.322 40.3807C204.743 40.0701 205.028 39.6089 205.116 39.0937C205.159 38.7076 205.066 38.4733 205.013 38.4766Z"
          fill="#263238"
        />
        <path
          id="Vector_77"
          d="M205.88 28.2193C205.953 28.4569 206.816 28.3876 207.811 28.5493C208.806 28.711 209.61 29.0344 209.752 28.8331C209.818 28.7341 209.686 28.5031 209.372 28.2688C208.95 27.9676 208.463 27.7698 207.95 27.6913C207.44 27.6035 206.916 27.6397 206.422 27.7969C206.045 27.9355 205.85 28.1071 205.88 28.2193Z"
          fill="#263238"
        />
        <path
          id="Vector_78"
          d="M197.967 28.5449C198.109 28.7462 198.707 28.5746 199.418 28.601C200.129 28.6274 200.721 28.7957 200.87 28.601C200.936 28.5053 200.85 28.3073 200.595 28.1126C200.26 27.8628 199.853 27.7253 199.435 27.7199C199.018 27.7057 198.606 27.821 198.258 28.0499C198 28.2512 197.907 28.4459 197.967 28.5449Z"
          fill="#263238"
        />
        <path
          id="Vector_79"
          d="M197.13 25.7003C197.13 25.7003 198.783 22.2914 200.496 21.5621C202.579 20.681 203.346 22.9547 205.314 22.5092C207.281 22.0637 209.282 21.2156 211.18 22.8128C213.27 24.5585 212.195 25.6574 212.205 28.1291C212.251 38.1545 213.941 41.075 214.695 36.3791C214.778 35.8676 216.233 35.5277 216.553 33.3596C216.97 30.5447 217.251 27.1193 216.719 25.0799C216.269 23.3639 215.363 22.1462 213.693 20.7734C211.048 18.6053 207.308 18.3743 204.742 18.5063C202.176 18.6383 197.117 21.3311 197.13 25.7003Z"
          fill="#263238"
        />
        <path
          id="Vector_80"
          d="M214.348 36.2212C214.365 36.0177 214.424 35.8198 214.519 35.6394C214.615 35.459 214.747 35.2999 214.906 35.1716C215.065 35.0433 215.248 34.9485 215.445 34.893C215.642 34.8374 215.848 34.8222 216.051 34.8484C217.086 35.0002 218.214 35.6437 218.035 37.7821C217.724 41.5771 213.971 40.4848 213.975 40.3726C213.978 40.2604 214.203 37.8085 214.348 36.2212Z"
          fill="#AE7461"
        />
        <path
          id="Vector_81"
          d="M214.933 39.0152C214.953 39.0152 214.996 39.068 215.105 39.1274C215.256 39.2081 215.433 39.227 215.598 39.1802C216.011 39.0647 216.401 38.4575 216.478 37.7744C216.512 37.4491 216.475 37.1202 216.368 36.8108C216.343 36.6895 216.287 36.5762 216.208 36.4807C216.129 36.3853 216.027 36.3106 215.912 36.263C215.837 36.2351 215.755 36.2351 215.68 36.263C215.606 36.2909 215.543 36.3448 215.505 36.4148C215.446 36.5171 215.466 36.593 215.446 36.5996C215.426 36.6062 215.367 36.527 215.413 36.3752C215.44 36.2817 215.5 36.201 215.581 36.1475C215.693 36.0777 215.827 36.054 215.955 36.0815C216.11 36.1261 216.251 36.2105 216.364 36.3262C216.476 36.442 216.557 36.5852 216.597 36.7415C216.734 37.0826 216.784 37.4522 216.742 37.8173C216.653 38.5829 216.203 39.266 215.641 39.3782C215.536 39.4002 215.428 39.3982 215.325 39.3725C215.221 39.3468 215.125 39.298 215.042 39.2297C214.933 39.1076 214.907 39.0218 214.933 39.0152Z"
          fill="#6F4439"
        />
        <path
          id="Vector_82"
          d="M215.783 29.8006C215.259 30.1827 214.647 30.4277 214.004 30.5134C213.343 30.5464 212.642 30.1405 212.566 29.5003C212.529 29.2132 212.615 28.8865 212.44 28.6555C212.265 28.4245 211.808 28.4443 211.448 28.4641C210.843 28.4814 210.25 28.2909 209.769 27.9246C209.287 27.5582 208.946 27.0381 208.803 26.4511C208.472 26.8933 207.768 26.8372 207.321 26.5171C206.875 26.197 206.604 25.6987 206.263 25.2697C205.923 24.8407 205.433 24.4447 204.888 24.4942C204.583 24.5239 204.289 24.6889 203.985 24.646C203.449 24.5734 203.218 23.9299 203.161 23.392C203.105 22.8541 203.072 22.2271 202.632 21.9136C202.193 21.6001 201.667 21.7519 201.164 21.8014C200.662 21.8509 200.03 21.7024 199.928 21.2107C199.913 21.0795 199.926 20.9468 199.964 20.8205C200.002 20.6941 200.065 20.5766 200.149 20.4748C200.509 19.9912 201.022 19.6438 201.606 19.4897C202.189 19.3356 202.808 19.3839 203.36 19.6267C203.606 18.9608 204.04 18.3799 204.609 17.9538C205.178 17.5277 205.858 17.2744 206.567 17.2243C207.979 17.1451 209.295 16.7425 209.91 18.0163C210.816 17.2738 212.202 18.2473 213.333 18.5641C213.897 18.7279 214.415 19.0226 214.844 19.424C215.272 19.8255 215.6 20.3223 215.8 20.8741C216.31 20.762 216.843 20.8036 217.33 20.9936C217.818 21.1835 218.237 21.5134 218.537 21.9415C218.836 22.3695 219.002 22.8766 219.012 23.3985C219.023 23.9204 218.879 24.4338 218.597 24.8737C219.315 25.3291 219.92 26.0947 219.883 26.9428C219.847 27.7909 218.987 28.5928 218.177 28.3321C218.308 28.6717 218.308 29.0478 218.178 29.3874C218.047 29.7271 217.794 30.0062 217.469 30.1706C217.143 30.335 216.769 30.373 216.417 30.2772C216.065 30.1814 215.761 29.9587 215.565 29.6521"
          fill="#263238"
        />
        <path
          id="Vector_83"
          d="M225.991 83.1608L237.234 80.7386C237.234 80.7386 235.693 72.2972 233.775 63.737C232.244 56.9093 224.685 55.0151 224.685 55.0151L215.925 51.1508L214.745 46.6133C209.93 48.9893 205.258 51.2762 202.441 52.4213L199.862 49.5767L198.767 52.9922L197.845 53.0879C197.845 53.0879 194.032 54.2429 193.648 54.2726C190.16 54.5498 185.61 58.4471 183.907 62.5226C183.203 64.2089 180.475 74.2937 178.477 84.7349C177.029 92.2886 176.192 99.6212 175.832 100.614L187.075 100.638L189.667 84.7349L190.428 100.727L228.696 100.608L225.974 84.5369L225.991 83.1608Z"
          fill="#F37032"
        />
        <path
          id="Vector_84"
          d="M187.991 65.9453C187.958 65.9453 188.275 70.1561 188.702 75.3437C189.128 80.5313 189.502 84.7355 189.538 84.7322C189.575 84.7289 189.254 80.5214 188.827 75.3338C188.401 70.1462 188.027 65.942 187.991 65.9453Z"
          fill="#263238"
        />
        <path
          id="Vector_85"
          d="M215.926 51.2933L204.547 56.9957L202.428 52.3757C202.428 52.3757 206.237 50.7257 209.702 48.8975C213.237 47.0165 214.613 46.6172 214.613 46.6172"
          fill="#E0E0E0"
        />
        <path
          id="Vector_86"
          d="M199.739 49.582L202.318 52.4233L199.994 56.5615L198.645 52.9975"
          fill="#E0E0E0"
        />
        <path
          id="Vector_87"
          d="M227.131 56.5977C227.151 56.6208 226.774 56.9277 226.242 57.459C224.853 58.8912 223.89 60.6803 223.461 62.6268C223.299 63.3693 223.259 63.8412 223.229 63.8412C223.214 63.7317 223.214 63.6206 223.229 63.5112C223.246 63.2077 223.282 62.9056 223.339 62.607C223.702 60.611 224.688 58.7805 226.156 57.3765C226.374 57.1644 226.606 56.9671 226.85 56.7858C226.933 56.7085 227.028 56.645 227.131 56.5977Z"
          fill="#263238"
        />
        <path
          id="Vector_88"
          d="M202.44 52.375C202.464 52.375 202.189 52.8106 201.779 53.5036C201.369 54.1966 200.813 55.1734 200.288 56.2888C200.245 56.3812 200.205 56.4736 200.165 56.5561L200.083 56.7343L200 56.5594C199.57 55.6622 199.201 54.7372 198.896 53.7907C198.783 53.431 198.701 53.1307 198.651 52.9327C198.614 52.8265 198.595 52.715 198.595 52.6027C198.618 52.6027 198.76 53.035 199.015 53.7445C199.269 54.454 199.653 55.4209 200.155 56.4736H199.993L200.116 56.203C200.567 55.2435 201.084 54.3162 201.663 53.4277C201.885 53.0977 202.077 52.8172 202.212 52.6357C202.276 52.5389 202.353 52.4513 202.44 52.375Z"
          fill="#263238"
        />
        <path
          id="Vector_89"
          d="M214.934 51.8125C214.879 51.8299 214.826 51.852 214.775 51.8785L214.335 52.0864L212.731 52.8685L207.441 55.492L204.537 56.9506L204.617 56.9803L203.069 53.6605C202.881 53.2645 202.739 52.9477 202.616 52.7167L202.494 52.4659C202.481 52.4364 202.464 52.4087 202.444 52.3834C202.45 52.4158 202.461 52.447 202.477 52.4758L202.583 52.7299L203.006 53.6902C203.38 54.5185 203.903 55.6702 204.511 57.0265L204.537 57.0793L204.59 57.0529L207.497 55.6042L212.758 52.9477L214.345 52.1293L214.775 51.9016C214.831 51.8788 214.885 51.8488 214.934 51.8125Z"
          fill="#263238"
        />
        <path
          id="Vector_90"
          d="M236.003 74.9453C236.003 74.9453 238.338 86.2016 238.526 88.8053C238.9 93.9038 236.45 96.9596 234.138 98.4083C231.738 99.9098 218.19 100.619 218.19 100.619L217.37 92.5343L226.176 87.2114L224.982 77.9978L236.003 74.9453Z"
          fill="#F37032"
        />
        <path
          id="Vector_91"
          d="M226.126 86.9019C226.125 86.84 226.119 86.7783 226.11 86.7171C226.09 86.5851 226.067 86.4102 226.034 86.1891C225.964 85.7172 225.865 85.0572 225.743 84.2487C225.482 82.5987 225.128 80.3415 224.734 77.85C223.961 72.9759 223.412 69.4647 223.299 68.8047C223.293 68.8662 223.293 68.928 223.299 68.9895C223.299 69.1149 223.329 69.2931 223.355 69.5208C223.412 69.9828 223.504 70.6461 223.623 71.4678C223.861 73.1178 224.209 75.3717 224.615 77.8698C225.022 80.3679 225.382 82.6284 225.66 84.2619C225.796 85.0671 225.912 85.7271 225.991 86.1957C226.031 86.4135 226.064 86.5884 226.087 86.7204C226.094 86.782 226.108 86.8428 226.126 86.9019Z"
          fill="#263238"
        />
        <path
          id="Vector_92"
          d="M234.866 97.9387C234.841 97.9538 234.818 97.9715 234.797 97.9915C234.737 98.0491 234.67 98.099 234.598 98.14C234.324 98.3099 234.029 98.4461 233.722 98.5459C232.584 98.9176 231.417 99.1936 230.234 99.3709C226.244 99.9953 222.222 100.388 218.187 100.546L218.254 100.599C218.171 99.8032 218.088 98.9485 217.999 98.1103C217.801 96.1501 217.609 94.2592 217.43 92.5168L217.4 92.5729L225.935 87.4282L228.398 85.93L229.06 85.5241L229.225 85.4185L229.281 85.3789C229.281 85.3789 229.261 85.3789 229.222 85.4086L229.047 85.5076L228.385 85.8937L225.902 87.3655L217.348 92.4706L217.314 92.4904V92.5267C217.49 94.2724 217.681 96.1567 217.88 98.1367C217.966 98.9881 218.052 99.8296 218.134 100.625V100.684H218.191C222.229 100.524 226.254 100.119 230.244 99.4699C231.43 99.2827 232.599 98.9935 233.735 98.6053C234.043 98.4996 234.337 98.3555 234.608 98.1763C234.679 98.1308 234.744 98.0777 234.803 98.0179C234.827 97.9936 234.848 97.9671 234.866 97.9387Z"
          fill="#263238"
        />
        <g id="Group" opacity="0.3">
          <path
            id="Vector_93"
            d="M232.128 83.8732C232.045 83.7702 231.928 83.701 231.797 83.6785C231.136 83.53 230.475 83.7676 229.873 84.0448C228.052 84.9144 226.457 86.193 225.214 87.7804L225.366 87.6946C227.429 86.4769 229.255 85.2427 231.467 84.6553C231.666 84.6182 231.855 84.5371 232.019 84.4177C232.098 84.3538 232.152 84.2644 232.172 84.1651C232.192 84.0657 232.176 83.9625 232.128 83.8732Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_94"
          d="M217.492 93.0246L216.352 93.1302C216.352 93.1302 216.203 91.4802 215.945 90.84C215.687 90.1998 215.204 88.2198 215.204 88.2198C215.204 88.2198 210.102 86.0781 209.99 86.0781C209.877 86.0781 204.887 87.4509 204.887 87.4509C204.887 87.4509 205 88.8138 206.7 88.8897C207.717 88.9346 208.736 88.8481 209.732 88.6323L211.322 89.223L208.141 89.4243L202.56 92.7639C202.56 92.7639 202.596 93.7539 204.778 93.2424C206.961 92.7309 208.085 91.8036 208.085 91.8036L212.189 92.4009L207.847 92.6055L204.593 94.2291C204.593 94.2291 204.62 95.5755 205.952 95.2422C207.285 94.9089 208.178 94.7109 208.178 94.7109L212.06 95.1696L208.769 95.3511C208.769 95.3511 206.551 95.4105 206.663 96.0111C206.776 96.6117 208.402 97.1166 208.402 97.1166L210.717 97.5258C210.717 97.5258 210.803 98.5587 211.21 98.8887C211.617 99.2187 212.245 99.684 212.615 99.6906C212.985 99.6972 218.197 99.9744 218.197 99.9744L217.492 93.0246Z"
          fill="#AE7461"
        />
        <path
          id="Vector_95"
          d="M214.649 98.0659C214.72 98.0307 214.787 97.9875 214.848 97.9372C215.016 97.8056 215.17 97.6574 215.307 97.495C215.767 96.9495 216.058 96.2821 216.144 95.5744C216.191 95.1858 216.173 94.7923 216.091 94.4095C216.015 94.0597 215.893 93.7495 215.856 93.502C215.82 93.2976 215.838 93.0875 215.906 92.8915C215.935 92.8206 215.969 92.7512 216.005 92.6836C215.943 92.734 215.895 92.8 215.866 92.875C215.778 93.0749 215.748 93.2958 215.78 93.5119C215.807 93.7858 215.922 94.0894 215.992 94.4326C216.065 94.8043 216.08 95.1851 216.035 95.5612C215.95 96.2492 215.677 96.9008 215.248 97.4455C215.062 97.6651 214.862 97.8724 214.649 98.0659Z"
          fill="#6F4439"
        />
        <path
          id="Vector_96"
          d="M214.02 97.6813C213.457 97.6064 212.889 97.5678 212.321 97.5658C211.755 97.5302 211.187 97.5302 210.621 97.5658C211.183 97.6408 211.75 97.6794 212.317 97.6813C212.884 97.7169 213.453 97.7169 214.02 97.6813Z"
          fill="#6F4439"
        />
        <path
          id="Vector_97"
          d="M213.769 95.2306C213.471 95.1807 213.168 95.1674 212.866 95.191C212.565 95.1769 212.263 95.1991 211.967 95.257C212.264 95.3092 212.566 95.3236 212.866 95.2999C213.169 95.3136 213.472 95.2904 213.769 95.2306Z"
          fill="#6F4439"
        />
        <path
          id="Vector_98"
          d="M213.941 89.5387C213.941 89.5057 213.376 89.6014 212.685 89.5387C211.993 89.476 211.461 89.2714 211.451 89.3044C211.83 89.5026 212.247 89.6153 212.675 89.6344C213.099 89.6938 213.531 89.6611 213.941 89.5387Z"
          fill="#6F4439"
        />
        <path
          id="Vector_99"
          d="M165.995 76.666L170.882 100.611H213.306C213.531 100.611 213.747 100.522 213.906 100.364C214.065 100.205 214.155 99.9904 214.156 99.766C214.156 99.5411 214.067 99.3254 213.907 99.1663C213.748 99.0073 213.532 98.9179 213.306 98.9179H204.769L200.235 76.6495C200.193 76.4424 200.082 76.2559 199.918 76.1213C199.755 75.9867 199.551 75.9122 199.339 75.9103L166.917 75.5704C166.78 75.5685 166.644 75.5971 166.519 75.6541C166.394 75.711 166.284 75.795 166.196 75.8999C166.107 76.0047 166.043 76.1279 166.009 76.2604C165.974 76.3929 165.969 76.5314 165.995 76.666Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_100"
          d="M165.995 76.6668C165.993 76.6426 165.993 76.6183 165.995 76.5942C165.984 76.522 165.984 76.4486 165.995 76.3764C166.011 76.233 166.059 76.0953 166.137 75.9739C166.215 75.8525 166.321 75.7508 166.445 75.6768C166.532 75.6253 166.627 75.5885 166.726 75.5679C166.835 75.5469 166.946 75.5391 167.056 75.5448H167.82L169.728 75.5613L181.986 75.6768L190.53 75.7626L195.318 75.8121L197.831 75.8385H199.114C199.224 75.8385 199.326 75.8385 199.445 75.8385C199.56 75.8517 199.672 75.8841 199.776 75.9342C199.984 76.0375 200.149 76.2103 200.242 76.4226C200.282 76.5294 200.312 76.6399 200.331 76.7526L200.397 77.0826C200.44 77.2971 200.483 77.5116 200.53 77.7426C200.616 78.1749 200.705 78.6105 200.794 79.0626C200.973 79.9426 201.154 80.8303 201.337 81.7257C201.705 83.5231 202.079 85.3612 202.461 87.24C203.228 90.9921 204.022 94.8993 204.842 98.922L204.785 98.8758H213.181C213.292 98.8694 213.403 98.876 213.512 98.8956C213.738 98.9431 213.936 99.0754 214.067 99.2652C214.142 99.3698 214.193 99.4889 214.217 99.6148C214.242 99.7407 214.24 99.8703 214.21 99.9951C214.181 100.12 214.125 100.237 214.047 100.339C213.969 100.441 213.87 100.525 213.756 100.585C213.633 100.65 213.496 100.686 213.356 100.691H190.795H170.879H170.842V100.654C169.351 93.2922 168.134 87.306 167.291 83.1645L166.326 78.3399C166.216 77.7954 166.134 77.3763 166.078 77.0925C166.021 76.8087 165.998 76.6668 165.998 76.6668C165.998 76.6668 166.031 76.8087 166.091 77.0892C166.15 77.3697 166.236 77.7888 166.352 78.3366C166.577 79.4322 166.911 81.0426 167.344 83.115C168.197 87.2631 169.424 93.246 170.935 100.605L170.892 100.569H190.808H213.34C213.461 100.563 213.58 100.531 213.687 100.473C213.783 100.419 213.867 100.345 213.933 100.257C213.999 100.168 214.046 100.067 214.07 99.9588C214.094 99.8511 214.095 99.7395 214.073 99.6314C214.051 99.5232 214.006 99.4209 213.942 99.3312C213.828 99.1645 213.656 99.0467 213.459 99.0012C213.357 98.9854 213.254 98.9799 213.151 98.9847H204.719V98.9385C203.899 94.9158 203.106 91.0185 202.342 87.2565L201.224 81.7422C201.043 80.8402 200.863 79.9514 200.682 79.0758C200.593 78.6369 200.503 78.2013 200.417 77.7558C200.374 77.5413 200.328 77.3235 200.285 77.0958L200.219 76.7658C200.204 76.6615 200.177 76.5595 200.136 76.4622C200.055 76.2725 199.908 76.1181 199.723 76.0266C199.631 75.9802 199.531 75.9511 199.429 75.9408C199.329 75.9408 199.217 75.9408 199.098 75.9408L197.815 75.9243L195.305 75.8946L190.517 75.8418L181.973 75.7395L169.715 75.591L167.804 75.5646H167.043C166.933 75.5591 166.822 75.5658 166.712 75.5844C166.524 75.6234 166.354 75.7207 166.224 75.8623C166.095 76.0039 166.013 76.1826 165.992 76.3731C165.978 76.4706 165.979 76.5695 165.995 76.6668Z"
          fill="#263238"
        />
        <path
          id="Vector_101"
          d="M185.547 87.6258C185.547 87.9025 185.465 88.173 185.311 88.4031C185.157 88.6332 184.938 88.8125 184.682 88.9185C184.426 89.0244 184.144 89.0521 183.872 88.9981C183.6 88.9441 183.35 88.8108 183.154 88.6151C182.958 88.4195 182.824 88.1702 182.77 87.8987C182.716 87.6273 182.744 87.346 182.85 87.0903C182.956 86.8346 183.136 86.6161 183.366 86.4624C183.597 86.3086 183.868 86.2266 184.145 86.2266C184.329 86.2261 184.512 86.262 184.682 86.3322C184.853 86.4024 185.007 86.5054 185.138 86.6354C185.268 86.7654 185.371 86.9198 185.441 87.0898C185.512 87.2598 185.548 87.4419 185.547 87.6258Z"
          fill="white"
        />
        <path
          id="Vector_102"
          d="M166.041 76.8633H166.186H168.263L174.331 76.893L194.339 77.0349L197.233 77.058H197.944C198.065 77.0544 198.187 77.0621 198.307 77.0811C198.425 77.1079 198.537 77.1548 198.638 77.2197C198.85 77.3532 199.004 77.5619 199.068 77.8038C199.121 78.0381 199.161 78.2592 199.21 78.4869C199.567 80.2887 199.915 82.0311 200.242 83.6877C200.903 86.9877 201.492 89.9874 201.988 92.4954C202.484 95.0034 202.877 97.0296 203.152 98.4354L203.482 100.052C203.515 100.234 203.542 100.382 203.558 100.471C203.575 100.561 203.582 100.617 203.582 100.617C203.582 100.617 203.582 100.567 203.549 100.475C203.515 100.382 203.496 100.237 203.459 100.056C203.38 99.6828 203.267 99.1416 203.129 98.4453C202.844 97.0395 202.434 95.0133 201.925 92.5053C201.416 89.9973 200.824 87.0141 200.156 83.7009C199.825 82.0509 199.495 80.3052 199.114 78.5034C199.071 78.279 199.028 78.0447 198.979 77.8434C198.921 77.6293 198.784 77.4452 198.595 77.3286C198.503 77.2684 198.399 77.2269 198.291 77.2065C198.182 77.1871 198.071 77.1805 197.96 77.1867H197.249L194.356 77.1636L174.344 76.9887L168.28 76.9227L166.626 76.8996H166.2L166.041 76.8633Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--character-1--inject-4">
        <path
          id="Vector_103"
          d="M31.0205 89.6602C30.9702 91.9378 31.4038 94.2002 32.2929 96.2985C33.1821 98.3968 34.5065 100.283 36.1789 101.834C36.9461 99.6141 37.7176 97.3931 38.4936 95.1711"
          fill="#263238"
        />
        <path
          id="Vector_104"
          d="M48.3963 76.4059C46.4123 75.3268 44.0282 75.1717 41.8161 75.6139C39.6039 76.0561 37.5439 77.0527 35.5929 78.1813C34.4984 78.8116 33.4072 79.5013 32.6169 80.4913C31.1785 82.2931 29.76 85.2565 29.6211 87.5566C29.5087 89.4178 30.2229 94.0741 31.0099 95.7604C31.7341 97.3114 35.1168 98.4928 36.7866 98.8756L52.1097 81.0919C51.8325 80.1043 51.3615 79.1816 50.724 78.3772C50.0865 77.5728 49.2954 76.9027 48.3963 76.4059Z"
          fill="#263238"
        />
        <path
          id="Vector_105"
          d="M51.0389 78.8045L47.3652 78.1445C49.3724 82.9163 49.918 93.8294 51.0654 98.8784C52.4211 96.9182 55.5658 90.9584 55.3971 88.5692C55.2285 86.18 55.4037 78.3986 51.0389 78.8045Z"
          fill="#263238"
        />
        <path
          id="Vector_106"
          d="M33.623 86.7488C33.6902 85.4087 34.1865 84.1254 35.0388 83.0877C35.8912 82.05 37.0546 81.3125 38.3581 80.9837L46.8166 78.8288C50.4704 78.4361 52.9141 82.9241 53.1521 86.5838C53.4167 90.6527 53.582 94.946 53.1059 97.982C52.1469 104.09 47.4614 104.876 47.4614 104.876C47.4614 104.876 47.4614 107.78 47.4614 109.565L44.6309 121.257L35.5078 108.684L33.6197 86.8214C33.5998 86.7191 33.6131 86.8874 33.623 86.7488Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_107"
          d="M51.3005 91.1978C51.3032 91.4019 51.2259 91.599 51.0851 91.747C50.9442 91.8949 50.751 91.9821 50.5466 91.9898C50.4469 91.9979 50.3466 91.986 50.2516 91.9549C50.1566 91.9238 50.0688 91.874 49.9933 91.8085C49.9178 91.743 49.8562 91.6632 49.8121 91.5736C49.768 91.484 49.7423 91.3865 49.7364 91.2869C49.7329 91.0826 49.8099 90.885 49.9509 90.7369C50.092 90.5887 50.2857 90.5018 50.4904 90.4949C50.5901 90.4864 50.6906 90.4979 50.7858 90.5289C50.881 90.5598 50.969 90.6096 51.0446 90.6752C51.1202 90.7407 51.1818 90.8208 51.2257 90.9106C51.2697 91.0003 51.2951 91.098 51.3005 91.1978Z"
          fill="#263238"
        />
        <path
          id="Vector_108"
          d="M52.2195 88.976C52.1236 89.0783 51.5284 88.646 50.6852 88.646C49.842 88.646 49.2203 89.0717 49.131 88.976C49.0847 88.9298 49.1839 88.745 49.4617 88.5503C49.8255 88.295 50.2603 88.1599 50.705 88.1642C51.1438 88.1615 51.5722 88.2978 51.9285 88.5536C52.1798 88.745 52.2691 88.9298 52.2195 88.976Z"
          fill="#263238"
        />
        <path
          id="Vector_109"
          d="M43.9431 91.1976C43.9458 91.4016 43.8685 91.5987 43.7276 91.7467C43.5868 91.8947 43.3935 91.9818 43.1892 91.9895C43.0894 91.9981 42.9889 91.9865 42.8937 91.9556C42.7985 91.9246 42.7105 91.8749 42.6349 91.8093C42.5594 91.7437 42.4978 91.6637 42.4538 91.5739C42.4098 91.4841 42.3844 91.3864 42.379 91.2866C42.3754 91.0823 42.4525 90.8848 42.5935 90.7366C42.7345 90.5884 42.9283 90.5015 43.1329 90.4946C43.2326 90.4866 43.3329 90.4984 43.4279 90.5296C43.5229 90.5607 43.6108 90.6105 43.6862 90.676C43.7617 90.7414 43.8233 90.8213 43.8674 90.9109C43.9115 91.0005 43.9372 91.0979 43.9431 91.1976Z"
          fill="#263238"
        />
        <path
          id="Vector_110"
          d="M44.2041 88.976C44.1049 89.0783 43.5097 88.646 42.6665 88.646C41.8233 88.646 41.205 89.0717 41.1124 88.976C41.0694 88.9298 41.1653 88.745 41.443 88.5503C41.8066 88.2946 42.2416 88.1595 42.6863 88.1642C43.1252 88.1615 43.5536 88.2978 43.9098 88.5536C44.1611 88.745 44.2504 88.9298 44.2041 88.976Z"
          fill="#263238"
        />
        <path
          id="Vector_111"
          d="M46.8429 95.5904C46.8429 95.5442 47.3621 95.4518 48.2119 95.3396C48.4301 95.3165 48.6318 95.2736 48.6682 95.1284C48.6857 94.9063 48.635 94.6841 48.5227 94.4915C48.3199 93.9701 48.1061 93.4201 47.8812 92.8415C46.9917 90.5117 46.3469 88.5944 46.4395 88.5515C46.5321 88.5086 47.3323 90.3797 48.2251 92.7095C48.4367 93.2837 48.6451 93.8315 48.8368 94.3595C48.9737 94.6176 49.0147 94.9157 48.9526 95.201C48.9233 95.2796 48.876 95.3503 48.8146 95.4076C48.7532 95.4649 48.6793 95.5071 48.5988 95.531C48.4792 95.5641 48.3558 95.5818 48.2317 95.5838C47.3753 95.6333 46.8462 95.6399 46.8429 95.5904Z"
          fill="#263238"
        />
        <path
          id="Vector_112"
          d="M39.3496 102.703C39.3496 102.703 41.3336 106.897 47.4609 106.31V104.875C44.6079 104.913 41.8 104.162 39.3496 102.703Z"
          fill="#EB996E"
        />
        <path
          id="Vector_113"
          d="M43.9394 85.9321C43.8567 86.1598 43.0135 86.0542 42.0215 86.1763C41.0295 86.2984 40.2326 86.5657 40.1004 86.3611C40.0408 86.2654 40.1797 86.0476 40.5038 85.8265C40.9302 85.5471 41.418 85.375 41.9256 85.3249C42.4326 85.2626 42.9471 85.3214 43.4269 85.4965C43.7906 85.6417 43.9791 85.8232 43.9394 85.9321Z"
          fill="#263238"
        />
        <path
          id="Vector_114"
          d="M51.9446 86.3987C51.7958 86.5901 51.2139 86.3987 50.5162 86.3987C49.8185 86.3987 49.2233 86.5307 49.0877 86.3294C49.0282 86.2337 49.1208 86.0423 49.3787 85.8608C49.727 85.6399 50.1336 85.5281 50.5461 85.5399C50.9587 85.5517 51.3582 85.6864 51.6933 85.9268C51.9149 86.1083 52.0108 86.3063 51.9446 86.3987Z"
          fill="#263238"
        />
        <path
          id="Vector_115"
          d="M51.4751 81.009C51.1015 80.0916 50.093 79.5372 49.101 79.4877C48.1005 79.4877 47.1208 79.7728 46.2771 80.3094C42.6397 82.4115 40.7648 87.4869 37.1639 89.6616C36.2777 90.1962 35.127 89.7045 34.3731 90.414C33.6191 91.1235 33.1331 92.2554 33.5497 93.1992C33.0321 92.5574 32.6111 91.8437 32.2998 91.0806C32.1455 90.6997 32.0748 90.2903 32.0925 89.8799C32.1102 89.4694 32.2158 89.0676 32.4023 88.7013C32.7131 88.1634 33.262 87.7509 33.4141 87.1503C33.5464 86.619 33.3348 86.0646 33.3579 85.5168C33.4198 84.9607 33.6124 84.427 33.92 83.9592C35.3287 81.471 37.2697 79.2204 39.7662 77.8212C41.3969 76.8812 43.2534 76.402 45.1363 76.4352C47.0255 76.4794 48.8366 77.197 50.2418 78.4581C51.0486 79.2072 51.8951 79.9827 51.4751 80.9991"
          fill="#263238"
        />
        <path
          id="Vector_116"
          d="M34.4624 91.1705C34.3962 90.9956 31.2053 89.8505 31.1557 93.233C31.1127 96.533 34.4392 95.873 34.4624 95.7773C34.4855 95.6816 34.4624 91.1705 34.4624 91.1705Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_117"
          d="M33.4504 94.5218C33.4504 94.5218 33.3909 94.5614 33.295 94.6043C33.1571 94.6601 33.0029 94.6601 32.8651 94.6043C32.5344 94.4756 32.2302 93.9212 32.2038 93.3272C32.1974 93.0452 32.2551 92.7655 32.3724 92.5088C32.4053 92.4038 32.4639 92.3086 32.543 92.232C32.6222 92.1553 32.7192 92.0996 32.8254 92.0699C32.8907 92.0553 32.9591 92.0634 33.0192 92.0928C33.0793 92.1222 33.1276 92.1712 33.1561 92.2316C33.1991 92.324 33.1759 92.39 33.1924 92.3933C33.209 92.3966 33.2652 92.3405 33.2387 92.2052C33.222 92.1236 33.1776 92.0502 33.1131 91.9973C33.0669 91.9611 33.0136 91.9347 32.9567 91.9199C32.8998 91.9052 32.8405 91.9023 32.7824 91.9115C32.6468 91.9361 32.5199 91.9951 32.4138 92.083C32.3078 92.1709 32.2263 92.2846 32.1773 92.4131C32.0355 92.6968 31.9641 93.0103 31.969 93.3272C31.9855 93.9872 32.3195 94.6142 32.7957 94.7561C32.8838 94.783 32.977 94.7896 33.068 94.7753C33.1591 94.761 33.2458 94.7262 33.3214 94.6736C33.4438 94.601 33.4603 94.5284 33.4504 94.5218Z"
          fill="#EB996E"
        />
        <path
          id="Vector_118"
          d="M33.1494 89.48C33.2205 89.4512 33.2881 89.4147 33.3511 89.3711C33.4768 89.2886 33.6818 89.183 33.9033 89.018C34.5518 88.5443 35.1482 88.0034 35.6823 87.4043C36.4593 86.5055 37.1846 85.5635 37.8548 84.5828C38.6666 83.3831 39.5769 82.2528 40.5762 81.2036C41.1081 80.6803 41.6958 80.2167 42.3287 79.8209C42.9232 79.4594 43.5594 79.1713 44.2234 78.9629C45.3501 78.6029 46.535 78.4596 47.7153 78.5405C48.5116 78.5884 49.2979 78.7427 50.0531 78.9992C50.3242 79.0817 50.5226 79.1708 50.6648 79.2236C50.7329 79.258 50.8051 79.2835 50.8798 79.2995C50.8136 79.2611 50.7452 79.2269 50.6747 79.1972C50.4791 79.1012 50.2782 79.0163 50.0729 78.9431C49.3167 78.6654 48.5254 78.4944 47.7219 78.4349C46.5276 78.3412 45.3263 78.4779 44.1838 78.8375C43.5071 79.0459 42.8586 79.3363 42.2527 79.7021C41.6085 80.1024 41.0107 80.5728 40.4704 81.1046C39.4634 82.1583 38.5506 83.2978 37.7424 84.5102C37.0793 85.4904 36.364 86.4344 35.5997 87.3383C35.0782 87.9441 34.4978 88.4968 33.867 88.9883C33.6421 89.1599 33.4536 89.2721 33.3346 89.3612C33.2155 89.4503 33.1494 89.4767 33.1494 89.48Z"
          fill="#455A64"
        />
        <path
          id="Vector_119"
          d="M33.0673 95.105C32.9019 95.0741 32.7309 95.1073 32.5891 95.1978C32.4473 95.2883 32.3454 95.4294 32.3043 95.5923C32.2631 95.7552 32.2857 95.9276 32.3675 96.0744C32.4493 96.2213 32.5841 96.3314 32.7444 96.3825C32.9048 96.4336 33.0786 96.4217 33.2305 96.3493C33.3824 96.2769 33.5009 96.1494 33.5619 95.9929C33.6229 95.8363 33.6218 95.6624 33.5588 95.5067C33.4957 95.3509 33.3756 95.225 33.2228 95.1545"
          fill="white"
        />
        <path
          id="Vector_120"
          d="M33.2295 95.1549C33.3718 95.2684 33.4756 95.4228 33.5271 95.5971C33.5499 95.6869 33.55 95.7809 33.5275 95.8707C33.505 95.9605 33.4606 96.0434 33.3982 96.1119C33.3237 96.1982 33.2253 96.2605 33.1154 96.2912C33.0056 96.3218 32.889 96.3193 32.7806 96.2841C32.6721 96.2488 32.5765 96.1823 32.5057 96.093C32.435 96.0036 32.3923 95.8954 32.383 95.7819C32.372 95.6897 32.384 95.5962 32.4181 95.5099C32.4521 95.4235 32.5071 95.3469 32.5781 95.2869C32.7206 95.1757 32.8936 95.1101 33.0741 95.0988C33.0741 95.0988 33.0245 95.0658 32.922 95.0625C32.7724 95.0637 32.6273 95.1135 32.5087 95.2044C32.4176 95.2726 32.3457 95.3631 32.2999 95.4672C32.2541 95.5712 32.2361 95.6853 32.2475 95.7984C32.2555 95.9404 32.3066 96.0767 32.3939 96.1892C32.4812 96.3016 32.6006 96.385 32.7364 96.4283C32.8722 96.4715 33.018 96.4727 33.1545 96.4315C33.2909 96.3903 33.4116 96.3088 33.5007 96.1977C33.561 96.1259 33.6059 96.0425 33.6324 95.9526C33.6589 95.8627 33.6665 95.7683 33.6547 95.6753C33.6429 95.5823 33.6119 95.4928 33.5638 95.4123C33.5157 95.3319 33.4514 95.2622 33.375 95.2077C33.2891 95.1549 33.2328 95.145 33.2295 95.1549Z"
          fill="#263238"
        />
        <path
          id="Vector_121"
          d="M33.9793 90.4228C33.9264 91.3204 33.8867 92.2708 34.3099 93.0628C34.7332 93.8548 35.7715 94.4059 36.5552 93.9571C37.1933 93.5941 37.3851 92.779 37.4943 92.053C37.8051 89.9575 37.9473 87.8422 38.2779 85.75L33.9793 90.4228Z"
          fill="#263238"
        />
        <path
          id="Vector_122"
          d="M50.6648 79.4453C50.6648 79.4651 50.3738 79.3892 49.8447 79.3727C49.0991 79.3609 48.3584 79.4966 47.6656 79.772C47.1862 79.9549 46.7283 80.1895 46.3 80.4716C45.8093 80.8018 45.3389 81.161 44.8913 81.5474C43.8556 82.424 42.9287 83.421 42.1303 84.5174C41.7136 85.1048 41.3433 85.7087 40.9399 86.2664C40.5599 86.8112 40.1158 87.3087 39.6172 87.7481C38.7635 88.4718 37.8293 89.0952 36.833 89.606C35.9898 90.0515 35.2855 90.365 34.7994 90.596L34.2339 90.8336C34.1699 90.8659 34.1022 90.8902 34.0322 90.9062C34.0903 90.8631 34.1536 90.8276 34.2207 90.8006L34.7696 90.53C35.2458 90.2957 35.9402 89.9657 36.7536 89.5103C37.7304 88.986 38.6473 88.3576 39.4882 87.6359C39.9722 87.201 40.4038 86.7116 40.7745 86.1773C41.168 85.6262 41.5384 85.0223 41.9616 84.4283C42.7662 83.3197 43.7059 82.3154 44.7591 81.4385C45.216 81.0509 45.6964 80.6916 46.1975 80.3627C46.638 80.0812 47.1082 79.8488 47.5995 79.6697C48.3099 79.3996 49.069 79.2804 49.8282 79.3199C50.0338 79.3344 50.2382 79.363 50.4399 79.4057C50.5163 79.4089 50.5919 79.4222 50.6648 79.4453Z"
          fill="#455A64"
        />
        <path
          id="Vector_123"
          d="M33.8875 88.3829C33.7988 88.4594 33.7011 88.5248 33.5965 88.5776L32.7632 89.066L32.4822 89.2277C32.3719 89.2927 32.249 89.3332 32.1217 89.3465C32.0439 89.3557 31.9654 89.337 31.9002 89.2937C31.8639 89.2695 31.8337 89.2372 31.8119 89.1995C31.7901 89.1617 31.7773 89.1194 31.7745 89.0759C31.7831 88.9249 31.8372 88.7799 31.9299 88.6601L32.8988 87.1223L33.0311 87.2411C32.3842 87.7136 31.5928 87.9469 30.7924 87.9011C30.69 87.8992 30.5885 87.8813 30.4915 87.8483C30.4357 87.8318 30.3841 87.8035 30.3402 87.7654C30.2962 87.7273 30.261 87.6801 30.2369 87.6272C30.2185 87.5718 30.214 87.5128 30.2238 87.4552C30.2336 87.3977 30.2574 87.3435 30.2931 87.2972C30.3491 87.2231 30.4123 87.1546 30.4816 87.0926C30.9158 86.673 31.2927 86.1981 31.6026 85.6802C31.8761 85.1882 32.1148 84.6777 32.3168 84.1523C32.3022 84.3039 32.2666 84.4527 32.211 84.5945C32.0851 84.99 31.9189 85.3715 31.715 85.733C31.4145 86.2723 31.0394 86.7667 30.6007 87.2015C30.4783 87.317 30.356 87.4523 30.4023 87.5546C30.4486 87.6569 30.6304 87.7097 30.8024 87.7097C31.1789 87.7296 31.556 87.6838 31.9167 87.5744C32.2731 87.4668 32.6086 87.2994 32.9087 87.0794L33.3022 86.7923L33.041 87.2015C32.6872 87.7493 32.3532 88.2641 32.049 88.736C31.9719 88.8308 31.9227 88.945 31.9068 89.066C31.9091 89.0883 31.9161 89.1099 31.9272 89.1293C31.9384 89.1488 31.9534 89.1657 31.9714 89.1791C31.9895 89.1924 32.0101 89.2019 32.032 89.2068C32.0539 89.2118 32.0765 89.2122 32.0986 89.2079C32.3095 89.1643 32.5103 89.0815 32.6905 88.9637L33.5502 88.5215C33.6564 88.4616 33.7697 88.415 33.8875 88.3829Z"
          fill="#455A64"
        />
        <path
          id="Vector_124"
          d="M43.6487 97.1458C43.7096 96.8953 43.857 96.6743 44.0651 96.5216C44.2731 96.3689 44.5285 96.2943 44.7862 96.3109C44.9743 96.3342 45.1537 96.4037 45.3083 96.5131C45.463 96.6225 45.588 96.7684 45.6724 96.9379C45.754 97.109 45.8004 97.2947 45.8089 97.484C45.8174 97.6733 45.7879 97.8623 45.722 98.0401L45.7054 98.116C45.5298 98.3052 45.2999 98.4356 45.0471 98.4894C44.7944 98.5432 44.5311 98.5176 44.2935 98.4163C44.0603 98.3055 43.8706 98.1207 43.7539 97.8908C43.6372 97.6609 43.6002 97.3989 43.6487 97.1458Z"
          fill="#EB996E"
        />
        <path
          id="Vector_125"
          d="M46.2935 98.1374C46.2935 98.0087 45.4404 98.0483 44.7989 97.352C44.1574 96.6557 44.2037 95.7383 44.0846 95.7383C44.0317 95.7383 43.9292 95.9495 43.9391 96.3323C43.955 96.8325 44.1484 97.3108 44.4847 97.682C44.8077 98.0366 45.2556 98.253 45.7347 98.2859C46.1017 98.2991 46.2935 98.1935 46.2935 98.1374Z"
          fill="#263238"
        />
        <path
          id="Vector_126"
          d="M29.7275 107.777L35.6068 106.926L47.3653 108.662L50.6654 109.826L50.0801 117.03L38.7746 119.106L31.1461 116.852L28.2627 112.615L29.7275 107.777Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_127"
          d="M26.0239 108.467L30.9442 107.309C30.9442 107.309 34.4195 118.04 43.0036 117.578C50.0006 117.202 50.0799 109.407 50.0799 109.407L55.1226 111.018C55.1226 111.018 57.0504 123.924 54.9176 133.068C54.4183 135.203 53.7503 138.084 53.7503 138.084L54.4315 151.443L17.1455 151.502L26.0239 108.467Z"
          fill="#F37032"
        />
        <g id="Group_2" opacity="0.3">
          <path
            id="Vector_128"
            d="M40.6398 148.852C38.8278 148.805 37.1513 148.957 35.3491 148.914C33.1734 148.862 30.981 148.809 28.8317 149.162C27.2181 149.426 25.6507 149.918 24.0403 150.172C21.8414 150.502 19.4937 150.393 17.5361 149.337L17.8569 147.512L25.287 145.727L40.6398 148.852Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_129"
          d="M59.3318 114.025C57.6255 111.824 54.7917 110.91 54.7917 110.91L52.8838 127.486L56.498 151.619L68.3292 151.563C68.3292 151.563 61.8019 117.21 59.3318 114.025Z"
          fill="#F37032"
        />
        <path
          id="Vector_130"
          d="M26.5993 108.344C26.5993 108.344 18.6335 108.981 15.7765 122.002C14.4836 127.893 12.8501 134.797 12.3806 139.436C12.0367 142.799 13.8884 148.069 17.2315 148.501L21.4574 149.069C22.2861 149.189 23.1298 149.157 23.9473 148.977C26.6191 148.366 26.8902 146.538 27.3598 144.594L28.5932 140.71C29.2545 137.014 25.8189 136.324 23.9109 136.364L25.3328 119.494L26.5993 108.344Z"
          fill="#F37032"
        />
        <path
          id="Vector_131"
          d="M55.7776 120.121C55.7948 120.18 55.8069 120.241 55.814 120.303L55.8933 120.827C55.9099 120.943 55.9297 121.068 55.9495 121.207C55.9694 121.345 55.9793 121.497 55.9958 121.662C56.0289 121.992 56.0686 122.358 56.0851 122.771C56.1425 123.735 56.1491 124.701 56.1049 125.665C56.0467 126.847 55.9287 128.026 55.7511 129.196C55.5693 130.44 55.3378 131.618 55.1063 132.684C54.8749 133.75 54.6401 134.7 54.445 135.502C54.2499 136.304 54.0747 136.944 53.9523 137.39L53.8101 137.901C53.7965 137.961 53.7777 138.02 53.7539 138.076C53.7575 138.015 53.7686 137.954 53.787 137.895L53.906 137.377C54.0151 136.915 54.1705 136.271 54.359 135.479C54.5475 134.687 54.7724 133.724 54.9939 132.658C55.2155 131.592 55.4469 130.42 55.6288 129.176C55.8107 127.932 55.9396 126.747 55.9892 125.662C56.0388 124.576 56.0454 123.596 55.9892 122.774C55.9892 122.362 55.9429 121.992 55.9165 121.665C55.9165 121.504 55.8933 121.352 55.8834 121.213C55.8735 121.075 55.8503 120.949 55.8371 120.834C55.814 120.613 55.7974 120.438 55.7809 120.306C55.7754 120.244 55.7743 120.183 55.7776 120.121Z"
          fill="#263238"
        />
        <path
          id="Vector_132"
          d="M17.665 140.926C17.671 140.814 17.6922 140.703 17.7279 140.596C17.8054 140.303 17.9083 140.017 18.0354 139.741C18.4523 138.819 19.1026 138.021 19.9225 137.425C20.7423 136.83 21.7033 136.458 22.711 136.346C23.0127 136.31 23.3169 136.3 23.6203 136.316C23.7317 136.316 23.8427 136.33 23.951 136.356C23.5399 136.36 23.1293 136.387 22.7209 136.435C21.7366 136.57 20.8011 136.946 19.9976 137.529C19.194 138.113 18.5472 138.885 18.1147 139.778C17.9432 140.152 17.7931 140.535 17.665 140.926Z"
          fill="#263238"
        />
        <path
          id="Vector_133"
          d="M19.5098 134.438C19.5098 134.438 19.5792 134.422 19.7049 134.418C19.8793 134.416 20.0537 134.424 20.2273 134.441C21.3913 134.565 22.4942 135.024 23.4017 135.761C23.5396 135.87 23.67 135.988 23.7919 136.114C23.8779 136.204 23.9209 136.253 23.9142 136.26C23.9076 136.266 23.6993 136.091 23.3455 135.831C22.4228 135.156 21.3491 134.715 20.2174 134.547C19.7776 134.468 19.5098 134.458 19.5098 134.438Z"
          fill="#263238"
        />
        <path
          id="Vector_134"
          d="M27.7496 117.576C27.7306 117.46 27.7239 117.343 27.7298 117.226C27.7298 117.001 27.7298 116.678 27.6868 116.282C27.6137 115.244 27.4365 114.216 27.1577 113.213C26.8742 112.212 26.4897 111.242 26.0103 110.319C25.8252 109.966 25.6797 109.682 25.554 109.491C25.4909 109.393 25.4356 109.29 25.3887 109.184C25.4674 109.27 25.5372 109.364 25.597 109.464C25.7226 109.649 25.8946 109.926 26.0897 110.276C26.5964 111.195 26.9958 112.17 27.2801 113.18C27.561 114.19 27.7274 115.228 27.7761 116.275C27.7761 116.678 27.7761 117.001 27.7761 117.226C27.7795 117.343 27.7707 117.46 27.7496 117.576Z"
          fill="#263238"
        />
        <path
          id="Vector_135"
          d="M43.0033 129.398C43.0033 129.398 43.0033 129.448 42.967 129.537C42.9296 129.667 42.8854 129.795 42.8347 129.92C42.6574 130.386 42.436 130.835 42.1734 131.26C41.5076 132.359 40.6009 133.294 39.5214 133.994C38.4419 134.695 37.2176 135.142 35.9403 135.302C35.2026 135.397 34.4559 135.397 33.7182 135.302C33.2217 135.238 32.7324 135.128 32.2567 134.972C32.1265 134.933 31.9985 134.886 31.8731 134.834C31.828 134.82 31.7847 134.801 31.7441 134.777C31.7441 134.777 31.9326 134.83 32.2699 134.926C32.7476 135.058 33.2353 135.151 33.7281 135.203C35.3604 135.394 37.0134 135.119 38.495 134.409C39.9765 133.699 41.2257 132.584 42.0973 131.194C42.3634 130.773 42.5956 130.331 42.7917 129.874C42.9273 129.58 42.9868 129.395 43.0033 129.398Z"
          fill="#263238"
        />
        <path
          id="Vector_136"
          d="M26.2194 147.717C26.2194 147.717 26.0806 147.885 25.783 148.129C25.3493 148.457 24.8531 148.693 24.3247 148.822C23.5415 149.017 22.7326 149.088 21.9274 149.034C21.018 148.968 20.0128 148.862 18.9712 148.704C17.9899 148.577 17.0231 148.356 16.0845 148.044C15.6932 147.872 15.335 147.633 15.0264 147.337C14.7512 147.082 14.5019 146.8 14.2824 146.496C13.9642 146.055 13.6916 145.583 13.4689 145.087C13.3929 144.909 13.3334 144.757 13.3003 144.678C13.2787 144.63 13.2544 144.584 13.2275 144.539C13.2309 144.591 13.2432 144.643 13.2639 144.691C13.2937 144.79 13.3466 144.932 13.416 145.113C13.628 145.621 13.8976 146.102 14.2195 146.549C14.4385 146.861 14.6877 147.15 14.9635 147.413C15.2788 147.721 15.6459 147.97 16.0481 148.149C16.9898 148.475 17.9627 148.703 18.9514 148.829C19.9996 148.984 21.0015 149.086 21.9274 149.159C22.7453 149.211 23.5662 149.13 24.3578 148.918C24.8923 148.776 25.3897 148.521 25.816 148.169C25.9299 148.069 26.034 147.959 26.1268 147.839C26.1617 147.802 26.1927 147.761 26.2194 147.717Z"
          fill="#263238"
        />
        <path
          id="Vector_137"
          d="M27.5317 121.727C27.4987 121.727 26.6588 124.97 25.6569 128.987C24.6549 133.003 23.8713 136.289 23.9043 136.289C23.9374 136.289 24.7806 133.046 25.7825 129.029C26.7844 125.013 27.5681 121.733 27.5317 121.727Z"
          fill="#263238"
        />
        <path
          id="Vector_138"
          d="M28.5471 140.088C28.573 140.001 28.5864 139.911 28.5867 139.821C28.6139 139.575 28.6205 139.328 28.6066 139.082C28.5798 138.709 28.4555 138.351 28.2462 138.042C28.1295 137.856 27.9931 137.684 27.8394 137.527C27.6682 137.366 27.4784 137.225 27.274 137.108C26.5518 136.727 25.7685 136.475 24.9593 136.362C24.7163 136.325 24.4711 136.303 24.2252 136.296C24.1355 136.281 24.0439 136.281 23.9541 136.296C23.9541 136.316 24.3377 136.333 24.9461 136.438C25.7372 136.577 26.5022 136.836 27.2145 137.207C27.4085 137.319 27.5884 137.455 27.7502 137.61C27.8984 137.76 28.0323 137.923 28.1503 138.098C28.353 138.392 28.4782 138.733 28.514 139.088C28.5364 139.331 28.5442 139.574 28.5371 139.817C28.5296 139.908 28.5329 139.999 28.5471 140.088Z"
          fill="#263238"
        />
        <g id="Group_3" opacity="0.3">
          <path
            id="Vector_139"
            d="M55.4101 131.061C57.4437 127.625 57.4867 123.164 55.7143 119.59C56.2821 123.4 56.1589 127.281 55.3506 131.047"
            fill="black"
          />
        </g>
        <path
          id="Vector_140"
          d="M52.1698 146.478C51.5283 145.27 46.532 142.089 46.532 142.089L47.8844 141.776L49.379 142.406C49.4915 142.911 49.7102 143.387 50.0205 143.802C50.5694 144.584 51.5019 143.775 51.5019 143.775L50.8703 140.756L47.9175 138.98C47.9175 138.98 45.1366 139.406 44.6869 139.621L43.5031 140.703C42.9806 141.109 41.4794 142.713 41.0694 142.762C40.6593 142.812 27.7766 139.921 27.7766 139.921C26.0075 141.317 25.0783 144.095 24.8006 146.099C24.8006 146.099 24.4699 147.089 24.827 147.617L40.6593 148.857L44.0156 149.781C44.9143 150.153 45.8353 150.468 46.7734 150.725C47.8877 150.959 48.6416 150.6 48.6714 149.986C48.7011 149.372 47.8348 149.303 47.8348 149.303C47.0946 149.036 46.3733 148.719 45.6755 148.356C45.1681 148.014 44.7506 147.556 44.4587 147.019L45.6557 147.164C45.6557 147.164 48.1985 148.923 49.1542 149.441C50.1098 149.96 50.2983 149.009 50.3776 148.722C50.457 148.435 47.5207 145.567 47.5207 145.567C47.5207 145.567 50.3082 147.283 50.8108 147.719C51.3134 148.154 52.0574 148.28 52.2161 147.989C52.3749 147.699 52.808 147.686 52.1698 146.478Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_141"
          d="M38.4072 146.755C38.3968 146.69 38.3968 146.625 38.4072 146.56C38.398 146.484 38.398 146.408 38.4072 146.332C38.4181 146.23 38.4369 146.128 38.4634 146.029C38.622 145.459 38.8979 144.928 39.2735 144.471C39.6375 144.011 40.0462 143.587 40.4937 143.207C40.6692 143.039 40.8621 142.89 41.0691 142.762C40.906 142.94 40.7327 143.109 40.5499 143.267C40.1228 143.661 39.727 144.088 39.3661 144.544C39.0012 144.992 38.7221 145.503 38.5428 146.052C38.4204 146.478 38.4303 146.758 38.4072 146.755Z"
          fill="#EB996E"
        />
        <path
          id="Vector_142"
          d="M46.4161 141.992C46.1306 142.053 45.8332 142.026 45.563 141.916C45.2811 141.842 45.0284 141.684 44.8389 141.464C44.8587 141.434 45.1695 141.662 45.5994 141.794C46.0293 141.926 46.4161 141.955 46.4161 141.992Z"
          fill="#EB996E"
        />
        <path
          id="Vector_143"
          d="M47.2459 145.3C46.8096 145.182 46.3838 145.029 45.9729 144.841C45.5485 144.687 45.1381 144.497 44.7461 144.273C45.183 144.389 45.609 144.543 46.0192 144.732C46.4439 144.885 46.8543 145.075 47.2459 145.3Z"
          fill="#EB996E"
        />
        <path
          id="Vector_144"
          d="M44.5681 146.986C44.3393 146.937 44.1173 146.86 43.9067 146.758C43.6841 146.692 43.4699 146.6 43.2686 146.484C43.5035 146.49 43.7345 146.545 43.9464 146.646C44.1752 146.715 44.387 146.83 44.5681 146.986Z"
          fill="#EB996E"
        />
        <path
          id="Vector_145"
          d="M46.8362 145.53C46.8362 145.563 46.5584 145.672 46.3435 145.962C46.2238 146.145 46.1282 146.343 46.0591 146.55C46.0591 146.55 46.0294 146.471 46.0591 146.345C46.0883 146.18 46.1563 146.024 46.2575 145.89C46.3608 145.757 46.4931 145.65 46.6444 145.576C46.7502 145.51 46.8296 145.504 46.8362 145.53Z"
          fill="#EB996E"
        />
        <path
          id="Vector_146"
          d="M48.01 143.674C48.01 143.707 47.8049 143.822 47.6628 144.076C47.5896 144.238 47.5288 144.404 47.4809 144.575C47.4462 144.482 47.4353 144.383 47.4492 144.286C47.4631 144.188 47.5013 144.096 47.5602 144.017C47.7289 143.726 48.0033 143.644 48.01 143.674Z"
          fill="#EB996E"
        />
        <path
          id="Vector_147"
          d="M47.6161 140.381C47.6161 140.381 47.5599 140.332 47.5236 140.223C47.4843 140.079 47.4843 139.928 47.5236 139.784C47.5576 139.638 47.6308 139.505 47.7352 139.398C47.8145 139.315 47.8807 139.289 47.8873 139.299C47.7687 139.45 47.6841 139.625 47.639 139.812C47.5939 139.998 47.5895 140.193 47.6261 140.381H47.6161Z"
          fill="#EB996E"
        />
        <path
          id="Vector_148"
          d="M24.6644 148.06C24.6839 147.94 24.6917 147.819 24.6875 147.697C24.6875 147.582 24.6875 147.437 24.6875 147.272C24.6875 147.107 24.6875 146.918 24.7272 146.711C24.827 145.631 25.0648 144.569 25.4348 143.549C25.6401 142.989 25.8911 142.448 26.1854 141.929C26.3309 141.695 26.4566 141.467 26.6021 141.269L26.8071 140.982L27.0088 140.724C27.5346 140.081 27.938 139.734 27.9214 139.734C27.8195 139.801 27.7243 139.877 27.6371 139.962C27.5206 140.053 27.4102 140.151 27.3064 140.256C27.1907 140.378 27.0551 140.51 26.9228 140.675L26.7112 140.929C26.6418 141.018 26.5723 141.117 26.4996 141.216C26.3475 141.411 26.2152 141.642 26.0664 141.876C25.7639 142.403 25.5072 142.955 25.2993 143.526C24.9282 144.556 24.7055 145.634 24.6379 146.727C24.6181 146.938 24.6379 147.126 24.6148 147.295C24.5916 147.463 24.6148 147.602 24.6148 147.72C24.6234 147.835 24.64 147.948 24.6644 148.06Z"
          fill="#263238"
        />
        <g id="Group_4" opacity="0.3">
          <path
            id="Vector_149"
            d="M19.2324 136.771C20.7191 136.161 22.3554 136.013 23.9279 136.345C22.5776 136.284 21.2419 136.645 20.1072 137.378C18.9725 138.111 18.0956 139.179 17.5989 140.434C17.4832 140.737 17.2683 141.094 16.9376 141.048C16.6069 141.001 16.5342 140.628 16.5342 140.325C16.5342 138.747 17.7742 137.381 19.2324 136.771Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_150"
          d="M55.8828 119.007C55.9568 118.996 56.0283 118.973 56.0944 118.938C56.2267 118.885 56.4251 118.799 56.6466 118.687C57.2424 118.386 57.812 118.036 58.3496 117.641C58.8874 117.244 59.3907 116.803 59.8541 116.321C60.0294 116.133 60.1848 115.991 60.2575 115.869C60.3093 115.815 60.3527 115.754 60.3865 115.688C60.1774 115.866 59.9777 116.056 59.788 116.255C59.3118 116.716 58.8059 117.144 58.2735 117.539C57.7464 117.93 57.1941 118.286 56.6202 118.605C56.1473 118.852 55.863 118.991 55.8828 119.007Z"
          fill="white"
        />
        <path
          id="Vector_151"
          d="M27.6338 119.93L27.6966 119.973L27.8851 120.085C28.0471 120.184 28.2951 120.32 28.6192 120.491C29.538 120.96 30.4908 121.359 31.4695 121.686C32.9234 122.169 34.4156 122.529 35.9302 122.762C37.7831 123.037 39.652 123.191 41.5251 123.224C43.5091 123.273 45.417 123.224 47.1464 123.194C48.6761 123.178 50.2034 123.067 51.7195 122.864C52.7423 122.719 53.7504 122.485 54.7319 122.164C55.0791 122.049 55.3437 121.95 55.5189 121.874L55.7239 121.791L55.7901 121.758C55.7648 121.761 55.7401 121.767 55.7173 121.778L55.5123 121.851C55.3304 121.92 55.0626 122.009 54.7154 122.118C53.7318 122.419 52.7255 122.639 51.7063 122.778C50.1929 122.976 48.6693 123.086 47.1431 123.108C45.4204 123.141 43.5223 123.174 41.5218 123.128C39.6536 123.094 37.7894 122.943 35.9401 122.676C34.4318 122.451 32.9444 122.103 31.4927 121.636C30.5161 121.308 29.5636 120.912 28.6423 120.452C28.3117 120.29 28.0637 120.161 27.895 120.069L27.7032 119.966C27.6602 119.94 27.6371 119.927 27.6338 119.93Z"
          fill="white"
        />
        <path
          id="Vector_152"
          d="M55.7871 128.621C55.8903 128.608 55.9921 128.586 56.0913 128.555L56.9048 128.334C57.5892 128.139 58.5349 127.865 59.5765 127.555C60.6181 127.245 61.5605 126.955 62.2384 126.74L63.0386 126.479C63.1396 126.453 63.2372 126.416 63.3296 126.367C63.2264 126.38 63.1246 126.402 63.0254 126.433L62.212 126.654C61.5242 126.849 60.5818 127.123 59.5402 127.433C58.4986 127.743 57.5562 128.034 56.8783 128.248L56.0748 128.509C55.9744 128.534 55.8777 128.571 55.7871 128.621Z"
          fill="white"
        />
        <path
          id="Vector_153"
          d="M55.0762 142.123C55.0762 142.156 57.5265 141.463 60.5289 140.559C63.5314 139.655 65.9585 138.909 65.9485 138.876C65.9386 138.843 63.495 139.536 60.4925 140.44C57.4901 141.345 55.063 142.09 55.0762 142.123Z"
          fill="white"
        />
        <path
          id="Vector_154"
          d="M19.7217 112.93C19.8031 113.01 19.8929 113.08 19.9895 113.141C20.1681 113.273 20.4326 113.454 20.7633 113.669C21.6271 114.221 22.5225 114.723 23.445 115.17C24.367 115.624 25.3155 116.022 26.2854 116.362C26.6591 116.494 26.9633 116.589 27.1749 116.649C27.2825 116.687 27.3931 116.715 27.5056 116.735C27.4002 116.679 27.2894 116.635 27.1749 116.603L26.3019 116.273C25.5646 115.992 24.5626 115.576 23.4847 115.048C22.4067 114.52 21.4643 113.982 20.793 113.573L20.0027 113.081C19.9127 113.024 19.8188 112.974 19.7217 112.93Z"
          fill="white"
        />
        <path
          id="Vector_155"
          d="M14.8477 126.801C14.9743 126.875 15.107 126.938 15.2445 126.989C15.5024 127.104 15.8826 127.256 16.3588 127.431C18.8395 128.335 21.4448 128.851 24.0832 128.962C24.5891 128.985 24.9991 128.989 25.2802 128.982C25.4272 128.986 25.5742 128.979 25.72 128.959C25.5743 128.939 25.4272 128.93 25.2802 128.933C24.9991 128.933 24.5924 128.906 24.0898 128.873C21.4656 128.711 18.8752 128.198 16.3886 127.345C15.9124 127.184 15.5255 127.045 15.2643 126.943C15.1289 126.886 14.9897 126.838 14.8477 126.801Z"
          fill="white"
        />
        <path
          id="Vector_156"
          d="M21.8908 148.984C21.8974 148.94 21.8974 148.894 21.8908 148.849C21.8908 148.747 21.8544 148.621 21.8279 148.466C21.8015 148.311 21.7651 148.093 21.742 147.856C21.7188 147.618 21.6758 147.348 21.6659 147.047C21.6659 146.895 21.656 146.737 21.6361 146.572C21.6361 146.41 21.6361 146.242 21.6361 146.061C21.6361 145.707 21.6527 145.328 21.6692 144.929C21.7857 143.204 22.1903 141.511 22.8662 139.919C23.0316 139.556 23.1969 139.206 23.3556 138.896C23.4383 138.741 23.511 138.586 23.597 138.444L23.8384 138.035C23.9839 137.774 24.1459 137.553 24.2782 137.352C24.4104 137.151 24.5295 136.982 24.632 136.847L24.8601 136.533C24.8902 136.498 24.9157 136.459 24.9362 136.418C24.9007 136.447 24.8685 136.481 24.8403 136.517L24.5923 136.817C24.4832 136.949 24.3542 137.111 24.2186 137.309C24.0831 137.507 23.9144 137.728 23.759 137.989L23.511 138.395C23.425 138.537 23.349 138.692 23.263 138.847C23.0845 139.157 22.9324 139.507 22.7604 139.873C22.4138 140.673 22.134 141.499 21.9238 142.345C21.7249 143.193 21.5955 144.056 21.5369 144.925C21.5369 145.328 21.4973 145.707 21.5138 146.064C21.5138 146.242 21.5138 146.417 21.5138 146.582C21.5138 146.747 21.5369 146.912 21.5502 147.057C21.5502 147.361 21.613 147.631 21.6461 147.869C21.6712 148.073 21.7076 148.276 21.7552 148.476C21.7883 148.631 21.8147 148.757 21.8379 148.859C21.8501 148.903 21.8679 148.945 21.8908 148.984Z"
          fill="white"
        />
        <path
          id="Vector_157"
          d="M12.4403 141.504C12.4568 141.504 12.4601 141.306 12.5163 140.953C12.6008 140.457 12.7626 139.977 12.9958 139.531C13.3452 138.871 13.8138 138.282 14.378 137.792C15.0687 137.191 15.8662 136.726 16.729 136.419C17.5996 136.134 18.5078 135.979 19.424 135.96C20.1734 135.939 20.9233 135.967 21.6692 136.043C22.3074 136.106 22.8232 136.168 23.1803 136.208L23.5937 136.254H23.7358C23.6916 136.236 23.6447 136.225 23.597 136.221L23.1869 136.152C22.8331 136.096 22.3173 136.02 21.6791 135.947C20.9286 135.858 20.1729 135.821 19.4173 135.835C18.489 135.847 17.568 136.001 16.686 136.29C15.8078 136.601 14.9981 137.078 14.3019 137.696C13.7291 138.197 13.2586 138.803 12.9164 139.481C12.6855 139.938 12.5335 140.43 12.4667 140.937C12.4489 141.074 12.4401 141.211 12.4403 141.349C12.4353 141.401 12.4353 141.453 12.4403 141.504Z"
          fill="white"
        />
        <path
          id="Vector_158"
          d="M38.7578 134.441L38.8967 134.464L39.2935 134.504L40.7617 134.626C42.0017 134.722 43.7145 134.841 45.6092 134.936C47.5039 135.032 49.2201 135.098 50.4667 135.111C51.0884 135.111 51.591 135.111 51.9382 135.111H52.3383C52.3842 135.119 52.4312 135.119 52.4772 135.111H52.3383H51.9382L50.4667 135.075C49.2267 135.039 47.5106 134.966 45.6158 134.867L40.7683 134.593L39.2968 134.511L38.8967 134.494C38.854 134.468 38.8069 134.45 38.7578 134.441Z"
          fill="white"
        />
        <g id="Group_5" opacity="0.3">
          <path
            id="Vector_159"
            d="M37.3364 134.944C35.7955 135.396 33.6594 135.508 32.1582 134.944C33.3321 136.594 35.6004 137.211 37.5679 136.67C39.5354 136.128 41.3507 134.162 41.5028 132.129C40.4337 133.469 38.9801 134.451 37.3364 134.944Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_160"
          d="M24.8398 133.337L24.9622 133.37L25.3193 133.445C25.6268 133.508 26.0765 133.594 26.642 133.69C27.7563 133.884 29.2873 134.125 31.0101 134.333C32.7329 134.541 34.2771 134.68 35.4046 134.759C35.9701 134.798 36.4264 134.825 36.7273 134.838H37.091C37.1338 134.845 37.1773 134.845 37.22 134.838L37.0943 134.818L36.7306 134.782L35.408 134.663C34.2837 134.561 32.7329 134.409 31.0233 134.201C29.3138 133.993 27.7695 133.766 26.6552 133.594L25.3325 133.389L24.9721 133.337C24.8828 133.32 24.8398 133.32 24.8398 133.337Z"
          fill="white"
        />
        <g id="Group_6" opacity="0.3">
          <path
            id="Vector_161"
            d="M27.4027 122.469C27.7896 126.887 26.5826 131.273 25.3889 135.547C25.3347 135.813 25.2217 136.065 25.0583 136.283C24.9746 136.389 24.8587 136.467 24.7278 136.503C24.5968 136.539 24.4577 136.532 24.3308 136.484C23.9572 136.296 24.0001 135.755 24.1126 135.352L27.4192 122.65"
            fill="black"
          />
        </g>
        <path
          id="Vector_162"
          d="M89.3366 126.869L84.3204 151.5H40.6724C40.4417 151.5 40.2205 151.409 40.0575 151.246C39.8944 151.083 39.8027 150.863 39.8027 150.632C39.8027 150.402 39.8943 150.181 40.0572 150.017C40.2202 149.854 40.4414 149.762 40.6724 149.761H49.4582L54.1173 126.856C54.1605 126.642 54.2762 126.45 54.4447 126.311C54.6133 126.172 54.8246 126.095 55.0432 126.094L88.3942 125.731C88.5362 125.729 88.6768 125.759 88.8057 125.818C88.9346 125.878 89.0484 125.965 89.1388 126.074C89.2293 126.184 89.294 126.312 89.3282 126.449C89.3624 126.587 89.3653 126.73 89.3366 126.869Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_163"
          d="M89.3371 126.871C89.3371 126.871 89.3371 126.847 89.3537 126.798C89.3783 126.613 89.3479 126.425 89.2662 126.257C89.1845 126.089 89.055 125.949 88.894 125.854C88.8094 125.8 88.7169 125.758 88.6196 125.732C88.5103 125.714 88.3995 125.708 88.2889 125.712H87.5052H85.5411L72.9294 125.831L64.1403 125.92L59.2134 125.97L56.6309 125.996H55.3082C55.1958 125.996 55.09 125.996 54.9776 125.996C54.8624 126.007 54.7503 126.04 54.6469 126.092C54.4317 126.196 54.2614 126.374 54.1674 126.593C54.125 126.7 54.094 126.81 54.0748 126.923L54.0087 127.253C53.9624 127.474 53.9194 127.696 53.8731 127.913C53.7805 128.359 53.6913 128.804 53.5987 129.256C53.4135 130.161 53.2283 131.071 53.0398 131.995C52.6629 133.848 52.2782 135.739 51.8858 137.668L49.4356 149.687L49.4951 149.637H40.8184C40.7078 149.631 40.5969 149.638 40.4877 149.657C40.2618 149.7 40.0598 149.825 39.9209 150.008C39.7821 150.191 39.7161 150.419 39.7359 150.648C39.7556 150.876 39.8596 151.09 40.0279 151.246C40.1961 151.403 40.4165 151.491 40.6465 151.495H63.8196H84.3209H84.3573V151.459C85.8916 143.889 87.1415 137.731 87.9946 133.461C88.4245 131.329 88.7618 129.669 88.9866 128.54C89.099 127.979 89.185 127.55 89.2412 127.257C89.2974 126.963 89.3239 126.818 89.3239 126.818L89.228 127.253C89.1685 127.547 89.0792 127.976 88.9602 128.537C88.7287 129.662 88.3848 131.322 87.945 133.451L84.2515 151.442L84.3209 151.472H63.8196H40.6398C40.5155 151.465 40.394 151.432 40.2827 151.376C40.1827 151.322 40.0953 151.247 40.0262 151.156C39.9571 151.066 39.9078 150.962 39.8816 150.851C39.8554 150.74 39.8529 150.625 39.8741 150.513C39.8954 150.401 39.94 150.295 40.005 150.202C40.1218 150.032 40.2994 149.914 40.501 149.872C40.6101 149.853 40.7211 149.847 40.8316 149.855H49.5216V149.809L51.9619 137.79C52.3543 135.859 52.7389 133.968 53.1159 132.118C53.3033 131.194 53.4885 130.281 53.6714 129.379C53.764 128.926 53.8533 128.478 53.9459 128.032C53.9889 127.811 54.0352 127.587 54.0781 127.372L54.1476 127.042C54.1625 126.929 54.1903 126.819 54.2302 126.712C54.3167 126.517 54.4687 126.358 54.6601 126.263C54.7538 126.215 54.856 126.185 54.961 126.174C55.0635 126.174 55.1793 126.174 55.2917 126.174L56.6144 126.158L59.1969 126.128L64.1205 126.072L72.9129 125.97L85.5212 125.815L87.4854 125.788H88.2691C88.3797 125.783 88.4905 125.79 88.5997 125.808C88.7923 125.849 88.9673 125.949 89.1005 126.094C89.2338 126.239 89.3187 126.421 89.3437 126.616C89.3512 126.701 89.3489 126.786 89.3371 126.871Z"
          fill="#263238"
        />
        <path
          id="Vector_164"
          d="M69.2285 138.142C69.2285 138.426 69.3131 138.705 69.4715 138.941C69.6299 139.178 69.8551 139.362 70.1185 139.471C70.3819 139.58 70.6718 139.609 70.9515 139.553C71.2311 139.498 71.488 139.361 71.6897 139.159C71.8913 138.958 72.0286 138.702 72.0842 138.423C72.1399 138.144 72.1113 137.854 72.0022 137.591C71.8931 137.328 71.7083 137.104 71.4712 136.946C71.2341 136.788 70.9554 136.703 70.6702 136.703C70.2879 136.703 69.9212 136.855 69.6508 137.125C69.3804 137.394 69.2285 137.76 69.2285 138.142Z"
          fill="white"
        />
        <path
          id="Vector_165"
          d="M89.297 127.07H89.1482H87.0088L80.7692 127.1L60.1852 127.245L57.2092 127.268H56.4751C56.3501 127.265 56.225 127.273 56.1014 127.291C55.9763 127.318 55.8567 127.366 55.7476 127.433C55.5314 127.572 55.3746 127.786 55.3078 128.034C55.2516 128.275 55.2119 128.503 55.1623 128.737C54.7953 130.591 54.4382 132.383 54.1009 134.086C53.423 137.495 52.8146 140.567 52.3054 143.148L51.105 149.26C50.9662 149.976 50.8604 150.537 50.7744 150.91C50.7413 151.097 50.7149 151.242 50.695 151.345C50.6785 151.441 50.6719 151.49 50.6719 151.49C50.6719 151.49 50.6719 151.444 50.7082 151.345C50.7446 151.246 50.7578 151.101 50.7975 150.916L51.1282 149.266C51.4225 147.821 51.8424 145.738 52.3649 143.164C52.8873 140.59 53.4991 137.515 54.1836 134.109C54.5142 132.403 54.8846 130.615 55.2549 128.76C55.3045 128.529 55.3475 128.291 55.3971 128.067C55.4573 127.847 55.5976 127.658 55.7906 127.536C55.8912 127.471 56.0036 127.428 56.1213 127.407C56.2373 127.39 56.3546 127.383 56.4718 127.387H57.2058L60.1818 127.364L80.7658 127.183L87.0055 127.113L88.7018 127.09H89.1449L89.297 127.07Z"
          fill="#263238"
        />
        <path
          id="Vector_166"
          d="M17.542 149.875H17.6015L17.7702 149.891L18.4315 149.944C19.0002 149.99 19.8203 150.047 20.8387 150.106C22.869 150.225 25.683 150.347 28.7747 150.4C31.8665 150.452 34.7003 150.423 36.7339 150.37C37.7523 150.344 38.5757 150.317 39.1444 150.291L39.8058 150.258H39.9777H40.0339H39.8058H39.1444L36.7339 150.297C34.697 150.327 31.883 150.34 28.778 150.297C25.6731 150.254 22.8624 150.136 20.842 150.04L18.4348 149.918L17.7735 149.888H17.542V149.875Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

export const approvedIconSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check_circle_FILL1_wght300_GRAD0_opsz24 1">
      <path
        id="Vector"
        d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z"
        fill="#21A300"
      />
    </g>
  </svg>
);

export const approvalTickIconSVG = (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector 104"
      d="M1 6L5 10L13.5 1.5"
      stroke="#27D50B"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const deleteIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.61537 19.9997C7.16794 19.9997 6.78685 19.8424 6.4721 19.5276C6.15737 19.2129 6 18.8318 6 18.3843V5.99972H5V4.99972H9V4.23047H15V4.99972H19V5.99972H18V18.3843C18 18.8446 17.8458 19.2289 17.5375 19.5372C17.2292 19.8456 16.8449 19.9997 16.3846 19.9997H7.61537ZM17 5.99972H7V18.3843C7 18.5638 7.05769 18.7113 7.17308 18.8266C7.28846 18.942 7.43589 18.9997 7.61537 18.9997H16.3846C16.5385 18.9997 16.6795 18.9356 16.8077 18.8074C16.9359 18.6792 17 18.5382 17 18.3843V5.99972ZM9.80768 16.9997H10.8077V7.99972H9.80768V16.9997ZM13.1923 16.9997H14.1923V7.99972H13.1923V16.9997Z"
      fill="white"
    />
  </svg>
);

export const deleteCardsIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="27"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.61537 19.9997C7.16794 19.9997 6.78685 19.8424 6.4721 19.5276C6.15737 19.2129 6 18.8318 6 18.3843V5.99972H5V4.99972H9V4.23047H15V4.99972H19V5.99972H18V18.3843C18 18.8446 17.8458 19.2289 17.5375 19.5372C17.2292 19.8456 16.8449 19.9997 16.3846 19.9997H7.61537ZM17 5.99972H7V18.3843C7 18.5638 7.05769 18.7113 7.17308 18.8266C7.28846 18.942 7.43589 18.9997 7.61537 18.9997H16.3846C16.5385 18.9997 16.6795 18.9356 16.8077 18.8074C16.9359 18.6792 17 18.5382 17 18.3843V5.99972ZM9.80768 16.9997H10.8077V7.99972H9.80768V16.9997ZM13.1923 16.9997H14.1923V7.99972H13.1923V16.9997Z"
      fill="red"
    />
  </svg>
);

export const passwordOpenIconSVG = (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    >
      <path d="m2 2 20 20" />
      <path d="m6.71277 6.7226c-3.04798 2.07267-4.71277 5.2774-4.71277 5.2774s3.63636 7 10 7c2.0503 0 3.8174-.7266 5.2711-1.7116m-6.2711-12.23018c.3254-.03809.6588-.05822 1-.05822 6.3636 0 10 7 10 7s-.6918 1.3317-2 2.8335" />
      <path d="m14 14.2362c-.5308.475-1.2316.7639-2 .7639-1.6569 0-3-1.3431-3-3 0-.8237.33193-1.5698.86932-2.11192" />
    </g>
  </svg>
);

export const passwordCloseIconSVG = (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m0 0h24v24h-24z" fill="#fff" opacity="0" />
    <g fill="#231f20">
      <path d="m21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1zm-9.65 5.5c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5z" />
      <path d="m12 8.5a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0 -3.5-3.5zm0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1 -1.5 1.5z" />
    </g>
  </svg>
);

export const noPhotosUploadedSVG = (
  <svg
    width="234"
    height="234"
    viewBox="0 0 234 234"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Empty-pana (1) 1">
      <g id="freepik--background-complete--inject-64">
        <path
          id="Vector"
          d="M126.984 177.148H78.2422V214.743H126.984V177.148Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_2"
          d="M114.745 214.405C114.679 214.405 114.623 206.023 114.623 195.685C114.623 185.347 114.679 176.965 114.745 176.965C114.81 176.965 114.866 185.347 114.866 195.685C114.866 206.023 114.81 214.405 114.745 214.405Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_3"
          d="M122.836 206.215H119.102V210.441H122.836V206.215Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_4"
          d="M98.5872 177.328H93.0508V185.35H98.5872V177.328Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_5"
          d="M98.5872 206.578H93.0508V214.6H98.5872V206.578Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_6"
          d="M215.39 167.641H153.928V215.044H215.39V167.641Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_7"
          d="M200.026 214.834C199.96 214.834 199.904 204.271 199.904 191.237C199.904 178.203 199.96 167.641 200.026 167.641C200.091 167.641 200.148 178.203 200.148 191.237C200.148 204.271 200.096 214.834 200.026 214.834Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_8"
          d="M210.193 204.387H205.48V209.713H210.193V204.387Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_9"
          d="M179.649 167.824H172.666V177.938H179.649V167.824Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_10"
          d="M179.649 204.934H172.666V215.047H179.649V204.934Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_11"
          d="M38.1692 169.048C40.659 167.766 43.5886 167.597 46.3498 168.056C47.8334 168.299 49.3778 168.744 50.3887 169.858C51.3996 170.972 51.5868 172.933 50.4308 173.892C49.7382 174.463 48.7788 174.547 47.8802 174.538C45.718 174.51 43.3219 174.131 41.595 175.432C40.6075 176.176 39.9523 177.407 38.787 177.772C37.6216 178.137 36.3346 177.449 35.7262 176.41C35.1634 175.326 35.0394 174.068 35.3799 172.895C35.5177 172.083 35.8411 171.313 36.3248 170.646C36.8086 169.978 37.4398 169.432 38.1692 169.048Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_12"
          d="M32.5102 158.186C34.0312 160.357 36.989 159.641 38.3602 158.312C39.7314 156.983 40.3118 155.064 40.8359 153.234C42.0434 149.046 43.2555 144.651 42.3616 140.388C42.1464 139.095 41.5779 137.887 40.7189 136.897C40.2841 136.41 39.7297 136.046 39.1107 135.84C38.4918 135.634 37.8297 135.593 37.1902 135.722C35.6973 136.115 34.7706 137.594 34.1014 138.965C32.1283 143.064 31.0954 147.553 31.0781 152.102C31.0781 154.222 31.3168 156.44 32.5102 158.186Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_13"
          d="M28.3042 161.267C29.9563 159.306 30.2698 156.451 29.5351 153.994C28.8003 151.537 27.1389 149.45 25.2248 147.742C22.9735 145.739 20.3539 144.194 17.5121 143.193C16.4108 142.748 15.2261 142.547 14.0396 142.603C13.4477 142.637 12.873 142.815 12.3657 143.122C11.8583 143.428 11.4336 143.854 11.1286 144.363C10.3143 145.912 11.0959 147.788 11.9383 149.324C13.4217 152.024 15.1148 154.605 17.002 157.041C18.523 158.997 20.278 160.93 22.5759 161.814C24.8738 162.699 27.298 162.596 28.5242 160.991"
          fill="#EBEBEB"
        />
        <path
          id="Vector_14"
          d="M32.3833 190.913C32.4646 190.591 32.5116 190.261 32.5237 189.93C32.5939 189.209 32.6781 188.306 32.7858 187.234C32.9199 185.908 33.1214 184.59 33.3895 183.284C33.7412 181.688 34.2216 180.123 34.8263 178.604C35.4192 177.096 36.2211 175.678 37.2084 174.392C38.0155 173.347 39.0429 172.492 40.2176 171.888C41.0165 171.495 41.8726 171.229 42.7542 171.102C43.086 171.089 43.4155 171.041 43.737 170.957C43.4057 170.921 43.0714 170.921 42.7401 170.957C41.8246 171.026 40.929 171.259 40.0959 171.645C38.8554 172.23 37.7677 173.095 36.9182 174.172C35.8849 175.475 35.0521 176.924 34.4472 178.473C33.8433 180.01 33.3735 181.596 33.0432 183.214C32.7886 184.536 32.612 185.872 32.5143 187.215C32.4301 188.362 32.3973 189.289 32.3833 189.93C32.3488 190.256 32.3488 190.586 32.3833 190.913Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_15"
          d="M32.5587 188.8C32.5864 188.646 32.5959 188.489 32.5867 188.332C32.5867 187.986 32.5867 187.551 32.5867 187.022C32.5867 185.885 32.5867 184.237 32.6429 182.206C32.7459 178.144 33.1109 173.782 33.7708 167.609C34.4119 161.811 35.2684 155.067 36.1763 150.682C36.3682 149.685 36.5647 148.786 36.7519 148C36.9391 147.214 37.0749 146.531 37.2199 145.983C37.365 145.436 37.4446 145.047 37.5288 144.71C37.5746 144.558 37.6013 144.401 37.6084 144.242C37.5379 144.379 37.4844 144.523 37.4493 144.673C37.3463 145.005 37.2199 145.417 37.0655 145.927C36.9111 146.437 36.7239 147.148 36.5273 147.93C36.3307 148.712 36.1061 149.61 35.8955 150.607C34.7712 155.793 33.9261 161.036 33.3636 166.313C32.6897 172.491 32.3855 178.116 32.3574 182.188C32.3574 184.223 32.3574 185.875 32.4276 187.013C32.4604 187.542 32.4885 187.977 32.5072 188.318C32.5049 188.481 32.5222 188.642 32.5587 188.8Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_16"
          d="M32.6028 177.9C32.6385 177.443 32.6385 176.985 32.6028 176.529C32.5513 175.649 32.4297 174.38 32.1816 172.822C31.8755 171 31.4661 169.197 30.9555 167.421C30.3652 165.236 29.6096 163.099 28.695 161.028C27.1292 157.213 24.882 153.715 22.0635 150.704C21.5744 150.187 21.0523 149.703 20.5003 149.254C20.2617 149.048 20.0323 148.846 19.8358 148.687L19.2555 148.271C18.8912 147.993 18.5046 147.745 18.0995 147.531C18.034 147.62 19.7328 148.622 21.8762 150.901C24.6027 153.94 26.7901 157.422 28.344 161.197C29.2428 163.254 30.0012 165.369 30.6138 167.529C31.1284 169.288 31.5549 171.072 31.8914 172.873C32.1722 174.413 32.3595 175.681 32.4343 176.543C32.4543 176.999 32.5107 177.453 32.6028 177.9Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_17"
          d="M21.3887 195.43L22.4744 210.326H41.6109L42.6967 195.43H21.3887Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_18"
          d="M44.9963 189.578H19.5605V195.447H44.9963V189.578Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_19"
          d="M19.5605 209.688V211.311H20.7586H44.5798V209.688H19.5605Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_20"
          d="M21.918 214.013L20.748 211.148H43.6567L42.2901 214.013H21.918Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_21"
          d="M42.2915 200.254C42.2677 200.305 42.2378 200.352 42.2026 200.395C42.1277 200.493 42.0295 200.62 41.9171 200.774L40.8033 202.178L40.7518 202.243L40.705 202.178L37.9672 198.392H38.1217L35.426 202.206L35.3418 202.328L35.2481 202.215L32.0517 198.411H32.2342L32.0611 198.635L29.2016 202.215L29.1033 202.337L29.0191 202.211L26.3187 198.397H26.4778L23.155 202.178L23.0989 202.248L23.0521 202.169L22.0131 200.446C21.9008 200.259 21.8165 200.105 21.7463 199.978C21.7111 199.926 21.6827 199.869 21.6621 199.81C21.7059 199.855 21.7437 199.905 21.7744 199.96L22.0693 200.404L23.1597 202.122H23.0567L26.3327 198.294L26.4123 198.195L26.4872 198.298L29.2109 202.098H29.0331L31.8832 198.509C31.9441 198.434 32.0049 198.359 32.0564 198.289L32.15 198.172L32.2436 198.284L35.4307 202.098H35.2528L37.9766 198.303L38.0561 198.191L38.131 198.303C39.2121 199.843 40.1294 201.148 40.8127 202.131H40.7144L41.875 200.727C42.0014 200.582 42.1043 200.465 42.1839 200.367C42.217 200.327 42.253 200.289 42.2915 200.254Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_22"
          d="M42.986 195.363C42.986 195.429 38.189 195.485 32.2782 195.485C26.3673 195.485 21.5703 195.429 21.5703 195.363C21.5703 195.298 26.3626 195.246 32.2782 195.246C38.1937 195.246 42.986 195.298 42.986 195.363Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_23"
          d="M177.137 26.4866L173.215 26.5078L173.32 46.0231L177.242 46.0019L177.137 26.4866Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_24"
          d="M149.458 26.4529L139.303 26.5078L139.361 37.281L149.516 37.2261L149.458 26.4529Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_25"
          d="M159.513 26.4529L149.357 26.5078L149.416 37.281L159.571 37.2261L159.513 26.4529Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_26"
          d="M139.284 29.5727C146.035 29.6289 152.79 29.5977 159.548 29.4791C159.577 29.4791 159.604 29.4678 159.624 29.4476C159.644 29.4274 159.656 29.4 159.656 29.3715C159.656 29.3429 159.644 29.3155 159.624 29.2954C159.604 29.2752 159.577 29.2638 159.548 29.2638C152.8 29.2264 146.032 29.2638 139.284 29.3902C139.263 29.3949 139.245 29.4065 139.231 29.4231C139.218 29.4397 139.211 29.4602 139.211 29.4814C139.211 29.5027 139.218 29.5232 139.231 29.5398C139.245 29.5564 139.263 29.568 139.284 29.5727Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_27"
          d="M151.357 37.197L132.904 37.2969L132.952 46.0764L151.405 45.9766L151.357 37.197Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_28"
          d="M169.73 37.0134L151.277 37.1133L151.325 45.8928L169.778 45.793L169.73 37.0134Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_29"
          d="M132.906 39.7374C145.163 39.8731 157.462 39.7374 169.724 39.5549C169.752 39.5549 169.78 39.5435 169.8 39.5233C169.82 39.5031 169.831 39.4758 169.831 39.4472C169.831 39.4187 169.82 39.3913 169.8 39.3711C169.78 39.3509 169.752 39.3396 169.724 39.3396C157.467 39.2741 145.163 39.2787 132.906 39.5502C132.881 39.5502 132.857 39.56 132.84 39.5776C132.822 39.5951 132.812 39.619 132.812 39.6438C132.812 39.6686 132.822 39.6924 132.84 39.71C132.857 39.7275 132.881 39.7374 132.906 39.7374Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_30"
          d="M197.541 46.0703H126.049V49.2153H197.541V46.0703Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_31"
          d="M140.65 47.5312H137.748V58.2625H140.65V47.5312Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_32"
          d="M183.976 47.5312H181.074V58.2625H183.976V47.5312Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_33"
          d="M180.975 19.1741L177.053 19.1953L177.198 46.0347L181.12 46.0135L180.975 19.1741Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_34"
          d="M187.078 24.2834L180.984 24.3164L181.102 46.0687L187.195 46.0358L187.078 24.2834Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_35"
          d="M187.068 28.4386C185.043 28.5817 183.01 28.5817 180.984 28.4386C183.01 28.3017 185.043 28.3017 187.068 28.4386Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_36"
          d="M187.078 27.5292C186.066 27.6316 185.048 27.666 184.031 27.6321C183.014 27.6658 181.997 27.6314 180.984 27.5292C183.01 27.3861 185.043 27.3861 187.068 27.5292H187.078Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_37"
          d="M187.068 42.7003C185.043 42.8434 183.01 42.8434 180.984 42.7003C183.01 42.5634 185.043 42.5634 187.068 42.7003Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_38"
          d="M187.068 41.7909C185.043 41.9278 183.01 41.9278 180.984 41.7909C183.01 41.6478 185.043 41.6478 187.068 41.7909Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_39"
          d="M184.103 39.789C184.047 39.789 184 37.5941 184 34.889C184 32.184 184.047 29.9844 184.103 29.9844C184.159 29.9844 184.211 32.1793 184.211 34.889C184.211 37.5987 184.164 39.789 184.103 39.789Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_40"
          d="M193.739 29.6172H187.107V46.0346H193.739V29.6172Z"
          fill="#EBEBEB"
        />
        <path
          id="Vector_41"
          d="M179.003 24.9276C179.626 24.9276 180.131 24.4227 180.131 23.7998C180.131 23.1768 179.626 22.6719 179.003 22.6719C178.38 22.6719 177.875 23.1768 177.875 23.7998C177.875 24.4227 178.38 24.9276 179.003 24.9276Z"
          fill="#E0E0E0"
        />
        <path
          id="Vector_42"
          d="M179.305 26.875H178.607V42.8432H179.305V26.875Z"
          fill="#E0E0E0"
        />
      </g>
      <g id="freepik--Floor--inject-64">
        <path
          id="Vector_43"
          d="M217.467 215.11C217.467 215.18 172.483 215.232 117.01 215.232C61.5384 215.232 16.5449 215.18 16.5449 215.11C16.5449 215.04 61.5197 214.988 117.01 214.988C172.501 214.988 217.467 215.044 217.467 215.11Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--Character--inject-64">
        <path
          id="Vector_44"
          d="M69.7474 43.1445C71.9544 45.8454 73.1495 49.232 73.1264 52.7198C73.103 54.6948 72.7379 56.871 73.8892 58.4762C74.7597 59.693 76.3509 60.3061 77.0576 61.6259C77.9093 63.2124 77.1839 65.2201 77.7081 66.9423C78.4475 69.3853 81.3117 70.4102 83.0105 72.315C83.7347 73.1573 84.2413 74.1642 84.4861 75.2477C84.7309 76.3312 84.7063 77.4582 84.4145 78.53C84.105 79.5973 83.5453 80.5754 82.7818 81.3829C82.0182 82.1903 81.073 82.8039 80.0247 83.1726C78.9053 83.6138 77.6567 83.5937 76.5521 83.1164C75.4055 82.5454 74.6801 81.3708 74.1185 80.2242C72.9906 77.9684 63.0831 65.777 62.5215 63.3153"
          fill="#263238"
        />
        <path
          id="Vector_45"
          d="M62.563 40.3212C58.5102 39.666 54.607 42.357 52.9082 46.0916C51.2094 49.8262 51.1532 54.0476 51.0362 58.166C50.9192 62.2844 50.6197 66.5526 48.5277 70.0813C47.1986 72.323 45.1394 74.2933 44.8165 76.872C44.5263 79.1839 45.7244 81.5145 45.3266 83.8124C44.9803 85.8154 43.4546 87.5564 43.5154 89.5828C43.5903 92.0258 46.1035 93.865 48.5418 93.9306C50.98 93.9961 53.2639 92.7184 55.178 91.2021C58.2966 88.726 60.7921 85.5541 62.4648 81.9404"
          fill="#263238"
        />
        <path
          id="Vector_46"
          d="M55.9087 49.9384C55.7814 48.9189 55.8602 47.8842 56.1404 46.8958C56.4207 45.9073 56.8966 44.9852 57.54 44.1842C58.1834 43.3832 58.9812 42.7197 59.886 42.2329C60.7907 41.7461 61.7841 41.4461 62.8071 41.3506C66.8927 40.9574 70.529 44.0041 71.1421 48.0664C71.6803 51.6278 72.139 55.2221 72.1249 56.5278C72.0735 60.4637 69.7849 61.9941 68.8489 62.4574C68.5122 62.5782 68.1641 62.6645 67.81 62.7148V62.7429L68.6805 67.2637C69.0783 70.2262 67.4262 72.8797 64.4685 73.2962C61.5107 73.7128 59.1847 71.4523 58.7308 68.4899L55.9087 49.9384Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_47"
          d="M70.2976 49.8746C70.2321 49.9682 69.7126 49.6921 69.048 49.7904C68.3835 49.8886 67.9389 50.2911 67.8546 50.2209C67.7704 50.1507 67.8546 50.0337 68.0605 49.8465C68.3165 49.5972 68.6436 49.4337 68.9965 49.3785C69.3429 49.3251 69.6972 49.3842 70.0074 49.547C70.2414 49.6968 70.3303 49.8372 70.2976 49.8746Z"
          fill="#263238"
        />
        <path
          id="Vector_48"
          d="M64.3562 51.3331C64.2907 51.4267 63.7712 51.1459 63.1019 51.2442C62.4327 51.3425 61.9975 51.7496 61.9132 51.6794C61.829 51.6092 61.9132 51.4876 62.1191 51.305C62.375 51.0557 62.7022 50.8922 63.0551 50.837C63.4019 50.7877 63.7554 50.8482 64.066 51.0102C64.2953 51.1553 64.3889 51.291 64.3562 51.3331Z"
          fill="#263238"
        />
        <path
          id="Vector_49"
          d="M66.8439 54.8687C67.1787 54.7076 67.5325 54.5897 67.8969 54.5177C68.0654 54.4755 68.2198 54.4194 68.2339 54.2977C68.2187 54.1267 68.1536 53.964 68.0467 53.8297L67.3494 52.5848C66.3806 50.8439 65.6552 49.4024 65.7254 49.3603C65.7956 49.3182 66.6614 50.7081 67.5974 52.4491C67.8361 52.8797 68.0654 53.2915 68.2713 53.6799C68.4073 53.8703 68.4734 54.1017 68.4585 54.3351C68.4431 54.399 68.4131 54.4584 68.3709 54.5088C68.3286 54.5591 68.2754 54.599 68.2152 54.6253C68.1239 54.6652 68.028 54.6935 67.9297 54.7095C67.5762 54.8097 67.2112 54.8632 66.8439 54.8687Z"
          fill="#263238"
        />
        <path
          id="Vector_50"
          d="M67.7411 62.8525C67.7411 62.8525 65.1999 63.4375 61.6992 61.9727C61.6992 61.9727 63.2109 65.2253 67.9798 64.0693L67.7411 62.8525Z"
          fill="#EB996E"
        />
        <path
          id="Vector_51"
          d="M64.0566 49.5095C64.0191 49.7014 63.3405 49.7108 62.573 49.9214C61.8055 50.132 61.2018 50.4315 61.0754 50.2864C61.0192 50.2162 61.1035 50.029 61.3328 49.8184C61.6416 49.5543 62.0064 49.364 62.3997 49.2618C62.793 49.1596 63.2043 49.1483 63.6026 49.2287C63.9115 49.2989 64.0566 49.4206 64.0566 49.5095Z"
          fill="#263238"
        />
        <path
          id="Vector_52"
          d="M69.7431 48.4348C69.6495 48.6033 69.1674 48.5144 68.6152 48.5846C68.0629 48.6548 67.609 48.8373 67.4779 48.6922C67.4218 48.622 67.4779 48.4629 67.6558 48.2898C67.9012 48.0722 68.2092 47.9378 68.5356 47.906C68.858 47.8672 69.1845 47.9276 69.4716 48.0792C69.6963 48.2055 69.7852 48.3506 69.7431 48.4348Z"
          fill="#263238"
        />
        <path
          id="Vector_53"
          d="M62.9836 52.1558C62.9939 52.2282 63.0185 52.2978 63.0559 52.3607C63.0933 52.4235 63.1429 52.4783 63.2016 52.5219C63.2604 52.5654 63.3273 52.5968 63.3983 52.6143C63.4693 52.6318 63.5431 52.635 63.6154 52.6238C63.6857 52.6157 63.7536 52.5937 63.8153 52.5591C63.877 52.5245 63.9312 52.4779 63.9748 52.4222C64.0183 52.3665 64.0504 52.3026 64.069 52.2344C64.0877 52.1661 64.0926 52.0949 64.0834 52.0247C64.0614 51.879 63.9826 51.7479 63.8642 51.6602C63.7458 51.5725 63.5974 51.5353 63.4516 51.5567C63.3811 51.5642 63.3128 51.5858 63.2508 51.6202C63.1887 51.6546 63.1343 51.7011 63.0906 51.757C63.047 51.8129 63.015 51.877 62.9966 51.9455C62.9782 52.014 62.9738 52.0855 62.9836 52.1558Z"
          fill="#263238"
        />
        <path
          id="Vector_54"
          d="M68.8332 50.8784C68.8552 51.0241 68.934 51.1552 69.0524 51.2429C69.1708 51.3307 69.3192 51.3679 69.465 51.3464C69.5353 51.3383 69.6032 51.3163 69.6649 51.2817C69.7266 51.2471 69.7809 51.2006 69.8244 51.1449C69.868 51.0891 69.9 51.0253 69.9186 50.957C69.9373 50.8888 69.9422 50.8175 69.933 50.7474C69.9111 50.6016 69.8322 50.4706 69.7138 50.3828C69.5954 50.2951 69.447 50.2579 69.3012 50.2794C69.2307 50.2869 69.1624 50.3084 69.1004 50.3429C69.0383 50.3773 68.9839 50.4238 68.9402 50.4797C68.8966 50.5356 68.8646 50.5997 68.8462 50.6682C68.8278 50.7367 68.8234 50.8082 68.8332 50.8784Z"
          fill="#263238"
        />
        <path
          id="Vector_55"
          d="M67.8972 56.1583C67.7135 56.1011 67.5156 56.1101 67.3378 56.1836C67.16 56.2571 67.0135 56.3906 66.9238 56.5608C66.8381 56.7171 66.8033 56.8962 66.8243 57.0732C66.8453 57.2502 66.921 57.4163 67.0408 57.5483C67.1683 57.6735 67.3363 57.7494 67.5146 57.7623C67.6929 57.7751 67.87 57.7242 68.0142 57.6185C68.1948 57.4541 68.3039 57.2257 68.3184 56.982C68.3502 56.7585 68.2968 56.5313 68.1687 56.3455C68.1029 56.2546 68.0091 56.188 67.9016 56.1558C67.7942 56.1237 67.6792 56.1278 67.5743 56.1677"
          fill="#EB996E"
        />
        <path
          id="Vector_56"
          d="M70.6081 44.9022C70.2407 43.4195 69.3241 42.1315 68.0435 41.2986C66.9952 40.5415 65.7501 40.1042 64.4586 40.0397C63.1591 39.9838 61.8903 40.4448 60.9299 41.322C60.2483 41.9975 59.8586 42.9132 59.8441 43.8726L59.919 43.2174C59.7223 43.7506 59.7223 44.3364 59.919 44.8695C60.0266 45.155 60.1577 45.4451 60.27 45.7306C60.605 46.5556 61.2265 47.2319 62.0203 47.6354C62.3798 47.8282 62.7824 47.9264 63.1903 47.9208C63.3945 47.9167 63.5953 47.8681 63.7788 47.7784C63.9623 47.6887 64.124 47.56 64.2527 47.4014C64.5432 46.8941 64.6334 46.2964 64.5054 45.7259C64.8125 46.2896 65.2507 46.7712 65.783 47.1299C66.0548 47.3036 66.3781 47.3784 66.6986 47.3418C67.0191 47.3051 67.3171 47.1592 67.5427 46.9287C67.9265 46.4607 67.7767 45.7212 67.5427 45.1409C67.9048 45.6883 68.4119 46.1242 69.0075 46.3998C69.1643 46.4897 69.3379 46.5462 69.5176 46.5655C69.6972 46.5848 69.8789 46.5667 70.0512 46.5122C70.1889 46.4439 70.3093 46.3452 70.4034 46.2236C70.4974 46.102 70.5626 45.9606 70.5941 45.8102C70.6635 45.512 70.6683 45.2024 70.6081 44.9022Z"
          fill="#263238"
        />
        <path
          id="Vector_57"
          d="M67.224 46.0936C67.1818 46.0936 67.1912 45.5367 67.0087 44.6896C66.7981 43.564 66.2322 42.5355 65.3941 41.7553C64.9334 41.3363 64.3776 41.036 63.7748 40.8801C63.2811 40.7589 62.767 40.7462 62.2678 40.8427C61.8078 40.9502 61.3684 41.132 60.9668 41.3809C60.9668 41.3809 61.0464 41.2639 61.2523 41.1141C61.5478 40.9074 61.8796 40.7581 62.2304 40.6742C62.7553 40.5513 63.3014 40.5513 63.8263 40.6742C64.473 40.8356 65.0686 41.1576 65.5579 41.6102C66.4355 42.4226 67.0085 43.511 67.1818 44.6943C67.2375 45.0441 67.2657 45.3978 67.2661 45.752C67.2719 45.8674 67.2576 45.983 67.224 46.0936Z"
          fill="#455A64"
        />
        <path
          id="Vector_58"
          d="M110.363 100.627L92.3685 93.4904C92.3685 93.4904 83.1536 81.402 83.3455 81.168L76.873 88.2535L86.2799 100.978L108.084 106.089L111.828 105.05C111.004 101.077 110.363 100.627 110.363 100.627Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_59"
          d="M71.1001 66.1977L68.6477 65.2617L58.0616 66.6049V68.4769L57.7574 68.5143C55.4754 68.9995 53.2867 69.8497 51.2756 71.0322C49.3918 72.1821 47.8949 73.8693 46.9776 75.8767C46.0602 77.8841 45.7642 80.12 46.1276 82.2969C46.5581 84.9739 47.3912 88.2265 49.0011 90.1078C52.0759 93.7068 54.8839 89.2608 54.8839 89.2608C54.8839 89.2608 56.812 93.66 56.6997 95.7426C56.6061 97.4882 55.8386 101.12 55.5905 102.252C55.5803 102.298 55.5795 102.345 55.588 102.39C55.5965 102.436 55.6142 102.479 55.6401 102.518C55.6659 102.556 55.6993 102.589 55.7383 102.614C55.7772 102.64 55.8209 102.657 55.8667 102.664L78.1996 106.797L78.3073 101.335L77.5959 78.8712L76.5897 70.1476C76.5897 70.1476 76.6225 65.9824 71.1001 66.1977Z"
          fill="#F37032"
        />
        <path
          id="Vector_60"
          d="M76.2324 68.7383L84.75 81.042L77.8938 89.3911L76.2324 68.7383Z"
          fill="#F37032"
        />
        <path
          id="Vector_61"
          d="M78.1143 94.5461C78.0837 94.2821 78.0728 94.0162 78.0816 93.7505C78.0816 93.1983 78.0816 92.4729 78.0535 91.5884C78.012 89.2144 77.8418 86.8444 77.5434 84.4888C77.1924 81.7276 76.6542 79.2613 76.247 77.4688L75.7509 75.3628C75.679 75.1081 75.6258 74.8484 75.5918 74.5859C75.6982 74.8291 75.7828 75.0812 75.8445 75.3394C75.9896 75.8074 76.1862 76.5422 76.4108 77.4314C77.0151 79.7405 77.4746 82.085 77.7867 84.4514C78.0876 86.8168 78.2345 89.1992 78.2266 91.5837C78.2266 92.5197 78.2032 93.2404 78.1752 93.7505C78.1776 94.017 78.1572 94.2831 78.1143 94.5461Z"
          fill="#263238"
        />
        <path
          id="Vector_62"
          d="M57.143 75.9514C57.143 75.9889 56.4972 75.9842 55.4629 76.0357C54.1134 76.1089 52.7712 76.2825 51.4475 76.5551C50.1241 76.8329 48.8227 77.2067 47.5537 77.6737C46.5803 78.034 45.9953 78.3008 45.9766 78.2633C46.0965 78.1693 46.2288 78.0922 46.3697 78.034C46.6271 77.8936 47.0108 77.7158 47.4929 77.5145C50.0182 76.4717 52.7171 75.9129 55.4489 75.8672C55.973 75.8672 56.3849 75.8672 56.6891 75.8953C56.8424 75.8903 56.9956 75.9093 57.143 75.9514Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_63"
          d="M76.8351 81.5354C76.4928 81.6598 76.1356 81.7384 75.7727 81.7694C74.0421 82.022 72.2889 82.0817 70.5452 81.9472C70.181 81.941 69.8192 81.8875 69.4688 81.7881C69.83 81.756 70.1933 81.756 70.5545 81.7881C71.2191 81.7881 72.141 81.7881 73.1566 81.7881C74.1722 81.7881 75.0894 81.6851 75.754 81.6243C76.1109 81.562 76.4728 81.5322 76.8351 81.5354Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_64"
          d="M80.7552 76.0544C80.2393 76.6504 79.6212 77.1496 78.93 77.5286C78.2774 77.9697 77.5492 78.287 76.7818 78.4646C76.7538 78.399 77.7178 77.9966 78.8036 77.3039C79.8894 76.6113 80.7084 75.9982 80.7552 76.0544Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_65"
          d="M77.3672 70.2026C75.8907 71.5308 74.0093 72.3223 72.0273 72.449C72.0273 72.3741 73.3143 72.1776 74.7932 71.5458C76.2721 70.914 77.3204 70.1418 77.3672 70.2026Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_66"
          d="M77.8259 91.0426C77.6882 91.1351 77.5406 91.212 77.3859 91.2719C77.0911 91.4123 76.6652 91.5854 76.1223 91.7867C74.7119 92.2935 73.256 92.6634 71.7746 92.8912C70.2934 93.1198 68.7933 93.2029 67.2959 93.1392C66.7202 93.1158 66.2569 93.0737 65.9387 93.0316C65.772 93.0205 65.6072 92.9907 65.4473 92.9427C65.4473 92.9005 66.1586 92.9426 67.3193 92.9707C70.2948 92.9985 73.2552 92.5433 76.0849 91.6229C77.1519 91.2719 77.8118 91.0051 77.8259 91.0426Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_67"
          d="M77.9945 97.4375C77.9945 97.4375 77.929 97.4843 77.7933 97.5545L77.1942 97.8166C76.6794 98.0599 75.9166 98.3782 74.9618 98.7526C74.0071 99.127 72.8512 99.4873 71.5501 99.843C68.7217 100.605 65.8184 101.055 62.8921 101.186C61.5443 101.238 60.3322 101.233 59.3119 101.186C58.2917 101.139 57.4727 101.065 56.9064 100.985L56.2559 100.896C56.1793 100.89 56.1037 100.875 56.0312 100.849C56.1072 100.837 56.1846 100.837 56.2606 100.849L56.9158 100.891C57.482 100.938 58.3198 100.985 59.3166 101.013C60.3135 101.041 61.5443 101.013 62.8828 100.966C64.2213 100.919 65.6908 100.751 67.2211 100.498C68.7515 100.245 70.1929 99.9413 71.494 99.6137C72.795 99.2861 73.9463 98.9164 74.901 98.5747C75.8557 98.2331 76.6326 97.9476 77.1568 97.7323L77.7652 97.4937C77.8394 97.467 77.9163 97.4481 77.9945 97.4375Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_68"
          d="M36.9122 196.898L34.3803 208.332L29.7612 216.798C29.6826 216.942 29.6346 217.101 29.62 217.265C29.6054 217.429 29.6246 217.594 29.6763 217.75C29.7281 217.907 29.8113 218.051 29.9209 218.173C30.0305 218.296 30.1641 218.395 30.3134 218.464C30.4868 218.543 30.6767 218.58 30.8672 218.571C31.0578 218.562 31.2434 218.508 31.4085 218.412C33.552 217.177 41.4191 212.576 41.5548 211.729C41.7186 210.751 45.0273 199.847 45.0273 199.847L36.9122 196.898Z"
          fill="#F37032"
        />
        <g id="Group" opacity="0.6">
          <path
            id="Vector_69"
            d="M30.3457 218.453L41.7789 210.965L41.6573 211.433C41.5572 211.85 41.3117 212.219 40.9646 212.472C40.0286 213.141 37.4219 214.938 31.4783 218.411C31.3076 218.511 31.1149 218.567 30.9173 218.574C30.7197 218.582 30.5233 218.54 30.3457 218.453Z"
            fill="white"
          />
        </g>
        <g id="Group_2" opacity="0.6">
          <path
            id="Vector_70"
            d="M40.2998 206.619C40.1347 206.688 40.0008 206.815 39.9239 206.976C39.847 207.138 39.8326 207.322 39.8833 207.494C39.9457 207.661 40.0698 207.798 40.23 207.876C40.3901 207.954 40.5742 207.968 40.7444 207.915C40.9212 207.842 41.0643 207.705 41.1457 207.532C41.227 207.359 41.2408 207.162 41.1843 206.979C41.1014 206.813 40.9583 206.686 40.7842 206.622C40.6102 206.559 40.4184 206.564 40.2483 206.637"
            fill="white"
          />
        </g>
        <path
          id="Vector_71"
          d="M34.1151 214.175C33.9263 213.754 33.6613 213.372 33.3335 213.047C32.956 212.784 32.532 212.595 32.084 212.49C32.084 212.457 32.2478 212.406 32.5239 212.434C32.8832 212.48 33.2214 212.63 33.4973 212.864C33.7754 213.09 33.9806 213.393 34.087 213.735C34.1666 214.002 34.1432 214.175 34.1151 214.175Z"
          fill="#263238"
        />
        <path
          id="Vector_72"
          d="M32.9519 215.472C32.8864 215.509 32.6103 215.051 32.0627 214.737C31.7134 214.575 31.3539 214.436 30.9863 214.32C31.1884 214.254 31.4033 214.237 31.6132 214.27C31.8232 214.304 32.0222 214.387 32.1938 214.512C32.8162 214.873 33.0174 215.458 32.9519 215.472Z"
          fill="#263238"
        />
        <path
          id="Vector_73"
          d="M36.1544 212.634C35.7564 212.192 35.3245 211.782 34.8627 211.408C34.3539 211.098 33.8219 210.827 33.2715 210.598C33.9044 210.585 34.5214 210.798 35.0124 211.197C35.5538 211.523 35.9593 212.033 36.1544 212.634Z"
          fill="#263238"
        />
        <path
          id="Vector_74"
          d="M37.193 209.174C37.1462 209.235 36.5799 208.819 35.789 208.589C34.9981 208.36 34.282 208.398 34.2773 208.318C34.7982 208.183 35.3459 208.191 35.8624 208.342C36.379 208.493 36.8451 208.781 37.2117 209.174H37.193Z"
          fill="#263238"
        />
        <path
          id="Vector_75"
          d="M37.9814 205.721C37.5249 205.439 37.0321 205.22 36.5166 205.071C35.9855 204.999 35.4471 204.999 34.916 205.071C34.916 205.043 35.0611 204.93 35.3606 204.841C35.7543 204.735 36.1676 204.721 36.5674 204.802C36.9672 204.884 37.3424 205.057 37.6632 205.309C37.9019 205.534 38.0001 205.703 37.9814 205.721Z"
          fill="#263238"
        />
        <path
          id="Vector_76"
          d="M36.7619 204.561C36.7622 204.413 36.7941 204.266 36.8555 204.131C36.9881 203.744 37.1983 203.389 37.4732 203.087C37.6531 202.847 37.9061 202.673 38.1939 202.591C38.2919 202.575 38.3925 202.588 38.4826 202.63C38.5727 202.672 38.6482 202.74 38.6994 202.825C38.7854 202.999 38.8037 203.199 38.7509 203.386C38.6309 203.762 38.3841 204.084 38.0528 204.297C37.7216 204.511 37.3264 204.602 36.935 204.556C36.5491 204.501 36.188 204.333 35.8973 204.074C35.6067 203.814 35.3994 203.474 35.3017 203.096C35.2792 203 35.2772 202.901 35.2958 202.804C35.3143 202.707 35.353 202.615 35.4093 202.535C35.474 202.459 35.561 202.406 35.6578 202.383C35.7546 202.361 35.856 202.369 35.9475 202.408C36.2121 202.54 36.4378 202.739 36.6027 202.984C36.8508 203.309 37.0393 203.675 37.1597 204.065C37.2167 204.204 37.2438 204.354 37.2392 204.505C37.0506 204 36.7871 203.527 36.4577 203.101C36.3043 202.901 36.1053 202.74 35.8773 202.633C35.8272 202.611 35.7714 202.606 35.7182 202.619C35.6651 202.632 35.6175 202.661 35.5825 202.703C35.5498 202.758 35.5288 202.82 35.5207 202.883C35.5127 202.947 35.5178 203.011 35.5357 203.073C35.6333 203.39 35.8187 203.674 36.0704 203.891C36.3221 204.108 36.6299 204.249 36.9584 204.299C37.2894 204.337 37.6237 204.263 37.9067 204.087C38.1898 203.911 38.4048 203.644 38.5169 203.33C38.5622 203.203 38.5622 203.064 38.5169 202.937C38.4903 202.889 38.4494 202.851 38.3999 202.827C38.3504 202.804 38.2947 202.796 38.2407 202.806C37.9968 202.873 37.7795 203.014 37.6183 203.209C37.2593 203.608 36.9698 204.066 36.7619 204.561Z"
          fill="#263238"
        />
        <g id="Group_3" opacity="0.3">
          <path
            id="Vector_77"
            d="M36.653 198.127L36.1055 200.748L44.3844 202.124L45.077 199.835L36.9479 196.887L36.653 198.127Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_78"
          d="M73.9026 201.096L73.2193 210.232C73.2193 210.232 82.2798 213.976 82.3172 215.698L64.5332 215.01L65.0012 200.727L73.9026 201.096Z"
          fill="#F37032"
        />
        <g id="Group_4" opacity="0.6">
          <path
            id="Vector_79"
            d="M67.7246 209.33C67.552 209.376 67.4024 209.484 67.3041 209.633C67.2057 209.783 67.1655 209.963 67.1911 210.14C67.2305 210.314 67.3347 210.466 67.4825 210.566C67.6302 210.666 67.8105 210.706 67.9867 210.678C68.1703 210.629 68.3293 210.514 68.433 210.355C68.5367 210.196 68.5778 210.004 68.5483 209.817C68.4892 209.639 68.3636 209.491 68.1979 209.404C68.0321 209.317 67.8391 209.297 67.6591 209.349"
            fill="white"
          />
        </g>
        <g id="Group_5" opacity="0.6">
          <path
            id="Vector_80"
            d="M64.4414 214.965L64.5444 213.523L81.5562 214.707C81.5562 214.707 82.3377 215.082 82.2254 215.643L64.4414 214.965Z"
            fill="white"
          />
        </g>
        <path
          id="Vector_81"
          d="M73.499 210.14C73.499 210.229 73.0591 210.253 72.6238 210.515C72.1886 210.777 71.9452 211.132 71.8657 211.095C71.7861 211.058 71.9359 210.561 72.4694 210.253C73.0029 209.944 73.5224 210.061 73.499 210.14Z"
          fill="#263238"
        />
        <path
          id="Vector_82"
          d="M75.3578 211.008C75.3578 211.097 74.9928 211.228 74.6839 211.583C74.375 211.939 74.2767 212.323 74.1878 212.318C74.0989 212.313 74.0661 211.817 74.4592 211.382C74.8524 210.947 75.3578 210.914 75.3578 211.008Z"
          fill="#263238"
        />
        <path
          id="Vector_83"
          d="M76.3243 213.351C76.2447 213.351 76.1418 212.925 76.3805 212.462C76.6192 211.998 77.0357 211.821 77.0684 211.895C77.1012 211.97 76.8438 212.214 76.6519 212.597C76.46 212.981 76.4085 213.346 76.3243 213.351Z"
          fill="#263238"
        />
        <path
          id="Vector_84"
          d="M73.4476 208.022C73.4102 208.097 73.0171 207.961 72.5116 207.976C72.0062 207.99 71.6318 208.13 71.5756 208.055C71.5195 207.98 71.9126 207.685 72.5116 207.676C73.1107 207.667 73.5038 207.957 73.4476 208.022Z"
          fill="#263238"
        />
        <g id="Group_6" opacity="0.3">
          <path
            id="Vector_85"
            d="M73.7483 202.865L73.6266 204.494L64.8984 204.073L64.9593 202.191L73.7483 202.865Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_86"
          d="M73.5075 206.271C73.2134 206.342 72.9053 206.329 72.6183 206.234C72.2938 206.166 71.9793 206.058 71.6823 205.911C71.509 205.826 71.3417 205.729 71.1815 205.621C71.0838 205.561 70.9955 205.487 70.9194 205.401C70.8678 205.334 70.8398 205.251 70.8398 205.167C70.8398 205.082 70.8678 205 70.9194 204.933C70.9649 204.874 71.0239 204.826 71.0915 204.794C71.1591 204.763 71.2333 204.748 71.3079 204.75C71.4206 204.755 71.5322 204.774 71.6402 204.806C71.8274 204.861 72.0092 204.933 72.183 205.022C72.4786 205.166 72.7488 205.357 72.9833 205.588C73.3811 205.986 73.5075 206.318 73.4794 206.332C73.4513 206.346 73.2501 206.079 72.8429 205.747C72.6039 205.56 72.343 205.403 72.066 205.279C71.9009 205.211 71.7322 205.151 71.5606 205.101C71.3734 205.045 71.2143 205.04 71.1628 205.101C71.1113 205.162 71.1628 205.148 71.1628 205.204C71.2189 205.266 71.2835 205.32 71.3547 205.363C71.5048 205.468 71.6611 205.563 71.8227 205.649C72.0926 205.798 72.3762 205.92 72.6698 206.014C72.9548 206.08 73.2347 206.166 73.5075 206.271Z"
          fill="#263238"
        />
        <path
          id="Vector_87"
          d="M73.4228 206.451C73.2673 206.189 73.197 205.885 73.2216 205.581C73.2234 205.251 73.2771 204.924 73.3807 204.612C73.4479 204.429 73.5309 204.252 73.6288 204.083C73.6813 203.967 73.7627 203.867 73.8651 203.791C73.9676 203.716 74.0876 203.668 74.2138 203.652C74.2937 203.658 74.3704 203.685 74.4351 203.733C74.4998 203.78 74.5496 203.845 74.5788 203.919C74.6194 204.024 74.6447 204.134 74.6537 204.247C74.6844 204.445 74.6844 204.647 74.6537 204.846C74.5911 205.176 74.448 205.487 74.2372 205.749C73.8721 206.217 73.5071 206.287 73.4977 206.259C73.4884 206.231 73.7785 206.058 74.064 205.623C74.2278 205.374 74.3349 205.093 74.3775 204.799C74.4013 204.628 74.4013 204.455 74.3775 204.284C74.3541 204.097 74.2886 203.938 74.2184 203.957C74.1482 203.975 73.9751 204.088 73.8955 204.237C73.8041 204.387 73.7244 204.543 73.6568 204.705C73.5485 204.988 73.4792 205.284 73.4509 205.585C73.3901 206.109 73.4696 206.451 73.4228 206.451Z"
          fill="#263238"
        />
        <path
          id="Vector_88"
          d="M55.4639 102.527C55.4639 102.527 52.6559 102.653 50.7839 112.257C48.9119 121.86 34.6426 199.674 34.6426 199.674L44.9901 199.768L64.4869 125.787L63.1906 202.071L73.7019 202.875C73.7019 202.875 81.5877 118.5 81.6579 113.59C81.7515 107.469 78.2368 101.277 78.2368 101.277L55.4639 102.527Z"
          fill="#263238"
        />
        <path
          id="Vector_89"
          d="M69.7534 101.824C69.8189 101.824 68.7425 107.323 67.3525 114.076C65.9626 120.83 64.7832 126.296 64.7177 126.282C64.6522 126.268 65.7239 120.783 67.1139 114.03C68.5038 107.276 69.7019 101.81 69.7534 101.824Z"
          fill="#455A64"
        />
        <path
          id="Vector_90"
          d="M71.3651 103.139C71.3651 103.111 71.6459 103.027 71.9688 103.312C72.0606 103.395 72.1332 103.497 72.1816 103.611C72.2301 103.725 72.2533 103.848 72.2496 103.972C72.2379 104.129 72.182 104.278 72.0884 104.404C71.9948 104.53 71.8673 104.627 71.7208 104.683C71.5779 104.748 71.4197 104.772 71.2641 104.751C71.1086 104.73 70.9619 104.666 70.841 104.566C70.7505 104.482 70.679 104.378 70.6314 104.264C70.5838 104.149 70.5611 104.026 70.5648 103.902C70.5648 103.471 70.855 103.322 70.8597 103.35C70.7808 103.521 70.7393 103.708 70.738 103.897C70.7443 103.992 70.7695 104.085 70.812 104.17C70.8546 104.255 70.9138 104.331 70.986 104.393C71.0784 104.457 71.1852 104.496 71.2968 104.508C71.4083 104.519 71.521 104.503 71.6244 104.459C71.7279 104.416 71.8188 104.348 71.8888 104.26C71.9588 104.172 72.0056 104.068 72.025 103.958C72.0319 103.863 72.0197 103.768 71.9892 103.678C71.9586 103.588 71.9103 103.505 71.8472 103.434C71.6178 103.167 71.3604 103.176 71.3651 103.139Z"
          fill="#455A64"
        />
        <path
          id="Vector_91"
          d="M70.8909 106.99C70.8909 106.962 71.1811 106.99 71.3589 107.379C71.4041 107.49 71.4246 107.609 71.419 107.729C71.4133 107.848 71.3816 107.965 71.3262 108.071C71.2457 108.198 71.1323 108.299 70.9983 108.366C70.8643 108.433 70.7147 108.461 70.5656 108.449C70.4164 108.437 70.2733 108.385 70.1517 108.298C70.0301 108.211 69.9346 108.092 69.8754 107.954C69.838 107.842 69.8257 107.722 69.8395 107.604C69.8532 107.486 69.8926 107.372 69.9549 107.271C70.1749 106.92 70.4744 106.929 70.465 106.958C70.4557 106.986 70.2404 107.051 70.1047 107.351C70.036 107.519 70.036 107.707 70.1047 107.875C70.1535 107.968 70.2251 108.047 70.3127 108.105C70.4003 108.162 70.5011 108.197 70.6057 108.205C70.7103 108.214 70.8153 108.196 70.911 108.153C71.0067 108.11 71.0899 108.043 71.153 107.959C71.2412 107.799 71.263 107.611 71.2138 107.435C71.0781 107.117 70.8675 107.023 70.8909 106.99Z"
          fill="#455A64"
        />
        <path
          id="Vector_92"
          d="M60.9669 103.289C60.9477 103.45 60.9067 103.607 60.8452 103.757C60.699 104.186 60.5158 104.601 60.2977 104.997C59.5836 106.321 58.5523 107.447 57.2961 108.275C56.0399 109.102 54.5981 109.605 53.0998 109.738C52.6498 109.778 52.1973 109.778 51.7473 109.738C51.5888 109.733 51.4315 109.708 51.2793 109.663C51.2793 109.617 51.986 109.696 53.1045 109.556C54.5623 109.379 55.9592 108.866 57.1854 108.058C58.4116 107.25 59.4336 106.169 60.1713 104.899C60.7189 103.954 60.9248 103.275 60.9669 103.289Z"
          fill="#455A64"
        />
        <path
          id="Vector_93"
          d="M81.1456 110.104C81.1456 110.104 81.0239 110.048 80.832 109.917C80.5639 109.724 80.3133 109.508 80.0832 109.271C79.3135 108.492 78.713 107.563 78.3192 106.541C77.9254 105.519 77.7469 104.427 77.7947 103.332C77.8054 103.003 77.8477 102.676 77.9211 102.354C77.9725 102.125 78.0053 102.003 78.024 102.008C78.0427 102.013 77.9679 102.518 77.9679 103.337C77.9686 105.487 78.7675 107.56 80.2096 109.154C80.7571 109.758 81.169 110.067 81.1456 110.104Z"
          fill="#455A64"
        />
        <path
          id="Vector_94"
          d="M117.441 110.384C117.596 110.009 117.553 110.159 115.073 108.512C115.073 108.512 118.63 110.852 118.26 109.738C117.94 109.316 117.549 108.953 117.104 108.666C118.04 109.218 118.583 109.279 118.747 109.054C119.028 108.666 116.992 107.182 116.023 106.513C116.909 107.147 117.838 107.718 118.803 108.221C119.379 108.399 119.103 107.725 118.714 107.234C118.326 106.743 115.312 103.841 114.502 102.975C114.425 102.909 114.363 102.827 114.321 102.735C114.278 102.643 114.256 102.543 114.256 102.442C114.256 102.34 114.278 102.24 114.321 102.148C114.363 102.056 114.425 101.974 114.502 101.908C115.953 100.972 116.589 99.4792 116.571 98.9878C116.555 98.8772 116.504 98.7745 116.426 98.6945C116.348 98.6145 116.246 98.5613 116.136 98.5426C116.026 98.5239 115.912 98.5406 115.812 98.5903C115.712 98.64 115.63 98.7202 115.578 98.8193C115.212 99.2745 114.786 99.6776 114.31 100.017C113.942 100.305 113.527 100.528 113.084 100.677C112.569 100.846 110.037 100.705 109.494 100.429L107.768 106.284C107.768 106.284 114.034 109.214 115.223 109.785C116.683 110.477 117.333 110.669 117.441 110.384Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_95"
          d="M113.895 107.686C113.843 107.756 114.658 108.351 115.711 109.02C116.764 109.689 117.648 110.171 117.69 110.101C117.732 110.031 116.918 109.432 115.87 108.767C114.822 108.102 113.942 107.597 113.895 107.686Z"
          fill="#EB996E"
        />
        <path
          id="Vector_96"
          d="M114.533 106.4C114.486 106.47 115.319 107.153 116.405 107.93C117.491 108.707 118.389 109.282 118.436 109.217C118.483 109.151 117.655 108.463 116.564 107.687C115.474 106.91 114.585 106.334 114.533 106.4Z"
          fill="#EB996E"
        />
        <path
          id="Vector_97"
          d="M115.082 105.306C115.035 105.372 115.812 106.036 116.818 106.785C117.825 107.534 118.69 108.086 118.728 108.02C118.765 107.955 118.002 107.29 116.996 106.542C115.99 105.793 115.134 105.241 115.082 105.306Z"
          fill="#EB996E"
        />
        <path
          id="Vector_98"
          d="M51.3861 84.1311L55.9819 84.3838C56.3074 85.6668 56.7427 86.9194 57.2829 88.1278C60.9848 81.7068 63.8349 73.1003 64.565 69.6418C64.462 69.3017 64.3357 68.918 64.1859 68.4905C64.0738 67.8444 64.0929 67.1823 64.2421 66.5436C64.3684 65.7761 64.5837 64.7372 64.6445 64.2598C64.8458 62.7996 65.0798 62.5656 65.5805 62.7341C66.2732 62.9588 65.2951 66.8385 65.8613 66.9227C66.1702 66.9648 66.5399 65.6357 66.6523 64.5453C66.7646 63.4548 67.2513 60.104 67.6117 59.8653C68.1405 59.5377 68.5991 60.0572 68.4681 61.1429C68.3371 62.2287 68.1639 65.5187 68.7395 65.5608C69.3152 65.603 69.7832 60.0431 69.7832 60.0431C69.7832 60.0431 69.6943 58.8357 70.3588 58.8638C71.5616 58.9152 70.6256 64.7793 70.5226 65.3362C70.4478 65.72 71.0749 65.8042 71.131 65.3736C71.1872 64.9431 71.4773 59.8091 72.6988 59.8512C73.6348 59.884 71.9734 64.681 72.5023 65.7948C73.0311 66.9087 73.3962 62.0181 74.2947 62.0836C74.627 62.1117 74.875 62.1772 74.2619 64.9431C73.6636 67.1425 72.9465 69.3078 72.1138 71.4296C70.7098 79.1048 64.4433 103.656 54.6528 99.1632C49.1772 96.6501 46.6172 84.1872 46.6172 84.1872L51.3861 84.1311Z"
          fill="#FFBE9D"
        />
        <path
          id="Vector_99"
          d="M72.0902 71.4216C72.0983 71.3637 72.114 71.307 72.137 71.2532C72.1792 71.1315 72.2306 70.9724 72.3008 70.7852C72.4553 70.3406 72.6659 69.7228 72.942 68.9132C73.2181 68.1035 73.5504 67.1207 73.878 65.9601C74.0465 65.3844 74.1869 64.7573 74.3132 64.0881C74.3788 63.7511 74.4396 63.4048 74.4817 63.0491C74.4934 62.873 74.4934 62.6964 74.4817 62.5203C74.4817 62.3378 74.4396 62.188 74.2945 62.1833C74.1494 62.1786 74.0465 62.2676 73.9435 62.422C73.8503 62.5873 73.7735 62.7613 73.7142 62.9415C73.5832 63.3112 73.4802 63.7043 73.3772 64.1021C73.2743 64.4999 73.1807 64.9164 73.059 65.3376C73.0059 65.5684 72.9107 65.7873 72.7782 65.9835C72.7449 66.0219 72.7009 66.0496 72.6518 66.063C72.6209 66.0698 72.5889 66.0696 72.5581 66.0623C72.5273 66.055 72.4986 66.0409 72.474 66.0209C72.4202 65.9716 72.3758 65.9129 72.343 65.8478C72.2935 65.7328 72.2604 65.6115 72.2447 65.4874C72.2233 64.5435 72.3176 63.6004 72.5255 62.6794C72.605 62.2114 72.6893 61.7434 72.7501 61.2754C72.7782 61.0367 72.8063 60.8074 72.811 60.5547C72.8156 60.302 72.7782 60.0352 72.6799 59.9931C72.5816 59.951 72.343 60.082 72.2119 60.2786C72.0825 60.4862 71.9803 60.7095 71.9077 60.9431C71.7481 61.432 71.6276 61.9328 71.5474 62.4407C71.4584 62.9555 71.3882 63.4797 71.3274 64.0132C71.304 64.28 71.2759 64.5467 71.2525 64.8182L71.2151 65.2253C71.2201 65.3123 71.2059 65.3993 71.1735 65.4802C71.1412 65.561 71.0915 65.6338 71.0279 65.6933C70.9477 65.7519 70.851 65.7835 70.7518 65.7835C70.6525 65.7835 70.5558 65.7519 70.4756 65.6933C70.4302 65.6633 70.3918 65.6241 70.3627 65.5781C70.3337 65.5321 70.3147 65.4804 70.3071 65.4266C70.3 65.3769 70.3 65.3265 70.3071 65.2768V65.1785L70.4335 64.3595C70.5131 63.8073 70.5786 63.255 70.6301 62.6934C70.6816 62.1318 70.7237 61.5656 70.733 60.9993C70.7605 60.4386 70.7037 59.877 70.5646 59.3332C70.5323 59.1952 70.4486 59.0747 70.3306 58.9962C70.2741 58.9781 70.2134 58.9783 70.1571 58.9968C70.1007 59.0153 70.0517 59.0511 70.017 59.0992C69.8655 59.3762 69.8033 59.6934 69.8391 60.0071C69.7362 61.1069 69.6192 62.188 69.4601 63.2504C69.3805 63.7792 69.2916 64.308 69.1606 64.8275C69.1231 64.9539 69.0857 65.0849 69.0389 65.216C68.9944 65.3748 68.901 65.5156 68.7721 65.6184C68.7151 65.6464 68.6503 65.6543 68.5882 65.6407C68.5262 65.6271 68.4706 65.5928 68.4305 65.5436C68.3733 65.4835 68.3302 65.4116 68.3041 65.333C68.2536 65.2031 68.2175 65.0682 68.1965 64.9305C68.0868 63.9121 68.0774 62.8853 68.1684 61.8651C68.2376 61.3895 68.2642 60.9087 68.248 60.4283C68.2328 60.2233 68.1389 60.0321 67.9859 59.8948C67.9499 59.8725 67.9098 59.8576 67.868 59.8512C67.8262 59.8448 67.7835 59.8469 67.7425 59.8574C67.6987 59.8721 67.6564 59.8909 67.6161 59.9135C67.574 59.951 67.5787 59.9135 67.5506 59.9931C67.3814 60.414 67.2574 60.8517 67.1809 61.2988C67.0873 61.7668 67.0078 62.1927 66.9376 62.6326C66.8674 63.0725 66.8018 63.5031 66.7457 63.9336C66.6895 64.3642 66.6614 64.7854 66.5772 65.2066C66.5045 65.6181 66.3948 66.0222 66.2496 66.414C66.211 66.5138 66.1657 66.6107 66.1139 66.7042C66.0484 66.7931 66.0109 66.9054 65.8331 66.9616C65.7876 66.97 65.7406 66.9646 65.6981 66.9463C65.6556 66.928 65.6195 66.8975 65.5944 66.8586C65.5617 66.8046 65.5365 66.7463 65.5195 66.6855C65.4985 66.5837 65.486 66.4804 65.4821 66.3766C65.4821 65.5763 65.5897 64.8462 65.6318 64.1396C65.6624 63.8017 65.6624 63.4618 65.6318 63.124C65.6318 62.9742 65.5616 62.7964 65.4774 62.7636C65.4184 62.7347 65.3536 62.7197 65.2879 62.7197C65.2221 62.7197 65.1573 62.7347 65.0983 62.7636C64.9019 62.9746 64.7802 63.2443 64.752 63.5312C64.6818 63.8166 64.6537 64.1068 64.6022 64.3829C64.4057 65.4874 64.1998 66.4421 64.1015 67.219C64.0553 67.5607 64.0553 67.907 64.1015 68.2486C64.167 68.5294 64.2653 68.7821 64.3168 68.9787C64.3682 69.1752 64.4197 69.3156 64.4525 69.4467C64.4699 69.4968 64.4824 69.5486 64.4899 69.6011C64.4619 69.5558 64.4398 69.507 64.4244 69.456L64.2653 68.988C64.1998 68.7868 64.1015 68.5622 64.0219 68.2533C63.9719 67.9025 63.9719 67.5464 64.0219 67.1956C64.1108 66.4047 64.298 65.4593 64.4899 64.3502C64.5414 64.074 64.5695 63.7839 64.6303 63.4844C64.6638 63.3262 64.706 63.1699 64.7567 63.0164C64.8035 62.8461 64.9055 62.6963 65.0468 62.5905C65.1319 62.5454 65.2267 62.5218 65.323 62.5218C65.4192 62.5218 65.514 62.5454 65.5991 62.5905C65.6906 62.6482 65.7657 62.7284 65.8174 62.8234C65.869 62.9185 65.8954 63.0252 65.8939 63.1334C65.9267 63.4852 65.9267 63.8392 65.8939 64.191C65.8612 64.9024 65.7488 65.6465 65.7676 66.4047C65.771 66.4944 65.7819 66.5836 65.8003 66.6714C65.8003 66.7604 65.8658 66.7978 65.8565 66.7791C65.8471 66.7604 65.9454 66.7042 65.9828 66.6293C66.029 66.5463 66.0696 66.4603 66.1045 66.3719C66.2431 65.9926 66.345 65.6008 66.4087 65.2019C66.4883 64.7948 66.5164 64.3736 66.5725 63.9383C66.6287 63.5031 66.6848 63.0725 66.755 62.6279C66.8252 62.1833 66.9048 61.7387 66.9937 61.2848C67.0698 60.8107 67.2018 60.3472 67.3868 59.9042C67.4242 59.8299 67.4808 59.7668 67.5506 59.7216C67.6128 59.6875 67.6788 59.6608 67.7472 59.6421C67.8257 59.6197 67.9081 59.6143 67.9888 59.6264C68.0695 59.6385 68.1467 59.6678 68.2152 59.7123C68.3238 59.7985 68.4135 59.9062 68.4787 60.0285C68.5439 60.1509 68.5833 60.2854 68.5943 60.4236C68.6294 60.6783 68.6294 60.9365 68.5943 61.1912C68.5709 61.4298 68.5475 61.6592 68.5334 61.9212C68.4422 62.9181 68.4516 63.9215 68.5615 64.9164C68.5816 65.0346 68.6129 65.1506 68.6551 65.2628C68.6692 65.3081 68.6931 65.3496 68.7253 65.3844C68.7253 65.3844 68.7253 65.3844 68.7487 65.3844C68.7487 65.4921 68.7487 65.3844 68.7487 65.4266C68.7487 65.4687 68.7487 65.4266 68.7487 65.3891C68.8071 65.3109 68.8529 65.2241 68.8844 65.1317C68.9281 65.0163 68.9656 64.8946 68.9968 64.7667C69.1231 64.2706 69.2074 63.7464 69.2869 63.2223C69.446 62.1693 69.563 61.0882 69.6613 59.9931V60.0165C69.6197 59.6307 69.7034 59.2418 69.9 58.9073C69.9751 58.8117 70.078 58.7419 70.1946 58.7075C70.3112 58.6731 70.4356 58.6759 70.5505 58.7154C70.6487 58.7699 70.7349 58.8436 70.804 58.932C70.8732 59.0204 70.9238 59.1219 70.953 59.2302C71.1029 59.8057 71.1644 60.4006 71.1355 60.9946C71.1355 61.5749 71.084 62.1459 71.0326 62.7122C70.9811 63.2784 70.9109 63.8354 70.8313 64.3876C70.7892 64.6684 70.7471 64.9398 70.705 65.216C70.6675 65.3891 70.6769 65.3938 70.705 65.4453C70.7374 65.4672 70.7757 65.4789 70.8149 65.4789C70.8541 65.4789 70.8924 65.4672 70.9249 65.4453C70.9811 65.4032 70.9904 65.3236 71.0045 65.1692L71.0372 64.762L71.1215 63.9524C71.1776 63.4188 71.2525 62.8853 71.3414 62.3658C71.428 61.8441 71.5532 61.3294 71.7158 60.8261C71.8008 60.5717 71.9155 60.3283 72.0575 60.1007C72.1348 59.9781 72.2368 59.8729 72.357 59.7918C72.4237 59.7436 72.501 59.712 72.5824 59.6998C72.6639 59.6876 72.7471 59.6951 72.825 59.7216C72.8967 59.7659 72.9572 59.826 73.0018 59.8975C73.0465 59.9689 73.0741 60.0497 73.0824 60.1335C73.1017 60.2652 73.1095 60.3983 73.1058 60.5313C73.1058 60.7887 73.073 61.0367 73.045 61.2848C72.9794 61.7528 72.8905 62.2488 72.8063 62.7215C72.6053 63.6105 72.5079 64.5198 72.5161 65.4312C72.5293 65.5291 72.5545 65.625 72.591 65.7167C72.608 65.75 72.6284 65.7813 72.6518 65.8103C72.6518 65.8103 72.6518 65.8103 72.6518 65.7776C72.7569 65.6084 72.8343 65.4236 72.8811 65.23C73.0028 64.8228 73.1011 64.411 73.2088 64.0085C73.3053 63.6081 73.4224 63.2129 73.5598 62.8245C73.6246 62.6321 73.7093 62.447 73.8125 62.2722C73.8683 62.177 73.9413 62.0929 74.0278 62.0242C74.0748 61.9834 74.131 61.9545 74.1916 61.94C74.252 61.9305 74.3136 61.9305 74.3741 61.94C74.4379 61.9463 74.4989 61.9697 74.5508 62.0075C74.6026 62.0454 74.6434 62.0964 74.6689 62.1552C74.708 62.2536 74.7286 62.3583 74.7298 62.4641C74.7334 62.6535 74.7224 62.8428 74.697 63.0304C74.6549 63.3954 74.5847 63.7418 74.5191 64.0834C74.3834 64.7526 74.2337 65.3891 74.0511 65.9554C73.7001 67.116 73.3492 68.0988 73.0637 68.8991C72.7782 69.6994 72.5348 70.3031 72.371 70.7337C72.2915 70.9302 72.2259 71.0847 72.1791 71.2017C72.1582 71.2782 72.1284 71.3521 72.0902 71.4216Z"
          fill="#EB996E"
        />
        <path
          id="Vector_100"
          d="M46.6172 84.6149C47.5064 87.7552 49.2473 92.599 51.1147 97.7189C51.1735 97.8838 51.28 98.0276 51.4207 98.132C51.5613 98.2363 51.7298 98.2966 51.9047 98.3051C52.0796 98.3136 52.2532 98.27 52.4033 98.1798C52.5534 98.0896 52.6734 97.9569 52.748 97.7984L57.325 88.1155C57.325 88.1155 56.2205 80.1595 56.3141 80.445C56.4077 80.7305 46.8699 81.4746 46.8699 81.4746L46.6172 84.6149Z"
          fill="#F37032"
        />
        <path
          id="Vector_101"
          d="M56.893 82.9963C56.893 83.0337 56.322 83.2022 55.4188 83.5485C54.2384 83.9966 53.1011 84.5511 52.0211 85.2052C50.9426 85.8624 49.9246 86.6142 48.9791 87.4516C48.2537 88.0928 47.8372 88.5327 47.8091 88.5046C47.781 88.4766 47.8887 88.3736 48.0665 88.163C48.3172 87.8703 48.5828 87.5907 48.8621 87.3253C49.7846 86.437 50.8016 85.6523 51.8948 84.9853C52.9883 84.3264 54.1493 83.7867 55.358 83.3753C55.7233 83.2495 56.0951 83.1433 56.4718 83.0571C56.6081 83.0145 56.7503 82.994 56.893 82.9963Z"
          fill="#FAFAFA"
        />
        <path
          id="Vector_102"
          d="M58.721 85.5296C58.4236 85.2298 58.1657 84.8932 57.9535 84.5281C57.4069 83.676 56.9371 82.777 56.5495 81.8418C56.1616 80.9038 55.8593 79.9326 55.6462 78.9402C55.5372 78.5342 55.4821 78.1157 55.4824 77.6953C55.622 78.0877 55.733 78.4897 55.8147 78.8981C56.0654 79.8672 56.3781 80.8192 56.7507 81.7482C57.14 82.6724 57.5871 83.5711 58.0892 84.4392C58.3229 84.7888 58.5339 85.153 58.721 85.5296Z"
          fill="#263238"
        />
        <path
          id="Vector_103"
          d="M61.7617 42.6233C60.9677 43.9319 60.4755 45.4011 60.3208 46.9239C60.1662 48.4467 60.353 49.9849 60.8678 51.4264C61.3358 52.7134 62.0846 53.9817 61.9489 55.3482C61.8131 56.7148 60.7461 58.0673 61.1205 59.4151C61.3451 60.2154 62.0284 60.8191 62.2952 61.596C62.5994 62.532 62.2952 63.5195 62.1314 64.4789C61.757 66.9312 62.5432 69.3976 62.7351 71.8686C62.927 74.3396 62.2671 77.2366 60.0581 78.313C59.3889 78.6406 58.5137 78.7342 57.9568 78.2334C57.2455 77.6016 57.442 76.4597 57.6386 75.5237C59.5761 66.1637 53.5904 57.0283 54.9569 47.556C55.1769 46.0397 56.024 43.4657 57.1144 42.408C58.2049 41.3503 61.2328 41.472 62.2624 42.5952"
          fill="#263238"
        />
        <path
          id="Vector_104"
          d="M52.5586 69.7359C52.5586 69.7359 52.8441 69.3989 53.2653 68.7344C53.8564 67.7958 54.2704 66.7568 54.4868 65.669C54.628 64.9196 54.6767 64.1557 54.6318 63.3945C54.55 62.5094 54.5172 61.6204 54.5336 60.7316C54.5615 60.2449 54.6511 59.7636 54.8003 59.2995C54.9713 58.8214 55.1876 58.3606 55.4462 57.9236C55.9703 57.0391 56.6302 56.2154 57.2386 55.3355C57.8633 54.504 58.2979 53.5454 58.5116 52.5275C58.6153 51.5688 58.56 50.5994 58.3478 49.6587C58.1707 48.7844 58.1015 47.8916 58.1418 47.0005C58.1975 46.222 58.3549 45.4542 58.6098 44.7166C58.9673 43.6463 59.5301 42.6559 60.2666 41.801C60.4622 41.5686 60.6749 41.3511 60.903 41.1505C60.9754 41.0734 61.0571 41.0058 61.1464 40.9492C61.1464 40.9492 60.8328 41.2534 60.3368 41.8852C59.1552 43.3518 58.4643 45.1526 58.3618 47.0332C58.3305 47.9098 58.4075 48.7869 58.5911 49.6447C58.8144 50.6107 58.8745 51.6072 58.769 52.5931C58.5471 53.6393 58.0999 54.6247 57.4586 55.4806C56.8455 56.3745 56.1856 57.1935 55.6708 58.0546C55.4176 58.4754 55.2075 58.9207 55.0437 59.3837C54.8956 59.8289 54.806 60.2914 54.7769 60.7597C54.7562 61.6386 54.7812 62.5181 54.8518 63.3945C54.889 64.1711 54.8292 64.9493 54.674 65.7111C54.4394 66.8138 53.9945 67.861 53.3636 68.7952C53.1927 69.0478 53.0051 69.2886 52.802 69.5159C52.7291 69.5979 52.6475 69.6717 52.5586 69.7359Z"
          fill="#455A64"
        />
        <path
          id="Vector_105"
          d="M48.0801 70.4566C48.1178 70.3475 48.1664 70.2424 48.2252 70.1431C48.3422 69.9231 48.4919 69.6329 48.6932 69.2679C49.0863 68.5051 49.6713 67.3959 50.2469 65.9919C50.9511 64.3521 51.3416 62.5948 51.3982 60.8111C51.3985 60.2972 51.3593 59.784 51.2812 59.2761C51.2016 58.7519 51.08 58.2231 51.0004 57.6709C50.9031 57.0996 50.9158 56.5151 51.0378 55.9486C51.1961 55.3671 51.5215 54.8447 51.9738 54.4463C52.8537 53.6461 53.916 53.1219 54.4683 52.1812C54.9467 51.2485 55.2287 50.2274 55.2966 49.1813C55.3957 48.2224 55.6126 47.2792 55.9425 46.3733C56.6843 44.4286 58.006 42.7588 59.7286 41.5904C60.0032 41.4055 60.2893 41.2383 60.585 41.0896C60.6849 41.0298 60.7918 40.9826 60.9033 40.9492C60.9033 40.9492 60.4821 41.1739 59.7848 41.6699C58.8019 42.3713 57.9511 43.2412 57.2716 44.2393C56.8004 44.9234 56.4168 45.664 56.1297 46.4435C55.8143 47.3516 55.61 48.2944 55.5213 49.2515C55.3809 50.2484 55.2686 51.3622 54.6695 52.3497C54.0705 53.3372 52.9754 53.8988 52.1376 54.6897C51.7107 55.0602 51.403 55.5487 51.2531 56.0937C51.1393 56.6296 51.1282 57.1823 51.2204 57.7223C51.2952 58.2605 51.4122 58.7941 51.4918 59.3229C51.5728 59.843 51.6103 60.369 51.6041 60.8954C51.5405 62.7117 51.1291 64.4991 50.392 66.1604C49.9133 67.2831 49.3695 68.377 48.7634 69.4364L48.2673 70.1711C48.2151 70.2726 48.1524 70.3683 48.0801 70.4566Z"
          fill="#455A64"
        />
      </g>
      <g id="freepik--Plant--inject-64">
        <path
          id="Vector_106"
          d="M203.047 202.834C203.069 202.766 203.097 202.7 203.131 202.638C203.197 202.497 203.286 202.31 203.393 202.071C203.719 201.34 203.98 200.582 204.175 199.806C204.69 197.794 204.872 194.719 204.109 191.069C203.695 189.078 203.153 187.116 202.485 185.195C201.802 183.113 201.002 180.904 200.351 178.512C199.617 176.018 199.262 173.428 199.298 170.828C199.397 168.109 200.201 165.399 201.086 162.694C201.971 159.989 202.883 157.354 203.155 154.686C203.456 152.128 202.942 149.54 201.685 147.292C200.515 145.135 199.041 143.286 197.941 141.376C196.911 139.602 196.153 137.684 195.69 135.686C195.026 132.792 194.976 129.792 195.545 126.878C195.752 125.812 196.066 124.769 196.481 123.766C196.468 123.836 196.45 123.905 196.425 123.972L196.238 124.566C196.078 125.09 195.868 125.876 195.667 126.906C195.143 129.806 195.221 132.784 195.896 135.653C196.365 137.627 197.127 139.52 198.156 141.269C199.256 143.141 200.735 145.013 201.933 147.18C203.221 149.473 203.75 152.116 203.445 154.729C203.169 157.434 202.251 160.096 201.367 162.797C200.482 165.497 199.687 168.179 199.588 170.851C199.547 173.425 199.894 175.991 200.618 178.461C201.259 180.838 202.045 183.047 202.724 185.139C203.385 187.07 203.916 189.043 204.315 191.045C205.059 194.724 204.849 197.831 204.315 199.848C204.106 200.626 203.826 201.383 203.477 202.109L203.187 202.666C203.147 202.727 203.1 202.784 203.047 202.834Z"
          fill="#263238"
        />
        <path
          id="Vector_107"
          d="M199.43 143.247C199.43 143.247 197.193 136.082 201.208 131.888C201.239 131.855 201.279 131.83 201.324 131.818C201.368 131.805 201.415 131.806 201.459 131.818C201.503 131.831 201.543 131.855 201.574 131.889C201.605 131.923 201.626 131.965 201.634 132.01C201.849 133.194 202.116 136.798 199.43 143.247Z"
          fill="#F37032"
        />
        <path
          id="Vector_108"
          d="M200.692 134.367C200.685 134.811 200.635 135.253 200.542 135.687C200.393 136.6 200.219 137.667 200.032 138.846C199.845 140.025 199.672 141.097 199.527 142.005C199.486 142.448 199.408 142.886 199.293 143.315C199.249 142.873 199.258 142.427 199.321 141.986C199.396 141.167 199.541 140.044 199.742 138.809C199.943 137.573 200.163 136.469 200.336 135.659C200.405 135.216 200.524 134.783 200.692 134.367Z"
          fill="#263238"
        />
        <path
          id="Vector_109"
          d="M202.008 160.223C202.008 160.223 203.379 152.843 208.892 151.018C208.936 151.003 208.982 151 209.027 151.01C209.072 151.02 209.114 151.042 209.147 151.074C209.18 151.106 209.203 151.147 209.214 151.191C209.226 151.236 209.224 151.283 209.21 151.327C208.845 152.464 207.399 155.773 202.008 160.223Z"
          fill="#F37032"
        />
        <path
          id="Vector_110"
          d="M207.427 152.832C207.213 153.222 206.963 153.59 206.678 153.932L204.746 156.482L202.827 159.042C202.585 159.414 202.311 159.763 202.008 160.086C202.179 159.674 202.399 159.284 202.663 158.925C203.131 158.237 203.767 157.311 204.535 156.314C205.303 155.317 206 154.442 206.529 153.805C206.792 153.449 207.093 153.123 207.427 152.832Z"
          fill="#263238"
        />
        <path
          id="Vector_111"
          d="M200.511 178.682C200.511 178.682 199.678 171.222 204.424 167.876C204.46 167.847 204.504 167.83 204.551 167.825C204.597 167.821 204.643 167.83 204.685 167.851C204.726 167.872 204.76 167.905 204.784 167.945C204.807 167.985 204.819 168.031 204.817 168.077C204.803 169.28 204.377 172.865 200.511 178.682Z"
          fill="#F37032"
        />
        <path
          id="Vector_112"
          d="M203.612 170.199C203.525 170.635 203.392 171.06 203.214 171.467L202.11 174.472C201.698 175.595 201.328 176.611 201.015 177.477C200.895 177.903 200.738 178.318 200.547 178.717C200.59 178.273 200.688 177.836 200.837 177.416C201.066 176.63 201.422 175.544 201.857 174.374C202.293 173.204 202.718 172.151 203.041 171.397C203.19 170.98 203.382 170.578 203.612 170.199Z"
          fill="#263238"
        />
        <path
          id="Vector_113"
          d="M204.68 197.357C204.68 197.357 204.118 189.869 208.976 186.696C209.014 186.67 209.059 186.655 209.105 186.653C209.151 186.65 209.197 186.661 209.237 186.683C209.277 186.706 209.311 186.739 209.333 186.779C209.356 186.819 209.367 186.865 209.365 186.911C209.308 188.114 208.756 191.685 204.68 197.357Z"
          fill="#F37032"
        />
        <path
          id="Vector_114"
          d="M208.044 188.848C207.939 189.28 207.79 189.7 207.599 190.102C207.253 190.954 206.841 191.974 206.387 193.064C205.933 194.155 205.535 195.17 205.189 196.027C205.05 196.449 204.873 196.858 204.66 197.248C204.722 196.806 204.837 196.372 205.002 195.957C205.259 195.18 205.652 194.113 206.13 192.957C206.607 191.801 207.066 190.762 207.417 190.022C207.583 189.61 207.794 189.216 208.044 188.848Z"
          fill="#263238"
        />
        <path
          id="Vector_115"
          d="M196.176 136.969C196.176 136.969 189.54 133.487 189.395 127.688C189.394 127.643 189.406 127.598 189.429 127.559C189.452 127.52 189.485 127.487 189.525 127.465C189.565 127.443 189.609 127.432 189.655 127.434C189.7 127.435 189.745 127.449 189.783 127.473C190.77 128.156 193.513 130.515 196.176 136.969Z"
          fill="#F37032"
        />
        <path
          id="Vector_116"
          d="M190.766 129.617C191.077 129.935 191.355 130.285 191.594 130.661C192.137 131.405 192.769 132.285 193.466 133.254L195.338 135.837C195.623 136.177 195.877 136.542 196.096 136.927C195.754 136.643 195.447 136.317 195.184 135.959C194.655 135.331 193.962 134.433 193.232 133.417C192.502 132.402 191.861 131.461 191.421 130.773C191.163 130.412 190.943 130.024 190.766 129.617Z"
          fill="#263238"
        />
        <path
          id="Vector_117"
          d="M203.311 152.268C203.311 152.268 196.46 149.203 195.977 143.414C195.974 143.368 195.982 143.323 196.003 143.282C196.023 143.241 196.054 143.206 196.093 143.182C196.132 143.158 196.176 143.145 196.222 143.145C196.268 143.144 196.313 143.156 196.352 143.18C197.377 143.802 200.255 145.983 203.311 152.268Z"
          fill="#F37032"
        />
        <path
          id="Vector_118"
          d="M197.529 145.336C197.859 145.633 198.157 145.964 198.418 146.323L200.45 148.799L202.485 151.266C202.79 151.588 203.066 151.938 203.309 152.309C202.95 152.044 202.623 151.738 202.336 151.397C201.774 150.798 201.025 149.946 200.234 148.977C199.443 148.008 198.751 147.105 198.264 146.445C197.979 146.104 197.732 145.732 197.529 145.336Z"
          fill="#263238"
        />
        <path
          id="Vector_119"
          d="M199.326 169.519C199.326 169.519 194.646 163.669 196.831 158.287C196.849 158.245 196.877 158.208 196.914 158.181C196.951 158.154 196.994 158.138 197.04 158.134C197.085 158.13 197.131 158.139 197.172 158.159C197.213 158.179 197.247 158.211 197.271 158.249C197.922 159.265 199.48 162.522 199.326 169.519Z"
          fill="#F37032"
        />
        <path
          id="Vector_120"
          d="M197.348 160.695C197.508 161.111 197.624 161.542 197.694 161.982C197.891 162.881 198.12 163.939 198.373 165.109C198.626 166.279 198.864 167.332 199.061 168.23C199.186 168.657 199.272 169.094 199.318 169.536C199.113 169.138 198.956 168.717 198.85 168.282C198.621 167.491 198.34 166.41 198.078 165.165C197.816 163.92 197.61 162.825 197.479 162.02C197.387 161.584 197.343 161.14 197.348 160.695Z"
          fill="#263238"
        />
        <path
          id="Vector_121"
          d="M204.076 189.681C204.076 189.681 197.276 186.504 196.892 180.71C196.887 180.663 196.896 180.617 196.916 180.575C196.937 180.534 196.969 180.499 197.008 180.474C197.048 180.45 197.093 180.437 197.14 180.438C197.186 180.438 197.232 180.451 197.271 180.476C198.277 181.117 201.118 183.349 204.076 189.681Z"
          fill="#F37032"
        />
        <path
          id="Vector_122"
          d="M198.352 182.633C198.673 182.94 198.965 183.277 199.222 183.639L201.211 186.143L203.205 188.647C203.504 188.974 203.774 189.328 204.01 189.704C203.661 189.431 203.347 189.117 203.074 188.768C202.517 188.16 201.787 187.294 201.01 186.311C200.233 185.329 199.559 184.416 199.082 183.747C198.796 183.405 198.551 183.031 198.352 182.633Z"
          fill="#263238"
        />
        <path
          id="Vector_123"
          d="M217.614 160.145C217.614 160.145 217.614 160.201 217.614 160.308C217.614 160.416 217.614 160.594 217.614 160.776C217.614 161.244 217.568 161.839 217.535 162.597C217.451 164.197 217.324 166.43 217.179 169.097C216.711 171.812 215.307 174.821 213.435 177.746C212.073 179.899 210.627 181.855 209.41 183.676C208.3 185.273 207.302 186.947 206.425 188.683C205.844 189.857 205.373 191.082 205.021 192.343C204.904 192.788 204.81 193.139 204.758 193.377C204.736 193.502 204.703 193.624 204.66 193.742C204.662 193.616 204.677 193.491 204.707 193.368C204.74 193.124 204.81 192.769 204.918 192.315C205.232 191.032 205.679 189.785 206.251 188.594C207.121 186.844 208.118 185.159 209.233 183.554C210.459 181.719 211.877 179.758 213.234 177.62C215.083 174.709 216.458 171.746 216.978 169.074C217.165 166.411 217.32 164.183 217.446 162.583C217.507 161.825 217.558 161.221 217.596 160.767C217.596 160.58 217.628 160.421 217.642 160.299C217.627 160.249 217.617 160.197 217.614 160.145Z"
          fill="#263238"
        />
        <path
          id="Vector_124"
          d="M213.569 177.196C213.569 177.196 216.447 170.27 212.83 165.726C212.802 165.689 212.764 165.661 212.721 165.645C212.678 165.629 212.631 165.625 212.586 165.633C212.541 165.642 212.499 165.663 212.465 165.694C212.432 165.726 212.407 165.766 212.395 165.81C212.072 166.97 211.477 170.532 213.569 177.196Z"
          fill="#F37032"
        />
        <path
          id="Vector_125"
          d="M212.995 168.188C213.119 168.615 213.196 169.054 213.224 169.498C213.327 170.312 213.44 171.44 213.528 172.69C213.617 173.939 213.66 175.072 213.66 175.895C213.688 176.34 213.661 176.786 213.58 177.225C213.499 176.788 213.46 176.344 213.463 175.9C213.402 174.964 213.327 173.902 213.248 172.708C213.168 171.515 213.093 170.434 213.028 169.517C212.973 169.076 212.962 168.631 212.995 168.188Z"
          fill="#263238"
        />
        <g id="Group_7" opacity="0.3">
          <path
            id="Vector_126"
            d="M213.479 177.196C213.479 177.196 216.358 170.27 212.74 165.726C212.712 165.689 212.674 165.661 212.631 165.645C212.588 165.629 212.541 165.625 212.496 165.633C212.451 165.642 212.409 165.663 212.376 165.694C212.342 165.726 212.317 165.766 212.305 165.81C211.982 166.97 211.387 170.532 213.479 177.196Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_127"
          d="M204.614 193.902C204.614 193.902 206.921 186.761 202.943 182.53C202.912 182.496 202.873 182.472 202.829 182.459C202.785 182.446 202.739 182.446 202.695 182.458C202.651 182.47 202.611 182.494 202.579 182.528C202.548 182.561 202.527 182.602 202.517 182.647C202.293 183.826 201.989 187.43 204.614 193.902Z"
          fill="#F37032"
        />
        <path
          id="Vector_128"
          d="M203.379 185.008C203.541 185.424 203.654 185.857 203.716 186.299C203.884 187.1 204.086 188.218 204.277 189.454C204.469 190.689 204.6 191.817 204.671 192.636C204.731 193.078 204.739 193.526 204.694 193.97C204.583 193.54 204.508 193.102 204.469 192.66C204.334 191.747 204.175 190.68 204.001 189.496C203.828 188.312 203.66 187.245 203.533 186.332C203.438 185.897 203.387 185.453 203.379 185.008Z"
          fill="#263238"
        />
        <g id="Group_8" opacity="0.3">
          <path
            id="Vector_129"
            d="M204.614 193.902C204.614 193.902 206.921 186.761 202.943 182.53C202.912 182.496 202.873 182.472 202.829 182.459C202.785 182.446 202.739 182.446 202.695 182.458C202.651 182.47 202.611 182.494 202.579 182.528C202.548 182.561 202.527 182.602 202.517 182.647C202.293 183.826 201.989 187.43 204.614 193.902Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_130"
          d="M217.182 168.803C217.182 168.803 223.326 164.497 222.709 158.722C222.704 158.677 222.687 158.634 222.659 158.597C222.631 158.561 222.594 158.533 222.551 158.517C222.509 158.5 222.463 158.496 222.418 158.504C222.373 158.512 222.331 158.533 222.297 158.563C221.403 159.368 219.007 162.045 217.182 168.803Z"
          fill="#F37032"
        />
        <g id="Group_9" opacity="0.3">
          <path
            id="Vector_131"
            d="M217.182 168.803C217.182 168.803 223.326 164.497 222.709 158.722C222.704 158.677 222.687 158.634 222.659 158.597C222.631 158.561 222.594 158.533 222.551 158.517C222.509 158.5 222.463 158.496 222.418 158.504C222.373 158.512 222.331 158.533 222.297 158.563C221.403 159.368 219.007 162.045 217.182 168.803Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_132"
          d="M221.626 160.875C221.504 161.304 221.333 161.717 221.116 162.106C220.765 162.845 220.255 163.856 219.66 164.961C219.066 166.065 218.495 167.043 218.055 167.736C217.839 168.125 217.576 168.486 217.273 168.812C217.438 168.401 217.642 168.006 217.882 167.633C218.322 166.823 218.841 165.878 219.412 164.825L220.938 162.017C221.129 161.615 221.36 161.232 221.626 160.875Z"
          fill="#263238"
        />
        <path
          id="Vector_133"
          d="M207.127 186.839C207.127 186.839 214.54 185.683 216.524 180.226C216.54 180.184 216.545 180.138 216.536 180.093C216.528 180.048 216.507 180.007 216.477 179.973C216.446 179.939 216.407 179.914 216.364 179.901C216.32 179.888 216.274 179.887 216.23 179.899C215.074 180.245 211.723 181.579 207.127 186.839Z"
          fill="#F37032"
        />
        <g id="Group_10" opacity="0.3">
          <path
            id="Vector_134"
            d="M207.035 186.839C207.035 186.839 214.448 185.683 216.433 180.226C216.449 180.184 216.453 180.138 216.444 180.093C216.436 180.048 216.415 180.007 216.385 179.973C216.354 179.939 216.315 179.914 216.272 179.901C216.228 179.888 216.182 179.887 216.138 179.899C214.982 180.245 211.631 181.579 207.035 186.839Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_135"
          d="M214.545 181.715C214.245 182.043 213.909 182.336 213.544 182.59C212.902 183.105 211.999 183.788 210.984 184.518C209.968 185.248 209.018 185.871 208.316 186.301C207.95 186.557 207.554 186.766 207.137 186.924C207.469 186.628 207.828 186.363 208.208 186.133L210.82 184.289L213.427 182.417C213.774 182.144 214.148 181.908 214.545 181.715Z"
          fill="#263238"
        />
        <path
          id="Vector_136"
          d="M200.057 200.547L197.895 215.102H211.373L209.627 200.547H200.057Z"
          fill="#455A64"
        />
        <path
          id="Vector_137"
          d="M210.137 205.091C210.137 205.17 207.704 205.231 204.704 205.231C201.704 205.231 199.266 205.17 199.266 205.091C201.075 204.952 202.89 204.905 204.704 204.95C206.516 204.905 208.33 204.952 210.137 205.091Z"
          fill="#263238"
        />
        <path
          id="Vector_138"
          d="M210.408 206.172C210.408 206.251 207.895 206.312 204.792 206.312C201.689 206.312 199.176 206.251 199.176 206.172C199.176 206.092 201.689 206.031 204.792 206.031C207.895 206.031 210.408 206.092 210.408 206.172Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--Boxes--inject-64">
        <path
          id="Vector_139"
          d="M157.938 59.102C157.938 59.102 157.811 59.102 157.568 59.102C157.212 59.0809 156.856 59.0809 156.501 59.102C155.126 59.1825 153.776 59.4991 152.509 60.038C150.5 60.8799 148.752 62.2417 147.445 63.9833C146.639 65.0707 146.039 66.2969 145.676 67.6009C144.857 70.7071 145.299 74.0112 146.907 76.7924C147.345 77.5625 147.88 78.2733 148.498 78.9078C149.122 79.58 149.848 80.1487 150.651 80.5926C151.474 81.056 152.407 81.2903 153.351 81.2712C154.325 81.2595 155.259 80.882 155.967 80.2135C156.31 79.8547 156.578 79.432 156.757 78.9695C156.936 78.507 157.022 78.0137 157.011 77.5178C157.004 76.4877 156.677 75.4852 156.075 74.649C154.863 72.9408 152.897 71.7942 150.805 71.1764C148.636 70.5672 146.345 70.5349 144.16 71.0828C143.044 71.3731 141.969 71.8007 140.958 72.3558C139.939 72.9314 139.012 73.6589 138.211 74.5133C138.019 74.7332 137.799 74.9345 137.626 75.1778L137.097 75.8892C136.776 76.3905 136.488 76.9127 136.236 77.4523C135.736 78.548 135.394 79.7094 135.221 80.9015C134.881 83.283 135.205 85.7121 136.157 87.9215C137.067 90.0803 138.651 91.8864 140.673 93.0695C141.653 93.6296 142.748 93.9608 143.874 94.0382C144.979 94.1 146.077 93.8364 147.033 93.2801C147.982 92.7556 148.732 91.9333 149.167 90.9401C149.578 89.9613 149.606 88.8641 149.247 87.8653C148.877 86.9017 148.272 86.0458 147.487 85.3756C146.726 84.7176 145.848 84.2081 144.899 83.8733C143.048 83.2898 141.068 83.2557 139.199 83.775C137.449 84.249 135.843 85.144 134.519 86.3818C133.313 87.537 132.395 88.9587 131.837 90.5329C130.862 93.2643 130.907 96.256 131.964 98.9569C132.787 100.973 134.113 102.745 135.815 104.105C136.887 104.965 138.081 105.66 139.358 106.169C139.798 106.333 140.139 106.454 140.373 106.52L140.72 106.632C140.72 106.632 140.598 106.609 140.364 106.543C140.018 106.451 139.678 106.34 139.344 106.211C138.05 105.725 136.841 105.04 135.759 104.18C134.028 102.821 132.676 101.04 131.832 99.0084C130.758 96.282 130.703 93.2591 131.678 90.4955C132.236 88.8974 133.165 87.4541 134.388 86.2835C135.73 85.0209 137.361 84.1052 139.138 83.6159C141.047 83.0833 143.069 83.1158 144.96 83.7095C145.937 84.0501 146.84 84.5726 147.623 85.2492C148.439 85.9414 149.066 86.8284 149.448 87.8279C149.833 88.8713 149.816 90.0206 149.401 91.0524C148.94 92.0847 148.156 92.94 147.169 93.4907C146.177 94.0685 145.039 94.345 143.893 94.2863C142.739 94.2058 141.619 93.8633 140.617 93.2848C138.549 92.0851 136.925 90.2478 135.988 88.0478C135.016 85.798 134.682 83.3238 135.024 80.8968C135.203 79.6806 135.553 78.4957 136.063 77.3774C136.32 76.8263 136.614 76.2932 136.943 75.7816L137.486 75.0562C137.659 74.8081 137.884 74.5882 138.08 74.3729C138.9 73.5023 139.847 72.7607 140.888 72.1733C141.922 71.6075 143.023 71.1736 144.164 70.8816C146.392 70.3235 148.726 70.3573 150.936 70.9799C153.07 71.6164 155.069 72.7817 156.328 74.5507C156.96 75.4218 157.304 76.4693 157.31 77.5459C157.333 78.6054 156.934 79.6306 156.201 80.396C155.452 81.0989 154.467 81.4948 153.44 81.5052C152.457 81.5275 151.487 81.2833 150.632 80.7985C149.811 80.3453 149.068 79.7621 148.432 79.0716C147.806 78.4229 147.264 77.6981 146.818 76.9141C145.182 74.0812 144.737 70.7146 145.582 67.5541C145.957 66.2351 146.571 64.9961 147.393 63.899C148.725 62.1442 150.503 60.7786 152.541 59.9444C153.819 59.416 155.18 59.1181 156.562 59.0646C156.92 59.041 157.28 59.041 157.638 59.0646L157.938 59.102Z"
          fill="#263238"
        />
        <path
          id="Vector_140"
          d="M173.569 105.848H107.951V156.457H173.569V105.848Z"
          fill="#F37032"
        />
        <path
          id="Vector_141"
          d="M107.951 105.848L120.072 117.155H184.577L173.569 105.848H107.951Z"
          fill="#F37032"
        />
        <path
          id="Vector_142"
          d="M107.951 105.965L173.588 105.848H173.64L173.677 105.88L184.572 117.07L184.684 117.187L184.886 117.393H184.596L120.091 117.342H120.063L107.951 105.965L120.119 117.197H120.068L184.572 117.15L184.488 117.356L184.371 117.239L173.481 106.049L173.565 106.086L107.951 105.965Z"
          fill="#263238"
        />
        <path
          id="Vector_143"
          d="M127.722 129.246C127.367 129.259 127.03 129.411 126.786 129.669C126.541 129.927 126.408 130.271 126.414 130.627C126.421 130.983 126.567 131.322 126.82 131.571C127.074 131.82 127.416 131.96 127.771 131.96C128.127 131.96 128.468 131.82 128.722 131.571C128.976 131.322 129.122 130.983 129.128 130.627C129.135 130.271 129.001 129.927 128.757 129.669C128.512 129.411 128.176 129.259 127.82 129.246"
          fill="#263238"
        />
        <path
          id="Vector_144"
          d="M143.162 129.246C142.808 129.26 142.474 129.411 142.231 129.669C141.987 129.926 141.855 130.269 141.862 130.623C141.868 130.978 142.014 131.315 142.267 131.563C142.519 131.811 142.86 131.95 143.214 131.95C143.568 131.95 143.908 131.811 144.161 131.563C144.414 131.315 144.559 130.978 144.566 130.623C144.573 130.269 144.44 129.926 144.197 129.669C143.954 129.411 143.619 129.26 143.265 129.246"
          fill="#263238"
        />
        <path
          id="Vector_145"
          d="M143.28 141.345C143.01 140.311 142.57 139.329 141.979 138.438C141.322 137.486 140.478 136.677 139.499 136.061C138.318 135.277 136.94 134.841 135.522 134.802C134.105 134.763 132.705 135.123 131.482 135.841C130.472 136.405 129.586 137.165 128.875 138.078C128.235 138.936 127.744 139.894 127.42 140.914C127.424 140.838 127.436 140.763 127.457 140.69C127.502 140.479 127.56 140.271 127.631 140.067C127.887 139.315 128.261 138.609 128.74 137.975C129.445 137.02 130.343 136.223 131.375 135.635C132.629 134.886 134.07 134.51 135.53 134.55C136.99 134.59 138.409 135.044 139.621 135.86C140.617 136.5 141.468 137.342 142.12 138.331C142.564 138.991 142.901 139.718 143.117 140.484C143.174 140.691 143.22 140.902 143.252 141.115C143.269 141.191 143.278 141.268 143.28 141.345Z"
          fill="#263238"
        />
        <path
          id="Vector_146"
          opacity="0.5"
          d="M108.133 106.395L119.739 121.108H173.601V117.144H120.104L108.133 106.395Z"
          fill="black"
        />
        <path
          id="Vector_147"
          d="M160.631 156.492C160.566 156.492 160.51 147.689 160.51 136.836C160.51 125.983 160.566 117.18 160.631 117.18C160.697 117.18 160.758 125.978 160.758 136.836C160.758 147.693 160.702 156.492 160.631 156.492Z"
          fill="#263238"
        />
        <path
          id="Vector_148"
          d="M170.954 144.969H165.17V151.507H170.954V144.969Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_149"
          d="M107.983 105.848L94.5137 117.155H107.983V105.848Z"
          fill="#F37032"
        />
        <g id="Group_11" opacity="0.4">
          <path
            id="Vector_150"
            d="M107.983 106.031L94.5137 117.338H107.983V106.031Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_151"
          d="M175.536 156.484H100.09V214.675H175.536V156.484Z"
          fill="#F37032"
        />
        <path
          id="Vector_152"
          opacity="0.3"
          d="M175.536 156.484H100.09V214.675H175.536V156.484Z"
          fill="black"
        />
        <path
          id="Vector_153"
          d="M156.608 214.238C156.542 214.238 156.486 201.27 156.486 185.274C156.486 169.278 156.542 156.305 156.608 156.305C156.674 156.305 156.73 169.273 156.73 185.274C156.73 201.275 156.674 214.238 156.608 214.238Z"
          fill="#263238"
        />
        <path
          id="Vector_154"
          d="M169.126 201.457H163.342V207.995H169.126V201.457Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_155"
          d="M131.692 156.668H123.123V169.084H131.692V156.668Z"
          fill="#263238"
        />
        <path
          id="Vector_156"
          d="M131.692 202.188H123.123V214.604H131.692V202.188Z"
          fill="#263238"
        />
        <path
          id="Vector_157"
          d="M174.881 156.555H174.684H174.118L171.942 156.578L163.925 156.615L137.488 156.676L111.041 156.643L103.029 156.606L100.853 156.583L103.029 156.559L111.041 156.522L137.488 156.484L163.925 156.522L171.942 156.559L174.118 156.583H174.684L174.881 156.555Z"
          fill="#263238"
        />
      </g>
      <g id="freepik--speech-bubble--inject-64">
        <path
          id="Vector_158"
          d="M45.5754 55.9138L37.3573 53.8921H37.4182C35.2962 55.2418 32.8425 55.9787 30.328 56.0215C28.8393 56.0282 27.3581 55.8121 25.9335 55.3803C23.4288 54.5761 21.2067 53.0716 19.5298 51.0448C17.8529 49.0179 16.7913 46.5534 16.4705 43.9424C16.2185 41.9677 16.404 39.9618 17.0138 38.0668C17.6237 36.1718 18.6429 34.4342 19.9992 32.9771C20.7122 32.194 21.5113 31.4938 22.3813 30.8899C22.8213 30.6137 23.2612 30.3283 23.7198 30.0896L24.4171 29.7526L24.7635 29.5841L25.1285 29.4531C27.0077 28.7247 29.0236 28.4164 31.0347 28.5499C33.7298 28.7249 36.3129 29.6938 38.4583 31.3345C40.6037 32.9752 42.2154 35.2142 43.0903 37.7695C43.5764 39.1989 43.8323 40.6964 43.8485 42.2061C43.8602 44.7151 43.1784 47.1785 41.8782 49.3244V49.2495C44.1621 53.3726 45.3133 55.4552 45.5707 55.9138C45.304 55.4458 44.1106 53.4007 41.7472 49.3197V49.2823V49.2448C43.0006 47.1197 43.6481 44.6919 43.6192 42.2248C43.5975 40.7393 43.3383 39.2668 42.8517 37.8631C41.9863 35.3601 40.4017 33.168 38.2964 31.5614C36.1911 29.9547 33.6586 29.0048 31.0159 28.8307C29.0445 28.7022 27.0688 29.0056 25.2268 29.7199L24.8711 29.8462L24.5295 30.0147L23.8462 30.3423C23.3782 30.581 22.9663 30.8571 22.5311 31.1285C21.6779 31.7163 20.893 32.3975 20.1911 33.1597C18.8595 34.5901 17.8587 36.2957 17.2594 38.1558C16.6602 40.0159 16.4771 41.985 16.7232 43.9237C17.1571 47.4754 18.9793 50.711 21.7917 52.9233C23.049 53.9195 24.4759 54.6806 26.0037 55.1697C27.4027 55.6022 28.8589 55.8215 30.3233 55.8202C32.8077 55.7936 35.2366 55.0827 37.3433 53.7657H37.3714H37.4229L45.5754 55.9138Z"
          fill="#263238"
        />
        <path
          id="Vector_159"
          d="M28.9768 36.2166L29.3933 43.0962C29.4099 43.3675 29.5252 43.6235 29.7174 43.8157C29.9097 44.0079 30.1656 44.1232 30.4369 44.1398C30.7224 44.156 31.0033 44.0621 31.2218 43.8776C31.4403 43.6931 31.5798 43.4319 31.6116 43.1477L32.3744 36.254C32.3877 36.1307 32.3746 36.006 32.3361 35.8881C32.2975 35.7702 32.2343 35.6618 32.1506 35.5702C32.067 35.4786 31.9648 35.4058 31.8509 35.3567C31.737 35.3076 31.614 35.2832 31.4899 35.2853H29.8192C29.7019 35.2888 29.5866 35.3159 29.4801 35.3651C29.3736 35.4143 29.2782 35.4845 29.1995 35.5714C29.1208 35.6584 29.0606 35.7604 29.0223 35.8713C28.984 35.9821 28.9685 36.0996 28.9768 36.2166Z"
          fill="#F37032"
        />
        <path
          id="Vector_160"
          d="M32.2396 47.9083C32.1348 48.2225 31.9393 48.4987 31.6777 48.7019C31.416 48.905 31.1 49.0261 30.7696 49.0497C30.4392 49.0734 30.1092 48.9985 29.8213 48.8347C29.5334 48.6708 29.3006 48.4253 29.1522 48.1292C29.0037 47.833 28.9465 47.4995 28.9875 47.1708C29.0286 46.8421 29.1662 46.533 29.3829 46.2824C29.5996 46.0319 29.8858 45.8512 30.2051 45.7633C30.5245 45.6753 30.8628 45.684 31.1772 45.7882C31.3863 45.8575 31.5796 45.9673 31.7462 46.1114C31.9127 46.2555 32.0493 46.4311 32.1479 46.628C32.2466 46.8249 32.3055 47.0393 32.3212 47.259C32.3369 47.4787 32.3092 47.6993 32.2396 47.9083Z"
          fill="#F37032"
        />
      </g>
    </g>
  </svg>
);

export const breadCrumbsArrowSVG = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-right" clip-path="url(#clip0_1639_878)">
      <path
        id="Vector"
        d="M6 4.5L10 8.5L6 12.5"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1639_878">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const photoTickIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
  >
    <g filter="url(#filter0_d_1053_6845)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.5 37C30.7173 37 39 28.7173 39 18.5C39 8.28273 30.7173 0 20.5 0C10.2827 0 2 8.28273 2 18.5C2 28.7173 10.2827 37 20.5 37ZM30.2348 10.8516C30.7051 10.1696 30.5336 9.23551 29.8516 8.76518C29.1696 8.29486 28.2355 8.46643 27.7652 9.1484L18.6309 22.393L12.8719 18.2794C12.1977 17.7979 11.2609 17.954 10.7794 18.6281C10.2979 19.3023 10.454 20.2391 11.1281 20.7206L18.1281 25.7206C18.4554 25.9543 18.8627 26.0469 19.2588 25.9775C19.6549 25.9081 20.0065 25.6826 20.2348 25.3516L30.2348 10.8516Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1053_6845"
        x="0.7"
        y="0"
        width="45.6"
        height="46.3"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="5" />
        <feGaussianBlur stdDeviation="2.15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1053_6845"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1053_6845"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const photoSelectedTickSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
  >
    <g filter="url(#filter0_d_1053_6838)">
      <circle cx="20.5" cy="18.5" r="18.5" fill="#46A644" />
      <circle cx="20.5" cy="18.5" r="18" stroke="#C9C9C9" />
    </g>
    <path
      d="M12 19.5L19 24.5L29 10"
      stroke="white"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_1053_6838"
        x="0.7"
        y="0"
        width="45.6"
        height="46.3"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="5" />
        <feGaussianBlur stdDeviation="2.15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1053_6838"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1053_6838"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const homeBackgroundSVG = (
  <svg
    width="360"
    height="511"
    viewBox="0 0 360 511"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="360" height="511" fill="url(#paint0_linear_633_25937)" />
    <defs>
      <linearGradient
        id="paint0_linear_633_25937"
        x1="180"
        y1="0"
        x2="180"
        y2="511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E16432" />
        <stop offset="1" stop-color="#FCE6AB" />
      </linearGradient>
    </defs>
  </svg>
);

export const travelPartnerNameSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame" clip-path="url(#clip0_2119_1924)">
      <path
        id="Vector"
        d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
        stroke="#4D4D4D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M6 6.66797C6 7.1984 6.21071 7.70711 6.58579 8.08218C6.96086 8.45726 7.46957 8.66797 8 8.66797C8.53043 8.66797 9.03914 8.45726 9.41421 8.08218C9.78929 7.70711 10 7.1984 10 6.66797C10 6.13754 9.78929 5.62883 9.41421 5.25376C9.03914 4.87868 8.53043 4.66797 8 4.66797C7.46957 4.66797 6.96086 4.87868 6.58579 5.25376C6.21071 5.62883 6 6.13754 6 6.66797Z"
        stroke="#4D4D4D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M4.112 12.5673C4.27701 12.0181 4.61465 11.5368 5.07483 11.1946C5.53502 10.8525 6.09323 10.6678 6.66667 10.668H9.33333C9.9075 10.6678 10.4664 10.8529 10.9269 11.1958C11.3874 11.5388 11.725 12.0212 11.8893 12.5713"
        stroke="#4D4D4D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2119_1924">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const reviewTickSVG = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 37492">
      <rect
        id="Rectangle 27031"
        x="0.5"
        y="0.5"
        width="20"
        height="20"
        rx="10"
        fill="#20A200"
        stroke="#00CC21"
      />
      <path
        id="Vector 105"
        d="M5 10.7414L9.11765 13.5L15 5.5"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const reviewUnTickSVG = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 37492">
      <rect
        id="Rectangle 27031"
        x="0.5"
        y="0.5"
        width="20"
        height="20"
        rx="10"
        fill="white"
        stroke="#C8C8C8"
      />
      <path
        id="Vector 105"
        d="M5 11.7414L9.11765 14.5L15 6.5"
        stroke="#B3B3B3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const errorMessageIcon = (
  <svg
    viewBox="0 0 16 16"
    stroke=""
    role="img"
    class="r-1jfjq5a r-1enofrn r-tbmifm r-16eto9q"
  >
    <g>
      <path
        fill="rgb(220, 38, 38)"
        d="M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346627 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346627 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16ZM8 14.4C9.2658 14.4 10.5032 14.0246 11.5556 13.3214C12.6081 12.6182 13.4284 11.6186 13.9128 10.4492C14.3972 9.27973 14.524 7.9929 14.277 6.75142C14.0301 5.50995 13.4205 4.36958 12.5255 3.47452C11.6304 2.57946 10.4901 1.96992 9.24858 1.72298C8.0071 1.47603 6.72028 1.60277 5.55083 2.08717C4.38138 2.57158 3.38184 3.39188 2.6786 4.44435C1.97536 5.49683 1.6 6.7342 1.6 8C1.6 9.69739 2.27429 11.3253 3.47452 12.5255C4.67475 13.7257 6.30262 14.4 8 14.4ZM7.2 10.4H8.8V12H7.2V10.4ZM7.2 4H8.8V8.8H7.2V4Z"
        stroke=""
      ></path>
    </g>
  </svg>
);

export const closeIconSvg = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2195 22.7188C12.0789 22.8595 12 23.0503 12 23.2492C12 23.4481 12.0791 23.6389 12.2198 23.7795C12.3605 23.9201 12.5512 23.999 12.7501 23.999C12.9491 23.999 13.1398 23.9199 13.2804 23.7792L17.9108 19.1493C17.9224 19.1376 17.9362 19.1284 17.9514 19.1221C17.9666 19.1158 17.9829 19.1126 17.9993 19.1126C18.0158 19.1126 18.032 19.1158 18.0472 19.1221C18.0624 19.1284 18.0762 19.1376 18.0878 19.1493L22.7182 23.7802C22.7879 23.8499 22.8705 23.9051 22.9615 23.9428C23.0525 23.9806 23.15 24 23.2485 24C23.347 24 23.4445 23.9806 23.5355 23.943C23.6265 23.9053 23.7092 23.8501 23.7789 23.7805C23.8485 23.7108 23.9038 23.6282 23.9415 23.5372C23.9792 23.4462 23.9986 23.3487 23.9987 23.2502C23.9987 23.1517 23.9793 23.0542 23.9416 22.9632C23.904 22.8722 23.8487 22.7895 23.7791 22.7198L19.1492 18.0879C19.1375 18.0763 19.1283 18.0625 19.122 18.0473C19.1157 18.0321 19.1125 18.0159 19.1125 17.9994C19.1125 17.983 19.1157 17.9667 19.122 17.9515C19.1283 17.9363 19.1375 17.9225 19.1492 17.9109L23.7801 13.2805C23.9207 13.1397 23.9996 12.9488 23.9995 12.7498C23.9994 12.5508 23.9202 12.36 23.7794 12.2194C23.6386 12.0788 23.4476 11.9999 23.2487 12C23.0497 12.0001 22.8589 12.0793 22.7182 12.2201L18.0878 16.8496C18.0762 16.8612 18.0624 16.8704 18.0472 16.8767C18.032 16.883 18.0158 16.8863 17.9993 16.8863C17.9829 16.8863 17.9666 16.883 17.9514 16.8767C17.9362 16.8704 17.9224 16.8612 17.9108 16.8496L13.2804 12.2201C13.2108 12.1505 13.1281 12.0952 13.0371 12.0575C12.9462 12.0198 12.8486 12.0004 12.7501 12.0004C12.5512 12.0003 12.3605 12.0793 12.2198 12.2199C12.0791 12.3605 12 12.5512 12 12.7501C12 12.9491 12.0789 13.1398 12.2195 13.2805L16.8495 17.9109C16.8611 17.9225 16.8703 17.9363 16.8766 17.9515C16.8829 17.9667 16.8862 17.983 16.8862 17.9994C16.8862 18.0159 16.8829 18.0321 16.8766 18.0473C16.8703 18.0625 16.8611 18.0763 16.8495 18.0879L12.2195 22.7188Z"
      fill="black"
    />
  </svg>
);

export const speakerImageBGSVG = (
  <svg
    width="136"
    height="136"
    viewBox="0 0 106 106"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle id="Ellipse 37" cx="48" cy="48" r="48" fill="#D9D9D9" />
  </svg>
);

export const speakerNoPersonSVG = (
  <svg
    width="57"
    height="57"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="person_add_FILL1_wght400_GRAD0_opsz24 1" opacity="0.1">
      <path
        id="Vector"
        d="M21.1263 21.4974C19.1555 21.4974 17.4683 20.7957 16.0648 19.3922C14.6614 17.9887 13.9596 16.3016 13.9596 14.3307C13.9596 12.3599 14.6614 10.6727 16.0648 9.26927C17.4683 7.8658 19.1555 7.16406 21.1263 7.16406C23.0971 7.16406 24.7843 7.8658 26.1878 9.26927C27.5912 10.6727 28.293 12.3599 28.293 14.3307C28.293 16.3016 27.5912 17.9887 26.1878 19.3922C24.7843 20.7957 23.0971 21.4974 21.1263 21.4974ZM6.79297 35.8307V30.8141C6.79297 29.7988 7.05425 28.8656 7.57682 28.0146C8.09939 27.1635 8.79366 26.5141 9.65964 26.0661C11.511 25.1405 13.3923 24.4462 15.3034 23.9833C17.2145 23.5205 19.1555 23.2891 21.1263 23.2891C23.0971 23.2891 25.0381 23.5205 26.9492 23.9833C28.8603 24.4462 30.7416 25.1405 32.593 26.0661C33.4589 26.5141 34.1532 27.1635 34.6758 28.0146C35.1984 28.8656 35.4596 29.7988 35.4596 30.8141V35.8307H6.79297Z"
        fill="black"
      />
    </g>
  </svg>
);

export const editIconDetailsPage = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 7">
      <g id="Search top">
        <rect id="Rectangle 2" width="46" height="46" rx="23" fill="#F2F4FF" />
        <path
          id="Vector"
          d="M16 30H17.0981L27.7962 19.3019L26.6981 18.2038L16 28.9019V30ZM15 31V28.4808L28.1808 15.2865C28.2832 15.1952 28.3963 15.1246 28.5201 15.0747C28.6439 15.0249 28.7729 15 28.9072 15C29.0416 15 29.1717 15.0212 29.2977 15.0635C29.4236 15.1058 29.5398 15.1821 29.6462 15.2923L30.7135 16.3654C30.8237 16.4718 30.899 16.5885 30.9394 16.7156C30.9798 16.8426 31 16.9697 31 17.0967C31 17.2322 30.9772 17.3619 30.9315 17.4857C30.8858 17.6095 30.8131 17.7226 30.7135 17.825L17.5192 31H15ZM27.2375 18.7625L26.6981 18.2038L27.7962 19.3019L27.2375 18.7625Z"
          fill="black"
        />
      </g>
    </g>
  </svg>
);

export const editIconBannerImage = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="#F37032"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 7">
      <g id="Search top">
        <rect id="Rectangle 2" width="46" height="46" rx="23" fill="#F37032" />
        <path
          id="Vector"
          d="M16 30H17.0981L27.7962 19.3019L26.6981 18.2038L16 28.9019V30ZM15 31V28.4808L28.1808 15.2865C28.2832 15.1952 28.3963 15.1246 28.5201 15.0747C28.6439 15.0249 28.7729 15 28.9072 15C29.0416 15 29.1717 15.0212 29.2977 15.0635C29.4236 15.1058 29.5398 15.1821 29.6462 15.2923L30.7135 16.3654C30.8237 16.4718 30.899 16.5885 30.9394 16.7156C30.9798 16.8426 31 16.9697 31 17.0967C31 17.2322 30.9772 17.3619 30.9315 17.4857C30.8858 17.6095 30.8131 17.7226 30.7135 17.825L17.5192 31H15ZM27.2375 18.7625L26.6981 18.2038L27.7962 19.3019L27.2375 18.7625Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

export const uploadIconWhiteSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.25 11.7884V3.3884L4.78462 5.85378L3.7308 4.7692L7.99997 0.5L12.2692 4.7692L11.2153 5.85378L8.74995 3.3884V11.7884H7.25ZM2.3077 15.5C1.80257 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V10.9808H1.99997V13.6923C1.99997 13.7692 2.03202 13.8397 2.09612 13.9038C2.16024 13.9679 2.23077 14 2.3077 14H13.6922C13.7692 14 13.8397 13.9679 13.9038 13.9038C13.9679 13.8397 14 13.7692 14 13.6923V10.9808H15.5V13.6923C15.5 14.1974 15.325 14.625 14.975 14.975C14.625 15.325 14.1974 15.5 13.6922 15.5H2.3077Z"
      fill="white"
    />
  </svg>
);

export const docsUploadSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_3579_18728)">
      <path
        d="M9.33398 2V4.66667C9.33398 4.84348 9.40422 5.01305 9.52925 5.13807C9.65427 5.2631 9.82384 5.33333 10.0007 5.33333H12.6673"
        stroke="#4D4D4D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.334 14H4.66732C4.3137 14 3.97456 13.8595 3.72451 13.6095C3.47446 13.3594 3.33398 13.0203 3.33398 12.6667V3.33333C3.33398 2.97971 3.47446 2.64057 3.72451 2.39052C3.97456 2.14048 4.3137 2 4.66732 2H9.33398L12.6673 5.33333V12.6667C12.6673 13.0203 12.5268 13.3594 12.2768 13.6095C12.0267 13.8595 11.6876 14 11.334 14Z"
        stroke="#4D4D4D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3579_18728">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const filterSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame" clip-path="url(#clip0_4154_9816)">
      <path
        id="Vector"
        d="M4 4H20V6.172C19.9999 6.70239 19.7891 7.21101 19.414 7.586L15 12V19L9 21V12.5L4.52 7.572C4.18545 7.20393 4.00005 6.7244 4 6.227V4Z"
        stroke="#232323"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4154_9816">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
